// English translations
export const en = {
  // Common
  'common.noData': 'No data available',
  'common.name': 'Name',
  // Navigation
  'nav.overview': 'Overview',
  'nav.dashboard': 'Dashboard',
  'nav.analytics': 'Analytics',
  'nav.reportingDashboard': 'Reporting Dashboard',
  'nav.sales': 'Sales',
  'nav.salesOrders': 'Sales Orders',
  'nav.purchase': 'Purchase',
  'nav.purchaseOrders': 'Purchase Orders',
  'nav.purchaseReview': 'Reviewer Workspace',
  'nav.purchase.sprints': 'Sprints',
  'nav.supplierOnboarding': 'Supplier Onboarding',
  'nav.po': 'PO',
  'nav.po.sprints': 'Sprints',
  'nav.po.newSprint': 'Create Sprint',
  'nav.scout': 'Scout',
  'nav.scout.wochenplanung': 'Weekly Planning',
  'nav.scout.tagesplanung': 'Daily Planning',
  'nav.scout.prequal': 'PreQual Calling',
  'nav.scout.wiedervorlagen': 'Callbacks',
  'nav.scout.missionen': 'Missions',
  'nav.scout.meineKunden': 'My Customers',
  'nav.scout.praeferenzen': 'Preferences',
  'nav.scout.missionControl': 'Mission Control',
  'nav.scout.unternehmenssuche': 'Company Search',
  'nav.scout.preferences': 'Preferences',
  'nav.scout.hilfe': 'Help',
  'nav.scout.scorecard': 'Scorecard',
  'nav.poSprints': 'PO/Sprints',
  'nav.wiki': 'Wiki',
  'nav.supportVisualization': 'Support Visualization',
  'nav.navigationTiles': 'Navigation Tiles',
  'nav.styleGuide': 'Style Guide',
  'nav.inventory': 'Inventory',
  'nav.items': 'Items',
  'nav.warehouse': 'Warehouse',
  'nav.picking': 'Picking',
  'nav.asn': 'ASN',
  'nav.returns': 'Returns',
  'nav.payments': 'Payments',
  'nav.accounting': 'Accounting',
  'nav.accountsReceivable': 'Accounts Receivable',
  'nav.crm': 'CRM',
  'nav.leads': 'Leads',
  'nav.contacts': 'Contacts',
  'nav.ai': 'AI',
  'nav.commandCenter': 'Command Center',
  'nav.workflows': 'Workflows',
  'nav.workflowManagement': 'Workflow Management',
  'nav.projectManagement': 'Project Management',
  'nav.support': 'Support',
  'nav.tickets': 'Tickets',
  'nav.pivotTable': 'Pivot Table',
  'nav.learning': 'Learning',
  'nav.curriculumPlanning': 'Curriculum Planning',
  'nav.learnerDashboard': 'Learner Dashboard',
  'nav.accessibleLearnerDashboard': 'Accessible Learner Dashboard',
  'nav.settings': 'Settings',
  'nav.general': 'General',
  'nav.company': 'Company',
  'nav.addressManagement': 'Address Management',
  'nav.usersRoles': 'Users & Roles',
  'nav.auditLog': 'Audit Log',
  'nav.integrations': 'Integrations',
  'nav.appOverview': 'App Overview',
  'nav.appOverviewDescription': 'Click on any app to navigate, or drag tiles to reorder',
  'nav.group.operations': 'Operations',
  'nav.group.sales': 'Sales & CRM',
  'nav.group.supplyChain': 'Supply Chain',
  'nav.group.tools': 'Tools',
  'nav.group.other': 'Other',
  'header.help': 'Help',
  'header.bugReport': 'Report bug',
  'header.account': 'Account',
  'header.portalName': 'CLANDA Portal',
  'header.preferences': 'Preferences',
  'header.myProfile': 'My Profile',
  'header.language': 'Language',
  'header.appearance': 'Appearance',
  'header.lightMode': 'Light',
  'header.darkMode': 'Dark',
  'header.impersonation': 'Impersonation',
  'header.notifications.title': 'Notifications',
  'header.notifications.empty': 'No new messages',
  'header.notifications.markAllRead': 'Mark all as read',
  'header.notifications.enablePrompt': 'Enable push notifications?',
  'header.notifications.enableCta': 'Enable',

  // Help page

  // Privacy page

  // Form

  // Placeholders
  
  // Status
  
  // Actions
  'action.delete': 'Delete',
  
  // Messages
  'message.success': 'Success',
  'message.error': 'Error',
  
  // Common
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.continue': 'Continue',
  'common.reject': 'Reject',
  'common.save': 'Save',
  'common.update': 'Update',
  'common.saving': 'Saving…',
  'common.saveChanges': 'Save changes',
  'common.close': 'Close',
  'common.refresh': 'Refresh',
  'common.reset': 'Reset',
  'common.back': 'Back',
  'common.loading': 'Loading...',
  'common.search': 'Search',
  'common.search.placeholder': 'Search...',
  'common.filter': 'Filter',
  'atc.filterDrawer.title': 'Filter',
  'atc.filterDrawer.apply': 'Apply',
  'atc.filterDrawer.reset': 'Reset',
  'atc.filterDrawer.activeCount': '{count} active',
  'common.sort': 'Sort',
  'common.add': 'Add',
  'common.archive': 'Archive',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.remove': 'Remove',
  'common.verified': 'verified',
  'common.unverified': 'unverified',
  'common.minutesShort': '{{value}} min',
  'common.na': 'N/A',
  'common.days': 'days',
  'common.status.active': 'active',
  'common.status.paused': 'paused',
  'common.status.stopped': 'stopped',
  'common.status.pending': 'pending',
  'common.status.completed': 'completed',
  'common.status.planned': 'Planned',
  'common.status.inProgress': 'In Progress',
  'common.status.done': 'Done',
  'common.apply': 'Apply',
  'common.actions.filter': 'Filter',
  'common.actions.export': 'Export',
  'common.actions.search': 'Search',
  'common.dialog.defaultTitle': 'Dialog',
  'common.all': 'All',
  'common.clear': 'Clear',
  'common.total': 'Total',
  'common.pending': 'Pending',
  'common.assigned': 'Assigned',
  'common.inProgress': 'In Progress',
  'common.active': 'Active',
  'common.archived': 'Archived',
  'common.planned': 'Planned',
  'common.completed': 'Completed',
  'common.cancelled': 'Cancelled',
  'common.tryAgain': 'Please try again',
  'common.review': 'Review',
  'common.title': 'Title',
  'common.status': 'Status',
  'common.date': 'Date',
  'common.approve': 'Approve',
  'common.approved': 'Approved',
  'common.rejected': 'Rejected',
  'common.processing': 'Processing',
  'common.overdue': 'Overdue',
  'common.partial': 'Partial',
  'common.highPriority': 'High Priority',
  'common.tableView': 'Table View',
  'common.cardView': 'Card View',
  'common.switchToTable': 'Switch to table view',
  'common.switchToCard': 'Switch to card view',
  'common.openMenu': 'Open menu',
  'common.details': 'Details',
  'common.overview': 'Overview',
  'common.new': 'New',
  'common.draft': 'Draft',
  'common.shipped': 'Shipped',
  'common.delivered': 'Delivered',
  'common.received': 'Received',
  'common.inTransit': 'In Transit',
  'common.itemsPicked': 'Items Picked',
  'common.totalRefund': 'Total Refund',
  'common.totalPrice': 'Total price',
  'common.orderSummary': 'Order Summary',
  'common.subtotal': 'Subtotal:',
  'common.tax': 'Tax:',
  'common.discount': 'Discount:',
  'common.totalColon': 'Total:',

  // Date Range Filter (canonical component)
  'dateRange.today': 'Today',
  'dateRange.yesterday': 'Yesterday',
  'dateRange.last7Days': 'Last 7 days',
  'dateRange.last14Days': 'Last 14 days',
  'dateRange.last30Days': 'Last 30 days',
  'dateRange.thisMonth': 'This month',
  'dateRange.custom': 'Custom',

  // Dashboard
  'widget.vsLastPeriod': 'vs last period',
  'table.showing': 'Showing',
  'table.of': 'of',
  'table.page': 'Page',
  'table.previous': 'Previous',
  'table.next': 'Next',
  'table.filterGroups': 'Filter groups',
  'table.addFilterGroup': 'Add filter group',
  'table.filterGroup': 'Filter group',
  'table.addCondition': 'Add condition',
  'table.operator': 'Operator',
  'table.field': 'Field',
  'table.noFilterGroups': 'No filter groups.',
  'filter.operator.equals': 'equals',
  'filter.operator.not_equals': 'does not equal',
  'filter.operator.contains': 'contains',
  'filter.operator.not_contains': 'does not contain',
  'filter.operator.starts_with': 'starts with',
  'filter.operator.ends_with': 'ends with',
  'filter.operator.gt': 'greater than',
  'filter.operator.lt': 'less than',
  'filter.operator.gte': 'at least',
  'filter.operator.lte': 'at most',
  'filter.operator.between': 'between',
  'filter.operator.in': 'is one of',
  'filter.operator.not_in': 'is not one of',
  'filter.operator.is_set': 'is set',
  'filter.operator.is_not_set': 'is not set',
  'filter.placeholder.value': 'Value',
  'filter.placeholder.min': 'Min',
  'filter.placeholder.max': 'Max',
  'filter.placeholder.select': 'Select…',
  'filter.placeholder.selectMultiple': 'Select values…',
  'filter.logic.and': 'AND',
  'filter.logic.or': 'OR',

  // Documents
  
  // Validation

  // Toasts

  // Reviewer Dashboard

  // Account / Settings
  'settings.title': 'Account Settings',

  // Consent
  'consent.title': 'Consent',
  'consent.label': 'I agree to the terms and ordering policy',
  'consent.description': 'I have read and accept the terms.',
  'consent.required': 'Please agree to the terms.',
  'consent.link.terms': 'Terms',

  // Contacts
  'contacts.title': 'Contacts',
  'contacts.role': 'Role',
  'contacts.role.admin': 'Admin',
  'contacts.role.billing': 'Billing',
  'contacts.role.technical': 'Technical',
  'contacts.role.other': 'Other',

  // ARIA / Accessibility

  // Auth
  'auth.callback.title': 'Authentication',

  // Debug
  'debug.report.title': 'Bug Report',
  'debug.report.kindLabel': 'Type of report',
  'debug.report.kindBug': 'Report a bug',
  'debug.report.kindFeature': 'Suggest a feature',
  'debug.report.consentMessage': 'We will collect anonymized diagnostic data to analyze the issue.',
  'debug.report.collecting': 'Collecting data…',
  'debug.report.previewMessage': 'Please review the collected data before sending.',
  'debug.report.sentMessage': 'Bug report sent successfully.',
  'debug.report.errorMessage': 'Failed to send bug report.',
  'debug.report.sent': 'Sent',
  'debug.report.collect': 'Collect data',
  'debug.report.send': 'Send report',
  'debug.report.sending': 'Sending report…',
  'debug.report.download': 'Download bundle',
  'debug.report.screenshotLabel': 'Screenshot',
  'debug.report.screenshotErrorLabel': 'Screenshot failed',
  'debug.report.consoleLabel': 'Console',
  'debug.report.runtimeErrorsLabel': 'Runtime errors & rejected promises',
  'debug.report.diagnosticsLabel': 'Diagnostics',
  'debug.report.commentLabel': 'Short comment (optional)',
  'debug.report.commentPlaceholder': 'What were you doing when the problem happened? What did you expect to see?',
  'debug.report.refLabel': 'Your bug reference',
  'debug.report.refCopy': 'Copy',
  'debug.report.refCopied': 'Copied',
  'debug.report.refHint': 'Quote this reference when following up with support.',
  'debug.report.refCopyFailed': 'Copy was blocked by your browser — read the reference above instead.',
  // Offline / transient-failure outcome — the report was queued for automatic
  // replay on reconnect (never silently dropped).
  'debug.report.queued': 'Saved — will send when online',
  'debug.report.queuedMessage': "You're offline or the connection dropped — your report is saved on this device and sends automatically once you're back online.",
  // Feature-request mode overrides (FR-FE-BUG-TOOL-FEATURE-REQUEST-FLOW-2026-05-24).
  // tk() in DebugReport.tsx / DebugReport.bugRefPanel.tsx looks these up first
  // when kind === 'feature' and falls back to the shared `debug.report.*` keys.
  'debug.report.feature.title': 'Feature Request',
  'debug.report.feature.consentMessage': 'We will collect anonymized diagnostic context to help us understand your request.',
  'debug.report.feature.previewMessage': 'Please review the captured context before sending your request.',
  'debug.report.feature.sentMessage': 'Feature request sent successfully.',
  'debug.report.feature.errorMessage': 'Failed to send feature request.',
  'debug.report.feature.collect': 'Start request',
  'debug.report.feature.commentLabel': 'Describe your idea (optional)',
  'debug.report.feature.commentPlaceholder': 'What would you like to be able to do? What problem would it solve?',
  'debug.report.feature.refLabel': 'Your request reference',
  'debug.report.feature.refHint': 'Quote this reference when following up about your request.',
  'debug.report.feature.queuedMessage': "You're offline or the connection dropped — your request is saved on this device and sends automatically once you're back online.",
  'realtime.connectionLost.title': 'Live updates paused',
  'realtime.connectionLost.description': 'The live connection for automatic updates is interrupted. Saving is not affected; data reloads as soon as the connection is back.',
  'realtime.connectionRestored.title': 'Live updates resumed – reloading data',

  // Deliveries

  // SKU Mappings

  // PO List

  // PO Sprints

  // Terms page


  // Common UI Elements

  // Dashboard

  // AI Command Center

  // Helpdesk
  // Helpdesk (continued)

  // Scout PreQual
  'scout.dailyPlanning.reportPending': 'Report pending',

  // UI Components
  'ui.dependency.none': 'No dependencies',
  'ui.dependency.add': 'Add dependency',
  'ui.dependency.remove': 'Remove dependency',
  'ui.detailPanel.close': 'Close',
  'ui.kanban.noEntries': 'No entries',
  'ui.kanban.add': 'Add',
  'ui.pdfViewer.openNewTab': 'Open in new tab',
  'ui.viewTabs.addView': 'Add view',

  // Common UI strings (continued)
  'common.noEntries': 'No entries',
  'common.noTasks': 'No tasks',
  'common.noContent': 'No content available. Document has only metadata.',
  'common.selectFromSidebar': 'Select a document from the sidebar',
  'common.changeOrder': 'Change order',
  'common.overdue30d': 'Overdue (>30d)',
  'common.noOrders': 'No orders',
  'common.onlyUnresolved': 'Only unresolved',
  'common.unresolved': 'Unresolved',
  'common.priority': 'Priority',
  'common.assignee': 'Assignee',
  'common.due': 'Due',
  'common.noTasksWithDueDate': 'No tasks with due date',
  'common.noActivities': 'No activities.',
  'common.noDependencies': 'No dependencies',
  'common.addDependency': 'Add dependency',
  'common.removeDependency': 'Remove dependency',
  'common.addView': 'Add view',
  'common.openInNewTab': 'Open in new tab',
  'common.sidebar': 'Sidebar',

  // Rich text editor
  'editor.heading1': 'Heading 1',
  'editor.heading2': 'Heading 2',
  'editor.heading3': 'Heading 3',
  'editor.bulletList': 'Bullet list',
  'editor.undo': 'Undo (Cmd+Z)',



  // Learning & Development
  'learning.curriculum.actions.exportJson': 'Export JSON',
  'learning.curriculum.actions.exportYaml': 'Export YAML',
  'learning.curriculum.actions.import': 'Import',
  'learning.curriculum.import.ariaLabel': 'Import curriculum JSON file',
  'learning.curriculum.tabs.planning': 'Planning',
  'learning.curriculum.tabs.formats': 'Formats',
  'learning.curriculum.tabs.modules': 'Modules',
  'learning.curriculum.tabs.weekPlan': 'Week Plan',
  'learning.curriculum.tabs.statistics': 'Statistics',
  'learning.curriculum.weekPlan.title': 'Week Plan',
  'learning.curriculum.weekPlan.placeholder': 'Week planning functionality will be implemented here.',
  'learning.feed.greeting': 'Hello {{name}}!',
  'learning.feed.levelInfo': 'Level {{level}} • {{xp}} XP',
  'learning.feed.offline': 'Offline',
  'learning.feed.streakLabel': 'Day streak',
  'learning.feed.dailyGoal': 'Daily goal',
  'learning.feed.recommendedLessons': 'Recommended lessons',
  'learning.feed.priority.high': 'High',
  'learning.feed.priority.medium': 'Medium',
  'learning.feed.priority.low': 'Low',
  'learning.feed.difficulty.easy': 'Easy',
  'learning.feed.difficulty.medium': 'Medium',
  'learning.feed.difficulty.hard': 'Hard',
  'learning.feed.aiRecommendation': 'AI recommendation',
  'learning.feed.actions.start': 'Start',
  'learning.feed.actions.skip': 'Skip',
  'learning.feed.actions.reload': 'Reload',
  'learning.feed.empty.title': 'All lessons completed!',

  // Helpdesk / Tickets
  'learning.feed.empty.description': 'You finished all available lessons for today. Come back tomorrow!',
  'learning.quiz.title': 'Quiz',
  'learning.quiz.questionCounter': 'Question {{current}} of {{total}}',
  'learning.quiz.options.true': 'True',
  'learning.quiz.options.false': 'False',
  'learning.quiz.actions.next': 'Next',
  'learning.quiz.actions.finish': 'Finish',
  'learning.quiz.actions.retry': 'Try again',
  'learning.quiz.badge.xp': '{{xp}} XP',
  'learning.quiz.badge.time': '{{seconds}}s',
  'learning.quiz.result.passedTitle': 'Quiz passed!',
  'learning.quiz.result.failedTitle': 'Quiz not passed',
  'learning.quiz.result.scoreSummary': '{{correct}} of {{total}} correct',
  'learning.quiz.result.xpEarned': '+{{xp}} XP earned',
  'learning.quiz.result.answersHeading': 'Detailed answers',
  'learning.quiz.result.questionLabel': 'Question {{index}}',
  'learning.quiz.result.yourAnswer': 'Your answer',
  'learning.quiz.result.correctAnswer': 'Correct answer',
  'learning.lehrplan.tabs.planner': 'Curriculum Planner',
  'learning.lehrplan.tabs.modules': 'Module Editor',
  'learning.accessible.title': 'Learning Dashboard',
  'learning.accessible.welcome': 'Welcome back, {{name}}',
  'learning.accessible.voice.start': 'Voice',
  'learning.accessible.voice.stop': 'Stop listening',
  'learning.accessible.voice.listening': 'Listening...',
  'learning.accessible.level': 'Level',
  'learning.accessible.xpToNext': '{{value}} XP to next level',
  'learning.accessible.streak': 'Streak',
  'learning.accessible.days': '{{value}} days',
  'learning.accessible.keepItUp': 'Keep it up!',
  'learning.accessible.badges': 'Badges',
  'learning.accessible.achievementsEarned': 'Achievements earned',
  'learning.accessible.tabs.overview': 'Overview',
  'learning.accessible.tabs.lessons': 'Lessons',
  'learning.accessible.tabs.progress': 'Progress',
  'learning.accessible.tabs.achievements': 'Achievements',
  'learning.accessible.recentActivity': 'Recent Activity',
  'learning.accessible.noRecentActivity': 'No recent activity',
  'learning.accessible.start': 'Start',
  'learning.accessible.learningProgress': 'Learning Progress',
  'learning.accessible.overallProgress': 'Overall Progress',
  'learning.accessible.achievements': 'Achievements',
  'learning.accessible.startingLesson': 'Starting lesson {{id}}',
  'learning.accessible.difficulty.beginner': 'Beginner',
  'learning.accessible.difficulty.intermediate': 'Intermediate',
  'learning.accessible.difficulty.advanced': 'Advanced',
  'learning.lessonCard.difficulty.easy': 'Easy',
  'learning.lessonCard.difficulty.medium': 'Medium',
  'learning.lessonCard.difficulty.hard': 'Hard',
  'learning.lessonCard.status.completed': 'Completed',
  'learning.lessonCard.reward': 'Reward',
  'learning.lessonCard.progress': 'Progress',
  'learning.lessonCard.selectFormat': 'Choose format',
  'learning.lessonCard.prerequisites': 'Prerequisites',
  'learning.lessonCard.actions.start': 'Start',
  'learning.lessonCard.actions.repeat': 'Repeat',
  'learning.lessonCard.actions.pause': 'Pause',
  'learning.lessonCard.actions.complete': 'Complete',
  'learning.lessonCard.actions.bookmark': 'Bookmark',
  'learning.lessonCard.actions.unbookmark': 'Remove bookmark',
  'learning.lessonCard.actions.collapse': 'Collapse',
  'learning.lessonCard.actions.expand': 'Expand',
  'learning.lessonCard.goalLabel': 'Goal',
  'learning.lessonCard.formats.video': 'Watch video',
  'learning.lessonCard.formats.text': 'Read text',
  'learning.lessonCard.formats.audio': 'Listen to audio',
  'learning.lessonCard.formats.cheatSheet': 'Cheat sheet',
  'learning.lessonCard.formatUnknown': 'Unknown',

  'learning.dashboard.title': 'Learner Dashboard',
  'learning.dashboard.tabs.feed': 'Learning',
  'learning.dashboard.tabs.lessons': 'Lessons',
  'learning.dashboard.tabs.quizzes': 'Quizzes',
  'learning.dashboard.tabs.knowledge': 'Knowledge',
  'learning.dashboard.tabs.progress': 'Progress',

  // Gamification & XP Toast
  'gamification.xpToast.xpLabel': 'XP',
  'gamification.xpToast.streakProgress': 'Streak progress',
  'gamification.xpToast.streakProgressValue': '{{current}} / {{target}}',
  'gamification.xpToast.source.lesson': 'Lesson',
  'gamification.xpToast.source.quiz': 'Quiz',
  'gamification.xpToast.source.streak': 'Streak',
  'gamification.xpToast.source.badge': 'Badge',
  'gamification.xpToast.source.bonus': 'Bonus',
  'gamification.xpToast.levelUp.title': 'Level Up!',
  'gamification.xpToast.levelUp.description': 'You reached level {{level}}!',
  'gamification.xpToast.levelUp.xpEarned': '+{{xp}} XP earned',
  'gamification.xpToast.button.continue': 'Continue',
  'gamification.xpToast.streakMilestone.title': 'Streak milestone!',
  'gamification.xpToast.streakMilestone.description': '{{count}}-day streak achieved!',
  'gamification.xpToast.streakMilestone.bonus': '+{{xp}} XP bonus earned',
  'gamification.close': 'Close',

  // Knowledge Base
  'knowledgeBase.back': 'Back',
  'knowledgeBase.article.view': 'View',
  'knowledgeBase.article.views': '{{count}} views',
  'knowledgeBase.article.helpful': '{{count}} helpful',
  'knowledgeBase.article.notHelpful': '{{count}} not helpful',
  'knowledgeBase.article.byAuthor': 'By {{author}}',
  'knowledgeBase.header.title': 'Knowledge Base',
  'knowledgeBase.header.subtitle': 'Find answers to your questions',
  'knowledgeBase.actions.filter': 'Filter',
  'knowledgeBase.actions.sort': 'Sort',
  'knowledgeBase.search.placeholder': 'Search the knowledge base...',
  'knowledgeBase.tabs.all': 'All',
  'knowledgeBase.stats.popular': 'Most popular articles',
  'knowledgeBase.stats.viewsCount': '{{count}} views',
  'knowledgeBase.stats.helpful': 'Most helpful articles',
  'knowledgeBase.stats.ratingsCount': '{{count}} ratings',
  'knowledgeBase.stats.total': 'Total articles',
  'knowledgeBase.stats.totalCount': '{{count}} articles',
  'knowledgeBase.empty.title': 'No articles found',
  'knowledgeBase.empty.searching': 'Try different search terms or check the categories.',
  'knowledgeBase.empty.default': 'There are no articles available in this category yet.',
  'knowledgeBase.difficulty.beginner': 'Beginner',
  'knowledgeBase.difficulty.intermediate': 'Intermediate',
  'knowledgeBase.difficulty.advanced': 'Advanced',
  'knowledgeBase.categories.odoo-basics': 'Odoo basics',
  'knowledgeBase.categories.crm': 'CRM & Sales',
  'knowledgeBase.categories.inventory': 'Inventory & Procurement',
  'knowledgeBase.categories.accounting': 'Accounting',
  'knowledgeBase.categories.projects': 'Project management',
  'knowledgeBase.categories.troubleshooting': 'Troubleshooting',

  // Accounting

  // Curriculum Planning
  'curriculum.video': 'Video',
  'curriculum.videoDescription': 'Screen recording or practice video',
  'curriculum.cheatSheet': 'Cheat Sheet',
  'curriculum.cheatSheetDescription': 'Print-ready, QR codes',
  'curriculum.test': 'Test/Quiz',
  'curriculum.testDescription': 'Odoo survey, 10 questions, 80%',
  'curriculum.checklist': 'Checklist',
  'curriculum.checklistDescription': 'Odoo tasks, clickable',
  'curriculum.textLesson': 'Text/Lesson',
  'curriculum.textLessonDescription': 'Odoo course lesson',
  'curriculum.roleplay': 'Roleplay',
  'curriculum.roleplayDescription': 'Live with mentor/Benno',
  'curriculum.practice': 'Practice Task',
  'curriculum.practiceDescription': 'Perform with customer',

  // UI Components
  // Common Actions

  // Purchase Onboarding (wizard)

  // SCOUT - Wochenplanung
  'scout.wochenplanung.title': 'Weekly Overview',
  'scout.wochenplanung.previousWeek': 'Previous Week',
  'scout.wochenplanung.nextWeek': 'Next Week',
  'scout.wochenplanung.toast.appointmentAdded': 'Appointment added',
  'scout.wochenplanung.toast.appointmentAddedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentUpdated': 'Appointment updated',
  'scout.wochenplanung.toast.appointmentUpdatedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentDeleted': 'Appointment deleted',
  'scout.wochenplanung.toast.syncFailed': 'Sync failed',
  'scout.wochenplanung.toast.syncFailedDesc': '"{{title}}" will be synced automatically.',
  'scout.wochenplanung.toast.queueFailed': 'Could not save offline',
  'scout.wochenplanung.toast.queueFailedDesc': '"{{title}}" could not be written to the offline queue — please try again.',
  'scout.wochenplanung.toast.deleteSyncFailed': 'Deletion not synced',
  'scout.wochenplanung.toast.deleteSyncFailedDesc': '"{{title}}" will be deleted automatically.',
  'scout.wochenplanung.toast.slotUpdated': 'Slot updated',
  'scout.wochenplanung.toast.slotUpdatedDesc': 'Mission resolved or slot removed.',
  
  // Planning legend
  'scout.wochenplanung.legend.completed': 'Completed',
  'scout.wochenplanung.legend.planned': 'Planned',
  'scout.wochenplanung.legend.partial': 'Partially planned',
  'scout.wochenplanung.legend.unplanned': 'To be planned',
  'scout.wochenplanung.legend.holiday': 'Holiday/Vacation',
  
  // Missions section
  
  // Map section
  'scout.wochenplanung.dialog.deleteAppointment.title': 'Delete Appointment',
  'scout.wochenplanung.dialog.deleteAppointment.description': 'Are you sure you want to delete this appointment? This action cannot be undone.',
  'scout.wochenplanung.dialog.editAppointment.title': 'Edit Appointment',
  'scout.wochenplanung.dialog.editAppointment.description': 'Do you want to apply the changes to this appointment?',
  'scout.wochenplanung.employee': 'Employee',
  'scout.wochenplanung.selectEmployee': 'Select employee',
  'scout.wochenplanung.allEmployees': 'All employees',
  'scout.wochenplanung.error.loading': 'Error loading weekly plan',
  'scout.wochenplanung.error.retry': 'Retry',
  'scout.wochenplanung.greeting.morning': 'Good morning',
  'scout.wochenplanung.greeting.afternoon': 'Good afternoon',
  'scout.wochenplanung.greeting.evening': 'Good evening',
  'scout.wochenplanung.greeting.subtitle': 'Here is your week at a glance.',
  'scout.wochenplanung.greeting.planned': 'planned',
  'scout.wochenplanung.greeting.done': 'done',

  // Quiz
  'quiz.title': 'Product Knowledge Quiz',
  'quiz.noQuizzes': 'No quizzes available.',
  'quiz.correct': 'correct',
  'quiz.points': 'points',
  'quiz.check': 'Check',
  'quiz.next': 'Next',
  'quiz.finish': 'Results',
  'quiz.restart': 'Restart',

  // Scan Order
  'scan.title': 'Scan order form',
  'scan.capture': 'Take photo of order form',
  'scan.capture.description': 'Take a photo of the filled order form. The order will be recognized automatically.',
  'scan.customer': 'Customer',
  'scan.takePhoto': 'Take photo',
  'scan.preview': 'Scan preview',
  'scan.processing': 'Processing...',
  'scan.confidence': 'Recognition quality',
  'scan.lineItems': 'Line items',
  'scan.noItems': 'No items detected.',
  'scan.product': 'Product',
  'scan.quantity': 'Quantity',
  'scan.unit': 'Unit',
  'scan.unit.placeholder': 'pcs/L/kg',
  'scan.price': 'Unit price',
  'scan.sku': 'SKU',
  'scan.notes': 'Note',
  'scan.reject': 'Reject',
  'scan.confirm': 'Confirm',
  'scan.confirmed': 'Order confirmed',
  'scan.confirmed.description': 'The order will be transferred to Odoo.',
  'scan.queued': 'Saved – will be synced',
  'scan.queued.description': 'The order is safely saved and will be transferred to Odoo automatically once the connection is back.',
  'scan.rejected': 'Scan rejected',
  'scan.newScan': 'New scan',
  'scan.retry': 'Try again',
  'scan.error.title': 'Scan error',
  'scan.error.unknown': 'Unknown error',
  'scan.error.upload': 'Upload failed',
  'scan.error.confirm': 'Confirmation failed',
  'scan.error.reject': 'Rejection failed',

  // SCAN — WhatsApp Bestellschein review (MO-BESTELLSCHEIN-WA S-WA-03,
  // /scan/review/:scanId?token=…). Rep arrives via WA link, signed
  // token = auth, no login.
  'scan.review.title': 'Review order',
  'scan.review.error.tokenMissing': 'Link invalid — please request a new link via WhatsApp.',
  'scan.review.error.expired': 'Link expired — please request a new link via WhatsApp.',
  'scan.review.error.invalid': 'Link invalid or no longer authorized — please request a new link via WhatsApp.',
  'scan.review.error.confirmTitle': 'Confirmation failed',
  'scan.review.error.confirmFailed': 'Could not submit the confirmation. Please try again.',
  'scan.review.rejectAcknowledged': 'Order discarded — you can close this window.',

  // Scout Wochenplanung — Mission Wishes (Rep self-serve)
  'scout.wochenplanung.missionWishes.title': 'My wishes for next week',
  'scout.wochenplanung.missionWishes.loadError': 'Error loading your mission wishes.',
  'scout.wochenplanung.missionWishes.saveError': 'Your mission wishes could not be saved.',
  'scout.wochenplanung.missionWishes.noUserTitle': 'No user information',
  'scout.wochenplanung.missionWishes.noUserDescription': 'Please sign in to set your mission wishes.',
  'scout.wochenplanung.missionWishes.assignedPlzTitle': 'PLZ zones (assigned)',
  'scout.wochenplanung.missionWishes.assignedPlzEmptyTitle': 'No PLZ zones assigned',
  'scout.wochenplanung.missionWishes.assignedPlzEmptyDescription': 'Once your territory plan is set, your PLZ zones will appear here as green badges.',
  'scout.wochenplanung.missionWishes.focusPlzTitle': 'Preferred PLZ',
  'scout.wochenplanung.missionWishes.focusPlzDescription': 'Select the postal code areas where you\'d like to work next week.',
  'scout.wochenplanung.missionWishes.focusProductsTitle': 'Products',
  'scout.wochenplanung.missionWishes.focusProductsPlaceholder': 'Select products...',
  'scout.wochenplanung.missionWishes.focusProductsDescription': 'Select the products you\'d like to focus on next week.',
  'scout.wochenplanung.missionWishes.productsWeightsDescription': 'Per-product weighting — ↑ focus, = neutral, ↓ avoid. Mission generator multiplies the score.',
  'scout.wochenplanung.missionWishes.industriesWeightsDescription': 'Per-industry weighting — ↑ focus, = neutral, ↓ avoid.',
  'scout.wochenplanung.missionWishes.idUnresolvedWarning': 'PLZ data temporarily unavailable — user id still loading. Please refresh the page if this persists.',
  'scout.wochenplanung.missionWishes.focusIndustriesTitle': 'Industries',
  'scout.wochenplanung.missionWishes.focusIndustriesPlaceholder': 'Select industries...',
  'scout.wochenplanung.missionWishes.focusIndustriesDescription': 'Select the industries you\'d like to prioritize next week.',
  'scout.wochenplanung.missionWishes.managerNoteTitle': 'Manager Note',
  'scout.wochenplanung.missionWishes.managerNoteEmptyTitle': 'No manager note yet',
  'scout.wochenplanung.missionWishes.managerNoteEmptyDescription': 'Once your manager sets a focus or note, it will appear here.',
  'scout.wochenplanung.missionWishes.saving': 'Saving…',
  'scout.wochenplanung.missionWishes.save': 'Save wishes',
  'scout.wochenplanung.missionWishes.saved': 'Wishes saved',
  'scout.wochenplanung.missionWishes.savedQueued': 'Wishes saved — syncing.',
  'scout.wochenplanung.missionWishes.removePlz': 'Remove postal code',

  // SCOUT - Mission list empty state & actions
  'scout.missions.industries.placeholder': 'Select industries',
  'scout.missions.industries.search': 'Search industries...',
  'scout.missions.industries.empty': 'No industries found',
  'scout.missions.products.placeholder': 'Select product families',
  'scout.missions.products.search': 'Search product families...',
  'scout.missions.products.empty': 'No product families found',
  'scout.missionControl.tabs.team': 'Team Overview',
  'scout.missionControl.teamMembers': 'Team Members',
  'scout.missionControl.table.employee': 'Employee',
  'scout.missionControl.table.team': 'Team',
  'scout.missionControl.table.plzAreas': 'PLZ Areas',

  // SCOUT - Mission Preferences

  // SCOUT - Missionen
  'scout.missionen.bestandskunden.loadError': 'Failed to load existing customers',
  'scout.missionen.bestandskunden.empty': 'No existing customers found',
  'scout.missionen.bestandskunden.company': 'Company',
  'scout.missionen.bestandskunden.lastContact': 'Last Contact',
  'scout.missionen.bestandskunden.revenue': 'Revenue (EUR)',
  'scout.missionen.bestandskunden.products': 'Products',
  'scout.missionen.bestandskunden.singular': 'Existing customer',
  'scout.missionen.bestandskunden.plural': 'Existing customers',
  'scout.missionen.bestandskunden.selected': 'selected',
  'scout.missionen.bestandskunden.markForNextWeek': 'mark for next week',
  'scout.missionen.bestandskunden.search': 'Search existing customers...',
  'scout.missionen.bestandskunden.filteredCount': '{{filtered}} of {{total}} existing customers',
  'scout.missionen.wunschliste.industriesTitle': 'Preferred Industries',
  'scout.missionen.wunschliste.productsTitle': 'Preferred Products',
  'scout.missionen.wunschliste.plzTitle': 'Preferred Postal Code Regions',
  'scout.missionen.wunschliste.saveButton': 'Save',
  'scout.missionen.wunschliste.saved': 'Saved',
  'scout.missionen.wunschliste.savedDesc': 'Your preferences have been saved.',
  'scout.missionen.wunschliste.saveError': 'Error',
  'scout.missionen.wunschliste.saveErrorDesc': 'Preferences could not be saved.',
  'scout.missionen.wunschliste.loadError': 'Failed to load preferences',
  'scout.praeferenzen.title': 'Preferences',
  'scout.praeferenzen.subtitle': 'Preferences for future missions',
  'scout.tagesplanung.title': 'Tagesplanung',
  'scout.tagesplanung.addressUnknown': 'Address unknown',
  'scout.tagesplanung.routeMapLabel': 'Route Map',
  'scout.tagesplanung.addAppointment': 'Add appointment',
  'scout.tagesplanung.daySchedule': 'Day Schedule',
  'scout.tagesplanung.noScheduleItems': 'No appointments or VIP stops for this day',
  'scout.tagesplanung.routePlanning': 'Route Planning',
  'scout.tagesplanung.traffic': 'Traffic',
  'scout.tagesplanung.showTraffic': 'Toggle traffic overlay',
  'scout.tagesplanung.optimizeRoute': 'Optimize route',
  'scout.tagesplanung.computeRoute': 'Compute route',
  'scout.tagesplanung.optimizingRoute': 'Computing…',
  'scout.tagesplanung.routeNotComputed': 'Route not computed yet.',
  'scout.tagesplanung.missingCoords': '{{missing}} of {{total}} stops missing coordinates — notify Tower.',
  'scout.tagesplanung.reoptimizeRoute': 'Optimize route order',
  'scout.tagesplanung.routeOptimized': 'Route has been optimized',
  'scout.tagesplanung.routeOptimizeFailed': 'Could not optimize route',
  'scout.tagesplanung.error': 'Action failed',
  'scout.tagesplanung.reorderFailed': 'Could not change order',
  'scout.tagesplanung.pinFailed': 'Could not set anchor',
  'scout.tagesplanung.deferNotPossible': 'Deferral not possible',
  'scout.tagesplanung.deferMaxReached': 'Maximum number of deferrals for today reached (3/3).',
  'scout.tagesplanung.deferAlreadyDeferred': 'This lead has already been deferred today.',
  'scout.tagesplanung.dayCannotClose': 'Day cannot be closed',
  'scout.tagesplanung.outstandingReports': 'There are {{count}} outstanding visit reports. Please complete all before closing the day.',
  'scout.tagesplanung.andMore': '... and {{count}} more',
  'scout.tagesplanung.nextVisit': 'Next visit',
  'scout.tagesplanung.fillLater': 'Fill in later',
  'scout.tagesplanung.noMissions': 'No missions',
  'scout.tagesplanung.noMissionsLabel': 'Missions',
  'scout.tagesplanung.noMissionsDesc': 'No missions planned for this day. Plan missions in Weekly Planning.',
  'scout.tagesplanung.tabs.planning': 'Daily plan',
  'scout.tagesplanung.tasks.tabLabel': 'Tasks',
  'scout.tagesplanung.tasks.empty': 'No tasks',
  'scout.tagesplanung.tasks.loading': 'Loading tasks',
  'scout.tagesplanung.tasks.error': 'Could not load tasks',
  'scout.tagesplanung.tasks.filterFieldStatus': 'Status',
  'scout.tagesplanung.tasks.filterStatusTodo': 'To do',
  'scout.tagesplanung.tasks.filterStatusInProgress': 'In progress',
  'scout.tagesplanung.tasks.filterStatusDone': 'Done',
  'scout.tagesplanung.tasks.priorityLabel': 'Priority',
  'scout.tagesplanung.tasks.priorityValue': '{{value}}',
  'scout.tagesplanung.tasks.priorityUnknown': '—',
  'scout.tagesplanung.tasks.dueLabel': 'Due',
  'scout.tagesplanung.tasks.dueNone': 'No due date',
  'scout.lead.neukunde': 'New customer — niche product as door opener',
  'scout.lead.bestandskunde': 'Existing customer',
  'scout.metrics.besuche': 'Visits',
  'scout.metrics.demos': 'Demos',
  'scout.metrics.auftraege': 'Orders',
  'scout.metrics.umsatz': 'Revenue',
  'scout.metrics.demoRate': 'Demo Rate',
  'scout.composition.title': 'Mission Composition',
  'scout.composition.minBestandskunden': 'Min. Existing Customers',
  'scout.composition.minQualifiziert': 'Min. Qualified Leads',
  'scout.composition.maxKaltbesuche': 'Max. Cold Visits',

  // Scout daily planning
  'scout.dailyPlanning.addAppointment': 'Add appointment',
  'scout.dailyPlanning.appointments': 'Appointments',
  'scout.dailyPlanning.noAppointmentsPlanned': 'No appointments planned for this day',
  'scout.dailyPlanning.leadsByPriority': 'Leads (by priority)',
  'scout.dailyPlanning.noLeadsPlanned': 'No leads planned for this day',
  'scout.dailyPlanning.skipLead': 'Skip lead',
  'scout.dailyPlanning.skipLeadConfirmation': 'Do you really want to skip this lead? It will be moved to the next day.',
  'scout.dailyPlanning.skip': 'Skip',
  // P21: Pre-visit skip/remove flow
  'scout.skipFlow.title': 'Why skip?',
  'scout.skipFlow.group.address': 'Address / Location',
  'scout.skipFlow.reason.wrongLocation': 'Right company, wrong location',
  'scout.skipFlow.reason.addressNotFound': 'Company not at this address',
  'scout.skipFlow.reason.addressInvalid': 'Address does not exist',
  'scout.skipFlow.group.businessGone': 'Business no longer exists',
  'scout.skipFlow.reason.businessClosed': 'Closed',
  'scout.skipFlow.reason.businessDissolved': 'Company dissolved / insolvent',
  'scout.skipFlow.group.known': 'Already known',
  'scout.skipFlow.reason.existingCustomer': 'Existing customer (already our client)',
  'scout.skipFlow.reason.recentlyVisited': 'Recently visited (by me or colleague)',
  'scout.skipFlow.reason.duplicate': 'Duplicate (same company as another lead)',
  'scout.skipFlow.group.timing': 'Appointment / Timing',
  'scout.skipFlow.reason.appointmentRejected': 'Appointment rejected (by phone)',
  'scout.skipFlow.reason.visitLater': 'Visit later',
  'scout.skipFlow.reason.dmNotAvailable': 'Decision maker currently unavailable',
  'scout.skipFlow.reason.outOfTerritory': 'Outside my territory',
  'scout.skipFlow.reason.other': 'Other',
  'scout.skipFlow.timeframeTitle': 'When to revisit?',
  'scout.skipFlow.timeframe.nextWeek': 'Next week',
  'scout.skipFlow.timeframe.in2Weeks': 'In 2 weeks',
  'scout.skipFlow.timeframe.in1Month': 'In 1 month',
  'scout.skipFlow.timeframe.in3Months': 'In 3 months',
  'scout.skipFlow.freeTextTitle': 'What is the reason?',
  'scout.skipFlow.freeTextPlaceholder': 'Describe the reason...',
  'scout.skipFlow.next': 'Next',
  'scout.skipFlow.confirmTitle': 'Summary',
  'scout.skipFlow.confirmCategory': 'Category',
  'scout.skipFlow.confirmReason': 'Reason',
  'scout.skipFlow.confirmTimeframe': 'Revisit',
  'scout.skipFlow.confirmNote': 'Note',
  'scout.skipFlow.submitButton': 'Skip lead',
  'scout.skipFlow.submitted': 'Lead skipped',
  'scout.skipFlow.error': 'Could not skip lead',
  'scout.dailyPlanning.removeLead': 'Remove lead',
  'scout.dailyPlanning.removeLeadConfirmation': 'Do you really want to remove this lead? It will be completely removed from rotation.',
  'scout.dailyPlanning.selectMissionToViewLeads': 'Select a mission to view leads',
  'scout.dailyPlanning.noMissionForDay': 'No mission for this day',
  'scout.dailyPlanning.selectDate': 'Select date',
  'scout.dailyPlanning.nextDay': 'Next day',
  'scout.dailyPlanning.closeDay': 'Close day',
  'scout.dailyPlanning.startHomeReturn': 'Return home',
  'scout.dailyPlanning.homeReturnActive': 'Returning home',
  'scout.dailyPlanning.reopenDay': 'Reopen day',
  'scout.dailyPlanning.noAcceptedLeads': 'No accepted leads for this day.',
  'scout.dailyPlanning.statusSkipped': 'Skipped',
  'scout.dailyPlanning.selectAll': 'Select all',
  'scout.dailyPlanning.selectAllLeads': 'Select all leads',
  'scout.dailyPlanning.noSuggestions': 'No suggestions.',
  'scout.dailyPlanning.previousDay': 'Previous day',
  'scout.dailyPlanning.calendarWeek': 'Calendar week {{weekNumber}}',
  'scout.dailyPlanning.visit': 'Visit',
  'scout.dailyPlanning.details': 'Details',
  'scout.dailyPlanning.missionsLoading': 'Loading missions…',
  'scout.dailyPlanning.leadsLoading': 'Loading leads…',
  'scout.dailyPlanning.noLeadsFound': 'No leads found',
  'scout.dailyPlanning.moreLeads': 'more',
  'scout.dailyPlanning.dailyList': 'Daily List',
  'scout.dailyPlanning.unknown': 'Unknown',
  'scout.dailyPlanning.suggestedLeads': 'Suggested Leads',
  'scout.dailyPlanning.error': 'Error: {{error}}',
  'scout.dailyPlanning.help': 'Help',
  'scout.dailyPlanning.bulkActions': 'Bulk actions',
  'scout.dailyPlanning.actionsCount': 'Actions ({{count}})',
  'scout.dailyPlanning.accept': 'Accept',
  'scout.dailyPlanning.reject': 'Reject',
  'scout.dailyPlanning.selectLead': 'Select lead {{name}}',
  'scout.dailyPlanning.openLeadDetails': 'Open details for {{name}}',
  'scout.dailyPlanning.score': 'Score: {{score}}',
  'scout.dailyPlanning.loading': 'Loading daily planning',
  // Scout weekly planning
  // Scout scorecard
  'scout.scorecard.selectHeatmapMetric': 'Select heatmap metric',
  'scout.scorecard.orders': 'Orders',
  'scout.scorecard.annualTargetOrders': 'Annual target orders',
  'scout.scorecard.comingSoon': 'Coming soon',
  'scout.scorecard.kpiOverview': 'KPI overview, activities and top industries',
  'scout.scorecard.activityByDay': 'Activity by day',
  'scout.scorecard.title': 'Scorecard',
  'scout.scorecard.period.tag': 'Day',
  'scout.scorecard.period.woche': 'Week',
  'scout.scorecard.period.monat': 'Month',
  'scout.scorecard.period.jahr': 'Year',
  'scout.scorecard.kpiTilesHeading': 'KPI tiles',
  'scout.scorecard.topBranchenProdukteHeading': 'Top industries and top products',
  'scout.scorecard.soll': 'Target',
  'scout.scorecard.forecast': 'Forecast',
  'scout.scorecard.gapToGo': 'Gap-to-Go',
  'scout.scorecard.csvExport': 'CSV Export',
  'scout.scorecard.pdfExport': 'PDF Export',
  'scout.scorecard.table.date': 'Date',
  'scout.scorecard.table.visits': 'Visits',
  'scout.scorecard.table.demos': 'Demos',
  'scout.scorecard.table.orders': 'Orders',
  'scout.scorecard.table.60l': '60L',
  'scout.scorecard.table.25l': '25L',
  'scout.scorecard.table.10l': '10L',
  'scout.scorecard.table.netRevenue': 'Net revenue',
  'scout.scorecard.table.total': 'Total',
  'scout.scorecard.topBranchen': 'Top industries',
  'scout.scorecard.topProdukte': 'Top products',
  'scout.scorecard.table.industry': 'Industry',
  'scout.scorecard.table.quantity': 'Quantity (units)',
  'scout.scorecard.table.revenue': 'Revenue (€)',
  'scout.scorecard.table.product': 'Product',
  'scout.scorecard.table.salesVolume': 'Sales volume',
  'scout.scorecard.table.customers': 'Customers',
  'scout.scorecard.kpi.visits': 'Visits',
  'scout.scorecard.kpi.demos': 'Demos',
  'scout.scorecard.kpi.orders': 'Orders',
  'scout.scorecard.kpi.netRevenue': 'Net revenue',
  'scout.scorecard.kpi.gebinde60l': '60L units',
  'scout.scorecard.kpi.gebinde25l': '25L units',
  'scout.scorecard.kpi.gebinde10l': '10L units',
  'scout.scorecard.emptyTitle': 'No data',
  'scout.scorecard.emptyDescription': 'No KPI data available for the selected period.',
  'scout.scorecard.missionPerformanceTitle': 'Mission Performance',
  'scout.scorecard.missionMissionsCompleted': 'Missions completed',
  'scout.scorecard.missionConversionRate': 'Conversion rate',
  'scout.scorecard.missionTerritoryCoverage': 'Territory coverage',
  'scout.scorecard.viewMissionDetails': 'View Details',
  'scout.scorecard.adjustTargets': 'Adjust targets',
  'scout.scorecard.annualTarget': 'Annual target',
  'scout.scorecard.annualTargetVisits': 'Annual target visits',
  'scout.scorecard.annualTargetDemos': 'Annual target demos',
  'scout.scorecard.annualTargetNetRevenue': 'Net revenue (€)',
  'scout.scorecard.annualTargetNetRevenueA11y': 'Annual target net revenue in EUR',
  'scout.scorecard.monthlyOverrides': 'Monthly overrides',
  'scout.scorecard.table.month': 'Month',
  'scout.scorecard.table.reason': 'Reason',
  'scout.scorecard.derivedTargets': 'Derived targets',
  'scout.scorecard.dailyTargetLabel': 'Daily target: {{count}} visits',
  'scout.scorecard.weeklyTargetLabel': 'Weekly target: {{count}} visits',
  'scout.scorecard.save': 'Save',
  'scout.scorecard.heatmap.visits': 'Visits',
  'scout.scorecard.heatmap.demos': 'Demos',
  'scout.scorecard.heatmap.revenue': 'Revenue',
  'scout.scorecard.heatmap.low': 'Low',
  'scout.scorecard.heatmap.high': 'High',
  'scout.scorecard.heatmap.scaleA11y': 'Color scale from low to high',
  'scout.scorecard.heatmap.loading': 'Loading map…',
  // Scout mission control
  'scout.missionControl.teamOverview': 'Your team and their PLZ areas',
  'scout.missionControl.jokerLimitPerDay': 'Joker limit / day',
  'scout.missionControl.jokerLimitUpdated': 'Joker limit has been updated.',
  'scout.missionControl.jokerLimitSaveFailed': 'Failed to save joker limit.',
  'scout.missionControl.selectTeam': 'Select team',
  'scout.missionControl.allTeams': 'All teams',
  'scout.missionControl.missionParameters': 'Mission parameters',
  'scout.missionControl.minLeads': 'Min leads per mission',
  'scout.missionControl.maxLeads': 'Max leads per mission',
  'scout.missionControl.maxKilometer': 'Max kilometers',
  'scout.missionControl.missionsPerDay': 'Missions per day',
  'scout.missionControl.dailyKpiGoals': 'Daily KPI goals',
  'scout.missionControl.visits': 'Visits',
  'scout.missionControl.demos': 'Demos',
  'scout.missionControl.revenueEur': 'Revenue EUR',
  'scout.missionControl.none': 'None',
  'scout.missionControl.addPlzAreaFor': 'Add PLZ area for',
  'scout.missionControl.addPlzArea': 'Add PLZ area',
  'scout.missionControl.noTeamMembersFound': 'No team members found.',
  'scout.missionControl.orders': 'Orders',
  'scout.missionControl.resetSettings': 'Reset settings',
  'scout.missionControl.saveSettings': 'Save settings',
  'scout.missionControl.territorySaturation': 'Territory saturation (PLZ)',
  'scout.missionControl.day': 'Day',
  'scout.missionControl.selectDay': 'Select day',
  'scout.missionControl.week': 'Week',
  'scout.missionControl.selectWeek': 'Select week',
  'scout.missionControl.month': 'Month',
  'scout.missionControl.selectMonth': 'Select month',
  'scout.missionControl.planFulfillment': 'Plan fulfillment',
  'scout.missionControl.plzPrefixPlaceholder': 'PLZ prefix (e.g. 70)',
  'scout.missionControl.plzPrefix': 'PLZ prefix',
  'scout.missionControl.addPlzToWhitelist': 'Add PLZ prefix to whitelist',
  'scout.missionControl.addPlzToGreylist': 'Add PLZ prefix to grey list',
  'scout.missionControl.addPlzToYellowlist': 'Add PLZ prefix to yellow list',
  'scout.missionControl.addNewTeamMember': 'Add new team member',
  'scout.missionControl.lastModified': 'Last modified',
  'scout.missionControl.diagnostics.team': 'Team',
  'scout.missionControl.diagnostics.target': 'Target',
  'scout.missionControl.diagnostics.visitsToConversion': 'visits to conversion',
  'scout.missionControl.diagnostics.systemVsManual': 'System vs. Manual',
  'scout.missionControl.diagnostics.conversionSystemRoute': 'conversion with system route',
  'scout.missionControl.diagnostics.repeatVisits': 'Repeat visits',
  'scout.missionControl.diagnostics.company': 'Company',
  'scout.missionControl.diagnostics.visitsCount': 'Visits',
  'scout.missionControl.diagnostics.lastVisit': 'Last visit',
  'scout.missionControl.diagnostics.status': 'Status',
  'scout.missionControl.territory.enterName': 'Enter name',
  'scout.missionControl.territory.memberName': 'Team member name',
  'scout.missionControl.territory.corePlz': 'Core postal code',
  'scout.missionControl.territory.plzExample': 'e.g. 10115',
  'scout.missionControl.territory.assignedPlz': 'Assigned postal codes',
  'scout.missionControl.territory.plzRangeExample': 'e.g. 10115-10178',
  'scout.missionControl.territory.teamMember': 'Team member',
  'scout.missionControl.territory.plzArea': 'Postal code area',
  'scout.missionControl.territory.assignedAt': 'Assigned at',
  'scout.missionControl.territory.approval': 'Approval',
  'scout.missionControl.territory.actions': 'Actions',
  'scout.missionControl.territory.editCorePlz': 'Edit core postal code',
  'scout.missionControl.outsideAreaRules': 'Outside area rules',
  'scout.missionControl.outsidePlzPolicy': 'Policy for PLZ outside lists',
  'scout.missionControl.enableOutsideWarning': 'Enable warning for PLZ outside area',
  'scout.missionControl.requireOutsideApproval': 'Require approval for PLZ outside area',
  'scout.missionControl.rejectOutsidePlz': 'Reject PLZ outside area',
  'scout.missionControl.checkPlz': 'Check PLZ or PLZ prefix',
  'scout.missionControl.check': 'Check',
  'scout.missionControl.error': 'Error',
  'scout.missionControl.success': 'Success',
  'scout.missionControl.userProfileNotFound': 'User profile not found',
  'scout.missionControl.plzAreasUpdated': 'PLZ areas updated',
  'scout.missionControl.plzAreasSaveFailed': 'PLZ areas could not be saved',

  // Mission Control → Config → KPI Target Configuration (MC-004)

  // Scout Mission Control — Rep Config (T13)
  'scout.missionControl.repConfig.title': 'Rep Configuration',
  'scout.missionControl.repConfig.repName': 'Name / Email',
  'scout.missionControl.repConfig.industries': 'Industries',
  'scout.missionControl.repConfig.products': 'Products',
  'scout.missionControl.repConfig.plz': 'PLZ',
  'scout.missionControl.repConfig.loadError': 'Failed to load rep configuration',
  'scout.missionControl.repConfig.saveError': 'Save failed',
  'scout.missionControl.repConfig.savedTitle': 'Saved',
  'scout.missionControl.repConfig.savedDesc': 'Rep configuration updated',

  // Scout Mission Control — Joker Limit (T16)
  'scout.missionControl.jokerConfig.title': 'Joker Limit Per Day',
  'scout.missionControl.jokerConfig.description': 'Maximum number of joker uses per rep per day.',
  'scout.missionControl.jokerConfig.maxPerDay': 'Max per day',
  'scout.missionControl.jokerConfig.loadError': 'Failed to load joker configuration',
  'scout.missionControl.jokerConfig.saveError': 'Save failed',
  'scout.missionControl.jokerConfig.savedTitle': 'Saved',
  'scout.missionControl.jokerConfig.savedDesc': 'Joker limit updated',

  // Scout Mission Control — live dashboard
  'scout.missionControl.live.reconnecting': 'Reconnecting...',
  'scout.missionControl.live.teamToday': 'Team today',
  'scout.missionControl.live.employee': 'Employee',
  'scout.missionControl.live.visits': 'Visits',
  'scout.missionControl.live.demos': 'Demos',
  'scout.missionControl.live.sales': 'Sales',
  'scout.missionControl.live.sale': 'Sale',
  'scout.missionControl.live.revenue': 'Revenue',
  'scout.missionControl.live.lastActivity': 'Last activity',
  'scout.missionControl.live.justNow': 'Just now',
  'scout.missionControl.live.secondsAgo': '{{seconds}} sec ago',
  'scout.missionControl.live.minutesAgo': '{{minutes}} min ago',
  'scout.missionControl.live.hoursAgo': '{{hours}} hr ago',
  'scout.missionControl.live.notOnScout': 'Not on scout',
  'scout.missionControl.live.noTeamMembers': 'No team members',
  'scout.missionControl.live.noTeamMembersDesc': 'No field sales representatives found.',
  'scout.missionControl.live.noReportsThisWeek': 'No visits in the selected week',
  'scout.missionControl.live.noReportsThisWeekHint': 'No visits were recorded this week for the reps shown. Visits are matched by email address.',
  'scout.missionControl.live.unmatchedVisits': '{{count}} visits this week are not attributed to any rep shown (email not in team).',
  'scout.missionControl.live.notAvailableHint': 'Not captured by the current visit report.',
  'scout.missionControl.reps.loadError': 'Failed to load field-sales roster',
  'scout.missionControl.live.weekLabel': 'CW {{week}}',
  'scout.missionControl.live.rep': 'Rep',
  'scout.missionControl.live.totalVisits': 'Σ Visits',
  'scout.missionControl.live.totalSales': 'Σ Sales',
  'scout.missionControl.live.recentActivities': 'Recent Activities',
  'scout.missionControl.live.activity.sale': 'Sale at',
  'scout.missionControl.live.activity.demo': 'Demo at',
  'scout.missionControl.live.activity.noAccess': 'No access at',
  'scout.missionControl.live.activity.noDecisionMaker': 'No decision maker at',
  'scout.missionControl.live.activity.conversation': 'Conversation at',
  'scout.missionControl.live.activity.rejected': 'Rejected at',
  'scout.missionControl.live.activity.visit': 'Visit at',
  // Mission Control funnel + reasons + visit-report popup (hotfix 2026-10-27)
  'scout.missionControl.live.unknownCompany': 'Unknown',
  'scout.missionControl.live.entered': 'Entry',
  'scout.missionControl.live.apReached': 'Contact reached',
  'scout.missionControl.live.apReachedShort': 'contact reached',
  'scout.missionControl.live.demoRate': 'Demo rate',
  'scout.missionControl.live.demoRateHint': 'Demos ÷ contact reached. "–" when no contact was reached.',
  'scout.missionControl.live.revenueNotAvailableHint': 'No revenue amount in CORE – the order value is not transmitted.',
  'scout.missionControl.live.totalDemos': 'Σ Demos',
  'scout.missionControl.live.unreportedVisits': '{{count}} visits today without a visit report – entry, contact and demo not recorded there.',
  'scout.missionControl.live.ambiguousReports': 'Data error: {{count}} visits cannot be matched to exactly one visit report and are not counted in the funnel.',
  'scout.missionControl.live.reasons.title': 'Reasons today',
  'scout.missionControl.live.reasons.none': 'No reasons recorded',
  'scout.missionControl.live.reasons.noEntry': 'No entry',
  'scout.missionControl.live.reasons.noAp': 'Contact not reached',
  'scout.missionControl.live.reasons.noSale': 'No sale',
  'scout.missionControl.live.reasons.precheckable': 'checkable upfront',
  'scout.missionControl.live.reasons.precheckableHint': 'Could have been checked before the visit (lead data).',
  'scout.missionControl.live.reason.noEntry.firma_geschlossen_dauerhaft': 'Company permanently closed',
  'scout.missionControl.live.reason.noEntry.falsche_oeffnungszeiten': 'Wrong opening hours',
  'scout.missionControl.live.reason.noEntry.kein_zutritt': 'No entry',
  'scout.missionControl.live.reason.noEntry.falsche_firma_adresse': 'Wrong company / address',
  'scout.missionControl.live.reason.noEntry.nicht_icp': 'Not a target customer',
  'scout.missionControl.live.reason.noEntry.sonstiges': 'Other',
  'scout.missionControl.live.reason.noAp.ap_nicht_da': 'Contact not present',
  'scout.missionControl.live.reason.noAp.abgewimmelt': 'Turned away',
  'scout.missionControl.live.reason.noAp.kein_termin': 'No appointment',
  'scout.missionControl.live.reason.noAp.folgetermin': 'Follow-up appointment',
  'scout.missionControl.live.reason.noAp.sonstiges': 'Other',
  'scout.missionControl.live.reason.noSale.kein_bedarf': 'No current need',
  'scout.missionControl.live.reason.noSale.bestandslieferant': 'Has a supplier',
  'scout.missionControl.live.reason.noSale.preis_budget': 'Price / budget',
  'scout.missionControl.live.reason.noSale.bedenkzeit': 'Wants to think it over',
  'scout.missionControl.live.reason.noSale.kein_interesse': 'No interest',
  'scout.missionControl.live.reason.noSale.sonstiges': 'Other reason',
  'scout.missionControl.live.report.open': 'Open visit report',
  'scout.missionControl.live.report.title': 'Visit report',
  'scout.missionControl.live.report.notRecorded': 'not recorded',
  'scout.missionControl.live.report.missing': 'There is no visit report for this visit.',
  'scout.missionControl.live.report.ambiguous': 'Data error: {{count}} visit reports match this visit – none is shown.',
  'scout.missionControl.live.report.yes': 'Yes',
  'scout.missionControl.live.report.no': 'No',
  'scout.missionControl.live.report.litersPerYear': '{{product}}: {{liters}} l/year',
  'scout.missionControl.live.report.field.stopType': 'Visit type',
  'scout.missionControl.live.report.field.erstbesuch': 'First visit',
  'scout.missionControl.live.report.field.kundeStatus': 'Customer status',
  'scout.missionControl.live.report.field.leadValid': 'Lead valid',
  'scout.missionControl.live.report.field.leadInvalidReason': 'Reason lead invalid',
  'scout.missionControl.live.report.field.entered': 'Entry',
  'scout.missionControl.live.report.field.noEntryReason': 'Reason no entry',
  'scout.missionControl.live.report.field.gatekeeper': 'Reception / gatekeeper',
  'scout.missionControl.live.report.field.apReached': 'Contact reached',
  'scout.missionControl.live.report.field.noApReason': 'Reason contact not reached',
  'scout.missionControl.live.report.field.demoDone': 'Demo done',
  'scout.missionControl.live.report.field.sold': 'Sale',
  'scout.missionControl.live.report.field.noSaleReason': 'Reason no sale',
  'scout.missionControl.live.report.field.zeichnungsberechtigt': 'Authorised signatory',
  'scout.missionControl.live.report.field.zeichnungsberechtigtInfo': 'Signatory info',
  'scout.missionControl.live.report.field.objectsConfirmed': 'Objects confirmed',
  'scout.missionControl.live.report.field.relevanteProdukte': 'Relevant products',
  'scout.missionControl.live.report.field.jahresbedarf': 'Annual demand',
  'scout.missionControl.live.report.field.wettbewerb': 'Competition',
  'scout.missionControl.live.report.field.nextAction': 'Next step',
  'scout.missionControl.live.report.field.nextWhen': 'When',
  'scout.missionControl.live.report.field.notizen': 'Notes',
  'scout.missionControl.live.report.enum.stop_type.planned': 'Planned',
  'scout.missionControl.live.report.enum.stop_type.joker': 'Joker',
  'scout.missionControl.live.report.enum.kunde_status.neukunde': 'New customer',
  'scout.missionControl.live.report.enum.kunde_status.bestand': 'Existing customer',
  'scout.missionControl.live.report.enum.gatekeeper_passed.durch': 'Got through',
  'scout.missionControl.live.report.enum.gatekeeper_passed.blockiert': 'Blocked',
  'scout.missionControl.live.report.enum.gatekeeper_passed.keiner': 'No gatekeeper',
  'scout.missionControl.live.report.enum.lead_invalid_reason.privathaus_kein_fit': 'Private house – not a customer for us',
  'scout.missionControl.live.report.enum.lead_invalid_reason.dauerhaft_geschlossen': 'Company permanently closed',
  'scout.missionControl.live.report.enum.lead_invalid_reason.falsche_firma_adresse': 'Wrong company / address',
  'scout.missionControl.live.report.enum.lead_invalid_reason.nicht_icp': 'Not a target customer (industry / profile)',
  'scout.missionControl.live.report.enum.zeichnungsberechtigt_wer.ansprechpartner_selbst': 'Contact themself',
  'scout.missionControl.live.report.enum.zeichnungsberechtigt_wer.geschaeftsfuehrung': 'Management',
  'scout.missionControl.live.report.enum.zeichnungsberechtigt_wer.einkauf': 'Purchasing',
  'scout.missionControl.live.report.enum.zeichnungsberechtigt_wer.gremium': 'Committee',
  'scout.missionControl.live.report.enum.zeichnungsberechtigt_wer.unbekannt': 'Unknown',
  'scout.missionControl.live.report.enum.next_action.folgetermin': 'Follow-up appointment',
  'scout.missionControl.live.report.enum.next_action.angebot': 'Quote',
  'scout.missionControl.live.report.enum.next_action.muster': 'Sample',
  'scout.missionControl.live.report.enum.next_action.rueckruf': 'Call back',
  'scout.missionControl.live.report.enum.next_action.wiedervorlage': 'Resubmission',
  'scout.missionControl.live.report.enum.next_action.nichts': 'Nothing',
  'scout.missionControl.live.report.enum.next_when_kind.datum': 'Date',
  'scout.missionControl.live.report.enum.next_when_kind.kw': 'Calendar week',
  'scout.missionControl.live.report.enum.next_when_kind.monat': 'Month',
  'scout.missionControl.live.report.enum.next_when_kind.zeitraum': 'Period',
  'scout.missionControl.live.report.enum.next_when_kind.offen': 'Open',
  'scout.missionControl.live.result.demo': 'Demo',
  'scout.missionControl.live.result.conversation': 'Conversation',
  'scout.missionControl.live.result.unreported': 'No report',
  'scout.missionControl.live.result.ambiguous': 'Data error',
  'scout.missionControl.live.feed.team': 'Team',
  'scout.missionControl.live.feed.filterLabel': 'Filter activities by employee',
  'scout.missionControl.live.feed.count': '{{count}} visits today',
  'scout.missionControl.live.feed.empty': 'No visits recorded today yet.',
  'scout.missionControl.live.feed.openDay': 'Day timeline & route',
  'scout.missionControl.live.day.open': 'Open day timeline of {{name}}',
  'scout.missionControl.live.day.title': '{{name}} · Day timeline',
  'scout.missionControl.live.day.description': 'Today, {{date}}',
  'scout.missionControl.live.day.dataNote': 'Visit duration and driven distance are not recorded. "Gap" = time since the previous visit, "straight line" = direct line between the company addresses.',
  'scout.missionControl.live.day.map': 'Planned route & visits',
  'scout.missionControl.live.day.mapShow': 'Show map',
  'scout.missionControl.live.day.mapHide': 'Hide map',
  'scout.missionControl.live.day.mapLegend': 'Line = planned route from route planning · numbers = actual visits in chronological order.',
  'scout.missionControl.live.day.mapNoGeometry': 'No visits with coordinates and no planned route – map not available.',
  'scout.missionControl.live.day.mapMissingStops': '{{count}} of {{total}} visits without coordinates – not on the map.',
  'scout.missionControl.live.day.routeLoading': 'Loading planned route…',
  'scout.missionControl.live.day.routeNone': 'No route planned for today.',
  'scout.missionControl.live.day.routeNotComputed': '{{count}} planned route(s) without a computed route.',
  'scout.missionControl.live.day.routeError': 'Planned route could not be loaded: {{error}}',
  'scout.missionControl.live.day.coordsError': 'Company coordinates could not be loaded – no straight-line distance: {{error}}',
  'scout.missionControl.live.day.noVisits': 'No visits recorded today yet.',
  'scout.missionControl.live.day.summary.planned': 'Planned: {{km}} · {{time}} h ({{count}} route(s))',
  'scout.missionControl.live.day.summary.plannedNone': 'Planned: not recorded',
  'scout.missionControl.live.day.summary.straightLine': 'Straight line total: {{km}} ({{legs}} of {{total}} legs)',
  'scout.missionControl.live.day.timeMissing': 'Time not recorded',
  'scout.missionControl.live.day.gap': 'Gap {{time}}',
  'scout.missionControl.live.day.gapHint': 'Time since the previous visit – not a visit or drive duration (not recorded).',
  'scout.missionControl.live.day.distance.first': 'First visit',
  'scout.missionControl.live.day.distance.km': 'Straight line {{km}}',
  'scout.missionControl.live.day.distance.kmHint': 'Direct line between the company addresses – not a driven distance.',
  'scout.missionControl.live.day.distance.loading': 'Loading straight-line distance…',
  'scout.missionControl.live.day.distance.error': 'Straight-line distance not available',
  'scout.missionControl.live.day.distance.unavailable': 'No straight-line distance: {{reason}}',
  'scout.missionControl.live.day.distance.unavailablePrevious': 'No straight-line distance: previous visit – {{reason}}',
  'scout.missionControl.live.day.distance.reason.repDiscovered': 'company discovered on site, no coordinates in the system',
  'scout.missionControl.live.day.distance.reason.unknownRef': 'company cannot be resolved',
  'scout.missionControl.live.day.distance.reason.companyNotFound': 'company not found',
  'scout.missionControl.live.day.distance.reason.noCoordinates': 'company without coordinates',

  // Scout session (NAV-005)

  // Scout Mission Control — territories (MC-001, MC-002)

  // Scout Mission Control — diagnostics (MC-006)
  'scout.missionControl.diagnostics.demoRate': 'Demo Rate',
  'scout.missionControl.diagnostics.visitDepth': 'Visit Depth',

  // Scout Mission Control — Team Steering
  'scout.missionControl.tabs.teamSteering': 'Team Steering',
  'scout.missionControl.teamSteering.noAccessTitle': 'No Access',
  'scout.missionControl.teamSteering.noAccessDesc': 'You do not have permission to view team steering.',
  'scout.missionControl.teamSteering.globalTitle': 'Targets',
  'scout.missionControl.teamSteering.globalNotes': 'Notes',
  'scout.missionControl.teamSteering.hide': 'Hide',
  'scout.missionControl.teamSteering.show': 'Show',
  'scout.missionControl.teamSteering.productFocus': 'Product Focus',
  'scout.missionControl.teamSteering.industries': 'Industries',
  'scout.missionControl.teamSteering.jokerDefault': 'Default Joker Limit',
  'scout.missionControl.teamSteering.territorySummaryTitle': 'Territory Summary',
  'scout.missionControl.teamSteering.territorySummary': '{{green}} green and {{grey}} grey PLZ zones assigned.',
  'scout.missionControl.teamSteering.perRepTitle': 'Per Employee',
  'scout.missionControl.teamSteering.perRepTable': 'Employee steering table',
  'scout.missionControl.teamSteering.loading': 'Loading data…',
  'scout.missionControl.teamSteering.noRepsTitle': 'No Employees',
  'scout.missionControl.teamSteering.noRepsDesc': 'No team members were found.',
  'scout.missionControl.teamSteering.plzGreen': 'PLZ (green)',
  'scout.missionControl.teamSteering.plzGrey': 'PLZ (grey)',
  'scout.missionControl.teamSteering.productWish': 'Products (wish)',
  'scout.missionControl.teamSteering.jokersPerDay': 'Jokers / Day',
  'scout.missionControl.teamSteering.visitTarget': 'Visit Target',
  'scout.missionControl.teamSteering.plzUpdated': 'PLZ zone was updated.',
  'scout.missionControl.teamSteering.plzUpdateError': 'PLZ zone could not be updated.',
  'scout.missionControl.teamSteering.plzDeleted': 'PLZ zone was removed.',
  'scout.missionControl.teamSteering.plzDeleteError': 'PLZ zone could not be removed.',
  'scout.missionControl.teamSteering.jokerUpdateError': 'Joker limit could not be saved.',
  'scout.missionControl.teamSteering.visitTargetUpdateError': 'Visit target could not be saved.',
  'scout.missionControl.teamSteering.removePlz': 'Remove PLZ',
  'scout.missionControl.teamSteering.saveGlobal': 'Save Targets',
  'scout.missionControl.teamSteering.globalSaved': 'Targets saved.',
  'scout.missionControl.teamSteering.globalSaveError': 'Failed to save targets.',
  'scout.missionControl.teamSteering.demoTarget': 'Demo Target',
  'scout.missionControl.teamSteering.revenueTarget': 'Revenue Target (EUR)',
  'scout.missionControl.teamSteering.demoTargetUpdateError': 'Demo target could not be saved.',
  'scout.missionControl.teamSteering.revenueTargetUpdateError': 'Revenue target could not be saved.',
  'scout.missionControl.teamSteering.plzOutsideTerritory': 'PLZ outside contractual territory',
  'scout.missionControl.teamSteering.plzOutsideTerritoryDesc': 'PLZ was automatically classified as grey zone and requires manager approval.',
  'scout.missionControl.teamSteering.vorgabenTitle': 'Title',
  'scout.missionControl.teamSteering.vorgabenTitlePlaceholder': 'e.g. Spring Campaign 2026',
  'scout.missionControl.teamSteering.missionConfigTitle': 'Mission config per rep',
  'scout.missionControl.teamSteering.missionConfigTable': 'Mission config table',
  'scout.missionControl.teamSteering.missionConfigSaved': 'Mission config saved.',
  'scout.missionControl.teamSteering.missionConfigSaveError': 'Failed to save mission config.',
  'scout.missionControl.teamSteering.missionConfigOverrideActive': 'rep override active',
  'scout.missionControl.teamSteering.missionConfigUsingGlobal': 'using global defaults',
  'scout.missionControl.teamSteering.minEmployees': 'Min. employees',
  'scout.missionControl.teamSteering.maxRouteKm': 'Max. route (km)',
  'scout.missionControl.teamSteering.stopsPerDay': 'Stops / day',
  'scout.missionControl.teamSteering.anchorLookbackDays': 'Anchor lookback (days)',

  // Scout Unternehmenssuche
  'scout.unternehmenssuche.selectAllResults': 'Select all search results',
  'scout.unternehmenssuche.openingHours': 'OPENING HOURS',
  'scout.unternehmenssuche.temporarilyClosed': 'Temporarily closed',
  'scout.unternehmenssuche.startSearch': 'Start search',
  'scout.search.selectStatus': 'Select status...',
  'scout.unternehmenssuche.searchRunning': 'Searching...',
  'scout.unternehmenssuche.adjustSearchCriteria': 'Please adjust your search criteria or try again.',
  'scout.unternehmenssuche.selectCompanyType': 'Select company type',
  'scout.unternehmenssuche.openingHoursTime': 'Opening hours time',
  'scout.unternehmenssuche.noTimeNeeded': 'No time specification needed',
  'scout.unternehmenssuche.addConditions': 'Add conditions to refine your search',
  'scout.unternehmenssuche.addCondition': 'Add condition',
  'scout.unternehmenssuche.addGroup': 'Add group',
  'scout.unternehmenssuche.savedSearchName': 'Saved search name',
  'scout.unternehmenssuche.saveCurrentSearch': 'Save current search',
  'scout.unternehmenssuche.savedSearches': 'Saved searches',
  'scout.unternehmenssuche.noSavedSearches': 'No saved searches available.',
  'scout.unternehmenssuche.keywordPlaceholder': 'e.g. Restaurant, Bar, Bakery',
  'scout.unternehmenssuche.addWaypoint': 'Add waypoint',
  'scout.unternehmenssuche.locationPlaceholder': 'e.g. Munich Marienplatz',
  'scout.unternehmenssuche.toggleAdditionalFilters': 'Show or hide additional filters',
  'scout.unternehmenssuche.additionalFilters': 'Additional filters',
  'scout.unternehmenssuche.saveSearchAsFile': 'Save search as file',
  'scout.unternehmenssuche.loadSearchFromFile': 'Load search from file',
  'scout.unternehmenssuche.checkSearchTerms': 'Please check your search terms or try again.',
  'scout.unternehmenssuche.noResults': 'No results found.',
  'scout.unternehmenssuche.statusOperational': 'Operational',
  'scout.unternehmenssuche.statusClosedPermanently': 'Permanently closed',
  'scout.unternehmenssuche.noRating': 'No rating',
  'scout.unternehmenssuche.openNow': 'Open now',
  'scout.unternehmenssuche.closed': 'Closed',
  'scout.unternehmenssuche.noInfo': 'No info',

  // Search overlay
  'search.overlay.hint': 'Type and press Enter or click Search.',
  'search.overlay.placeholder': 'Search (/) for resources, docs, and more',
  'search.overlay.searchLabel': 'Search',
  'search.overlay.noResults': 'No results for "{{query}}"',
  'search.overlay.tryDifferent': 'Try different keywords or check your spelling.',
  'search.overlay.topResults': 'Top results',
  'search.overlay.documentation': 'Documentation · ',

  // Location/Route toggle (Unternehmenssuche)
  'scout.unternehmenssuche.locationRadius': 'Location + Radius',
  'scout.unternehmenssuche.routeCorridor': 'Route + Corridor',
  'scout.unternehmenssuche.withoutLocation': 'Without location',

  // Scout missions (Wave 3 i18n)
  'scout.scorecard.heatmapTitle': 'Activity heatmap (PLZ-2)',
  'scout.preferences.defaultRegionLabel': 'Default region',
  'scout.preferences.selectRegionPlaceholder': 'Select region',
  'scout.preferences.defaultStatusLabel': 'Default status',
  'scout.preferences.selectDefaultStatus': 'Select default status',
  'scout.preferences.statusDraft': 'Draft',
  'scout.preferences.statusActive': 'Active',
  'scout.preferences.statusCompleted': 'Completed',
  'scout.preferences.statusArchived': 'Archived',
  'scout.preferences.saving': 'Saving...',
  'scout.preferences.plzPrefixes': 'PLZ prefixes for missions',
  'scout.preferences.plzPrefixesPlaceholder': 'Enter PLZ prefixes separated by commas (e.g. 70, 71, 72)',
  'scout.preferences.maxRouteLength': 'Max. route length (km)',
  'scout.preferences.maxRouteLengthDescription': 'Maximum route length in kilometers',
  'scout.preferences.autoGenerateMissions': 'Auto-generate missions (nightly automation)',
  'scout.preferences.autoGenerateDescription': 'When enabled, missions will be automatically generated based on your settings.',
  'scout.preferences.defaultAssigneeLabel': 'Default responsible person',
  'scout.preferences.defaultAssigneePlaceholder': 'Enter default responsible person',
  'scout.preferences.defaultAssigneeAria': 'Default responsible person',
  'scout.preferences.defaultLeadCountLabel': 'Default number of leads',
  'scout.preferences.defaultLeadCountAria': 'Default number of leads',
  'scout.preferences.defaultDurationLabel': 'Default duration (days)',
  'scout.preferences.defaultDurationAria': 'Default duration in days',
  'scout.preferences.autoAssignLabel': 'Automatically assign missions to default responsible person',
  'scout.preferences.productFamiliesLabel': 'Product families',
  'scout.preferences.industryCodesLabel': 'Industries',
  'scout.preferences.keywordsLabel': 'Keywords',
  'scout.preferences.keywordsPlaceholder': 'e.g. concrete, screed',
  'scout.preferences.minLeadsLabel': 'Min. leads per mission',
  'scout.preferences.minLeadsAria': 'Minimum leads per mission',
  'scout.preferences.maxLeadsLabel': 'Max. leads per mission',
  'scout.preferences.maxLeadsAria': 'Maximum leads per mission',
  'scout.preferences.dailyQuotaLabel': 'Number of missions per day',
  'scout.preferences.dailyQuotaAria': 'Maximum missions per day',
  'scout.preferences.dailyQuotaHelper': 'Maximum number of auto-generated missions per day (1-3)',
  'scout.dailyPlanning.inField': 'In the field',
  'scout.dailyPlanning.completed': 'Completed',
  'scout.dailyPlanning.openDay': 'Open day',
  'scout.dailyPlanning.dayMarkedCompleted': 'This day is marked as completed.',
  'scout.dailyPlanning.statusVisited': 'Visited',
  'scout.dailyPlanning.statusPlanned': 'Planned',
  'scout.dailyPlanning.reportDone': 'Report done',
  'scout.dailyPlanning.statusCompleted': 'Completed',
  'scout.dailyPlanning.exportRoute': 'Export next stops',
  'scout.dailyPlanning.routeFromHome': 'From home → First stop',
  'scout.dailyPlanning.routeToHome': 'Last stop → Home',
  'scout.dailyPlanning.jokerAdd': 'Joker stop',
  'scout.dailyPlanning.jokerTitle': 'Add joker stop',
  'scout.dailyPlanning.jokerUsed': 'used',
  'scout.dailyPlanning.jokerLimitReached': 'Daily joker stop limit reached.',
  'scout.dailyPlanning.jokerCompany': 'Company',
  'scout.dailyPlanning.jokerCompanyPlaceholder': 'Enter company name',
  'scout.dailyPlanning.jokerOrt': 'Location',
  'scout.dailyPlanning.jokerOrtPlaceholder': 'Enter location',
  'scout.dailyPlanning.jokerWhy': 'Why',
  'scout.dailyPlanning.jokerWhyPlaceholder': 'Why is this stop being added?',
  'scout.dailyPlanning.jokerCancel': 'Cancel',
  'scout.dailyPlanning.jokerSubmit': 'Add stop',
  'scout.dailyPlanning.jokerCreateError': 'Stop could not be added. Please try again.',
  'scout.dailyPlanning.jokerQuotaExceeded': 'Daily limit reached – you have already used all {{max}} joker stops today. Try again tomorrow.',
  'scout.dailyPlanning.jokerCreatedTitle': 'Stop created',
  'scout.dailyPlanning.jokerCreatedAs': 'Stop created as #{{position}}',
  'scout.dailyPlanning.jokerCreatedQueued': 'Saved offline – it will sync once you are back online.',
  'scout.dailyPlanning.jokerCreatedHint': 'How would you like to proceed?',
  'scout.dailyPlanning.jokerCreatedVisit': 'Start visit',
  'scout.dailyPlanning.jokerCreatedScan': 'Scan order',
  'scout.dailyPlanning.jokerCreatedDismiss': 'Later',
  'scout.dailyPlanning.jokerCountError': 'Failed to load joker quota.',
  'scout.dailyPlanning.writeQueued': '✓ Saved – will be synced.',
  'scout.dailyPlanning.bucketUpNext': 'Up Next',
  'scout.dailyPlanning.bucketVisited': 'Visited',
  'scout.dailyPlanning.bucketPostponed': 'Postponed',
  'scout.dailyPlanning.bucketRejected': 'Rejected',
  'scout.dailyPlanning.cannotStartDay': 'Cannot start day',
  'scout.dailyPlanning.cannotStartDayNotToday': 'You can only start today.',
  'scout.dailyPlanning.cannotStartDayPriorOpen': 'The previous day is still open. Please close it first.',
  'scout.dailyPlanning.cannotStartDayNoMission': 'No mission selected for today.',
  'scout.dailyPlanning.activeMissionExists': 'You already have an active mission',
  'scout.dailyPlanning.activeMissionExistsResume': 'Taking you to your active mission.',
  'scout.dailyPlanning.startHomeReturnFailed': 'Home return could not be started',
  // PRE-EXISTING GAP on staging, cured here because this branch makes it rep-visible:
  // useTagesplanungDayLifecycle asks for `scout.dailyPlanning.dayCannotClose` (the copy
  // itself only ever existed under the `scout.tagesplanung.` namespace), so a hard
  // day-finish failure rendered the RAW KEY to the rep — a dark write-failure surface,
  // which is exactly what this arc exists to kill. Same copy as the tagesplanung entry.
  'scout.dailyPlanning.dayCannotClose': 'Day cannot be closed',
  'scout.dailyPlanning.dayWriteQueuedOffline': 'Not sent yet — offline',
  'scout.dailyPlanning.dayWriteQueuedOfflineHint': 'The action is queued and will be sent automatically once you are back online.',
  'scout.dailyPlanning.dayWriteQueuedUnconfirmed': 'NOT confirmed yet',
  'scout.dailyPlanning.dayWriteQueuedUnconfirmedHint': 'The server did not confirm the day step. It is queued and will be resent — please check again later.',
  'scout.dailyPlanning.scanOrder': 'Scan order',
  'scout.dailyPlanning.backlogBlocked': 'You have {{count}} outstanding visit reports.',
  'scout.dailyPlanning.backlogBlockedHint': 'Please write your visit reports before continuing.',

  // ReadOnlyPlanModal
  'scout.createMission.title': 'Create new mission',
  'scout.createMission.description': 'Choose name, filters and assignments',
  'scout.createMission.nameLabel': 'Name',
  'scout.createMission.nameRequired': 'Name is required',
  'scout.createMission.namePlaceholder': 'e.g. Stuttgart North — Refrigeration',
  'scout.createMission.nameAria': 'Mission name',
  'scout.createMission.regionLabel': 'Region (optional)',
  'scout.createMission.regionPlaceholder': 'e.g. PLZ 70xxx',
  'scout.createMission.regionAria': 'Region or PLZ',
  'scout.createMission.ownerLabel': 'Owner',
  'scout.createMission.ownerPlaceholder': 'Email address',
  'scout.createMission.ownerAria': 'Owner email address',
  'scout.createMission.themeLabel': 'Theme (optional)',
  'scout.createMission.themePlaceholder': 'e.g. Refrigeration',
  'scout.createMission.themeAria': 'Mission theme',
  'scout.createMission.productLabel': 'Product (optional)',
  'scout.createMission.productPlaceholder': 'e.g. K-2000',
  'scout.createMission.productAria': 'Product',
  'scout.createMission.cancel': 'Cancel',
  'scout.createMission.save': 'Save',
  'scout.createMission.saveBusy': 'Saving…',
  'scout.createMission.cancelAria': 'Cancel mission creation',
  'scout.createMission.saveAria': 'Save mission',
  'scout.createMission.saveBusyAria': 'Mission is being saved',

  // Inventory

  // Sales

  // Purchase


  // Settings
  'settings.description': 'Manage your application preferences and customization options',
  'settings.typography.title': 'Typography',
  'settings.typography.description': 'Adjust text size and density for readability or compactness',
  'settings.typography.scale.title': 'Text size',
  'settings.typography.scale.description': 'Standard matches Masterslight baseline; Comfort increases size for long sessions',
  'settings.typography.scale.ariaLabel': 'Text size preset',
  'settings.typography.scale.compact': 'Compact',
  'settings.typography.scale.standard': 'Standard',
  'settings.typography.scale.comfort': 'Comfort',
  'settings.tabs.appearance': 'Appearance',
  'settings.tabs.account': 'Account',
  'settings.tabs.notifications': 'Notifications',
  'settings.tabs.security': 'Security',
  'settings.language.title': 'Language Preferences',
  'settings.language.description': 'Choose your preferred language for the application interface',
  'settings.language.interfaceLanguage': 'Interface Language',
  'settings.language.interfaceLanguageDesc': 'Select the language for menus, buttons, and interface elements',
  'settings.theme.title': 'Color Theme',
  'settings.theme.description': 'Customize the appearance and colors of your interface',
  'settings.theme.predefinedThemes': 'Want to choose from 10 predefined themes?',
  'settings.theme.goToThemeSettings': 'Go to Theme Settings',
  'settings.theme.tabs.themes': 'Themes',
  'settings.theme.tabs.preview': 'Preview',
  'settings.theme.colorScheme.title': 'Color Scheme',
  'settings.theme.colorScheme.description': 'Choose between light, dark, or system preference',
  'settings.theme.colorScheme.options.light': 'Light',
  'settings.theme.colorScheme.options.dark': 'Dark',
  'settings.theme.colorScheme.options.system': 'System',
  'settings.theme.selector.title': 'Choose Theme',
  'settings.theme.selector.description': 'Select from 10 predefined themes. Changes apply immediately.',
  'settings.theme.current.title': 'Current Theme',
  'settings.theme.current.description': 'Information about your currently selected theme',
  'settings.theme.preview.title': 'Theme Preview',
  'settings.theme.preview.description': 'See how your selected theme looks with sample UI elements',
  'settings.theme.palette.title': 'Color Palette',
  'settings.theme.palette.secondary': 'Secondary',
  'settings.theme.palette.background': 'Background',
  'settings.themeSettings.title': 'Theme Settings',
  'settings.themeSettings.description': 'Customize the appearance of your application with predefined themes',
  'settings.themeSettings.themeDetails': 'Theme Details',
  'settings.themeSettings.themeId': 'Theme ID:',
  'settings.themeSettings.colorScheme': 'Color Scheme:',
  'settings.account.profile.title': 'Profile Information',
  'settings.account.profile.description': 'Update your personal information and account details',
  'settings.account.profile.name': 'Name',
  'settings.account.profile.email': 'Email',
  'settings.account.profile.role': 'Role',
  'settings.account.profile.department': 'Department',
  'settings.account.profile.editProfile': 'Edit Profile',
  'settings.account.data.title': 'Data Management',
  'settings.account.data.description': 'Manage your data synchronization and backup preferences',
  'settings.account.data.cloudSync': 'Cloud Sync',
  'settings.account.data.cloudSyncEnabled': 'Your preferences are synced to the cloud',
  'settings.account.data.cloudSyncDisabled': 'Cloud sync is disabled (feature flag)',
  'settings.account.data.syncNow': 'Sync Now',
  'settings.notifications.title': 'Notification Preferences',
  'settings.notifications.description': 'Configure how you receive notifications',
  'settings.notifications.email.title': 'Email Notifications',
  'settings.notifications.email.description': 'Receive notifications via email',
  'settings.notifications.push.title': 'Push Notifications',
  'settings.notifications.push.description': 'Receive push notifications in browser',
  'settings.notifications.system.title': 'System Alerts',
  'settings.notifications.system.description': 'Important system notifications',
  'settings.notifications.configure': 'Configure',
  'settings.security.title': 'Security Settings',
  'settings.security.description': 'Manage your account security and privacy settings',
  'settings.security.password.title': 'Password',
  'settings.security.password.lastChanged': 'Last changed 30 days ago',
  'settings.security.password.change': 'Change',
  'settings.security.twoFactor.title': 'Two-Factor Authentication',
  'settings.security.twoFactor.description': 'Add an extra layer of security',
  'settings.security.twoFactor.enable': 'Enable',
  'settings.security.sessions.title': 'Session Management',
  'settings.security.sessions.description': 'Manage active sessions',
  'settings.security.sessions.view': 'View Sessions',
  'settings.company.title': 'Company Settings',
  'settings.company.description': 'Manage your company information and preferences',
  'settings.company.edit': 'Edit Company',
  'settings.company.saveChanges': 'Save Changes',
  'settings.company.cancel': 'Cancel',
  'settings.company.tabs.general': 'General',
  'settings.company.tabs.contact': 'Contact',
  'settings.company.tabs.billing': 'Billing',
  'settings.company.tabs.branding': 'Branding',
  'settings.company.general.companyInfo': 'Company Information',
  'settings.company.general.companyName': 'Company Name',
  'settings.company.general.legalName': 'Legal Name',
  'settings.company.general.taxId': 'Tax ID',
  'settings.company.general.registrationNumber': 'Registration Number',
  'settings.company.general.industry': 'Industry',
  'settings.company.general.foundedYear': 'Founded Year',
  'settings.company.general.employees': 'Number of Employees',
  'settings.company.general.industry.technology': 'Technology',
  'settings.company.general.industry.manufacturing': 'Manufacturing',
  'settings.company.general.industry.retail': 'Retail',
  'settings.company.general.industry.healthcare': 'Healthcare',
  'settings.company.general.industry.finance': 'Finance',
  'settings.company.general.industry.other': 'Other',
  'settings.company.address.title': 'Address Information',
  'settings.company.address.street': 'Street Address',
  'settings.company.address.city': 'City',
  'settings.company.address.state': 'State',
  'settings.company.address.zipCode': 'ZIP Code',
  'settings.company.address.country': 'Country',
  'settings.company.address.country.us': 'United States',
  'settings.company.address.country.ca': 'Canada',
  'settings.company.address.country.uk': 'United Kingdom',
  'settings.company.address.country.de': 'Germany',
  'settings.company.address.country.fr': 'France',
  'settings.company.address.country.other': 'Other',
  'settings.company.contact.title': 'Contact Information',
  'settings.company.contact.phone': 'Phone Number',
  'settings.company.contact.email': 'Email Address',
  'settings.company.contact.website': 'Website',
  'settings.company.contact.supportEmail': 'Support Email',
  'settings.company.billing.title': 'Billing Settings',
  'settings.company.billing.currency': 'Currency',
  'settings.company.billing.taxRate': 'Tax Rate (%)',
  'settings.company.billing.paymentTerms': 'Payment Terms',
  'settings.company.billing.billingCycle': 'Billing Cycle',
  'settings.company.billing.paymentTerms.net15': 'Net 15',
  'settings.company.billing.paymentTerms.net30': 'Net 30',
  'settings.company.billing.paymentTerms.net45': 'Net 45',
  'settings.company.billing.paymentTerms.net60': 'Net 60',
  'settings.company.billing.paymentTerms.dueOnReceipt': 'Due on Receipt',
  'settings.company.billing.cycle.monthly': 'Monthly',
  'settings.company.billing.cycle.quarterly': 'Quarterly',
  'settings.company.billing.cycle.annually': 'Annually',
  'settings.company.billing.cycle.custom': 'Custom',
  'settings.company.billing.summary.title': 'Billing Summary',
  'settings.company.billing.summary.currentPlan': 'Current Plan',
  'settings.company.billing.summary.monthlyCost': 'Monthly Cost',
  'settings.company.billing.summary.nextBillingDate': 'Next Billing Date',
  'settings.company.billing.summary.paymentMethod': 'Payment Method',
  'settings.company.billing.summary.status': 'Status',
  'settings.company.billing.summary.active': 'Active',
  'settings.company.branding.title': 'Branding & Appearance',
  'settings.company.branding.logo': 'Company Logo',
  'settings.company.branding.uploadLogo': 'Upload Logo',
  'settings.company.branding.logoHint': 'PNG, JPG up to 2MB',
  'settings.company.branding.favicon': 'Favicon',
  'settings.company.branding.uploadFavicon': 'Upload Favicon',
  'settings.company.branding.faviconHint': 'ICO, PNG up to 1MB',
  'settings.company.branding.primaryColor': 'Primary Color',
  'settings.company.branding.secondaryColor': 'Secondary Color',
  'settings.usersRoles.stats.totalUsers': 'Total Users',
  'settings.usersRoles.stats.activeUsers': 'active users',
  'settings.usersRoles.stats.totalRoles': 'Total Roles',
  'settings.usersRoles.stats.roleConfigurations': 'Role configurations',
  'settings.usersRoles.stats.permissionRules': 'Permission Rules',
  'settings.usersRoles.stats.acrossAllRoles': 'rules across all roles',
  'settings.userManagement.title': 'User Management',
  'settings.userManagement.description': 'Manage users, roles, and system settings',
  'settings.userManagement.addUser': 'Add User',
  'settings.userManagement.editUser': 'Edit User',
  'settings.userManagement.createNewUser': 'Create New User',
  'settings.userManagement.updateUserInfo': 'Update user information',
  'settings.userManagement.addNewUser': 'Add a new user to the system',
  'settings.userManagement.tabs.users': 'Users',
  'settings.userManagement.tabs.appAccess': 'App Access',
  'settings.userManagement.tabs.roles': 'Roles',
  'settings.userManagement.toast.userCreated': 'User created successfully',
  'settings.userManagement.toast.userUpdated': 'User updated successfully',
  'settings.userManagement.toast.userDeleted': 'User deleted successfully',
  'settings.userManagement.toast.roleCreated': 'Role created successfully',
  'settings.userManagement.toast.roleUpdated': 'Role updated successfully',
  'settings.userManagement.toast.roleDeleted': 'Role deleted successfully',
  'settings.userManagement.toast.error': 'Failed to create user',
  'settings.userManagement.toast.errorUpdate': 'Failed to update user',
  'settings.userManagement.toast.errorDelete': 'Failed to delete user',
  'settings.userManagement.toast.errorRoleCreate': 'Failed to create role',
  'settings.userManagement.toast.errorRoleUpdate': 'Failed to update role',
  'settings.userManagement.toast.errorRoleDelete': 'Failed to delete role',
  'settings.userManagement.selectUserForAccess': 'Select a user from the Users tab to manage their app and feature access.',
  'settings.userManagement.roles.title': 'Roles',
  'settings.userManagement.roles.subtitle': 'Manage roles and their permission matrix',
  'settings.userManagement.roles.addRole': 'Add Role',
  'settings.userManagement.roles.createTitle': 'Create New Role',
  'settings.userManagement.roles.createDescription': 'Enter a name for the new role. Configure permissions after creation.',
  'settings.userManagement.roles.roleName': 'Role name',
  'settings.userManagement.roles.cancel': 'Cancel',
  'settings.userManagement.roles.create': 'Create',
  'settings.userManagement.roles.permissionsTitle': 'Permissions: {{name}}',
  'settings.userManagement.roles.permissionsDescription': 'Apps x Actions permission matrix. Expand apps to see features.',
  'settings.userManagement.roles.savePermissions': 'Save Permissions',
  'settings.userManagement.roles.saving': 'Saving...',
  'settings.userManagement.roles.usersAssigned': '{{count}} users assigned',
  'settings.userManagement.roles.userAssigned': '{{count}} user assigned',
  'settings.userManagement.roles.deleteConfirmTitle': 'Delete Role',
  'settings.userManagement.roles.deleteConfirmDescription': 'Are you sure you want to delete role "{{name}}"? This action cannot be undone.',
  'settings.userManagement.roles.deleteConfirm': 'Delete',
  'settings.userManagement.roles.permissionCount': '{{count}} permissions',
  'settings.userManagement.roles.accessLevelsTab': 'Access Levels',
  'settings.userManagement.roles.granularTab': 'Granular Permissions',
  'settings.userManagement.roles.accessLevel': 'Access Level',
  'settings.userManagement.access.selectUser': 'Select a user to manage permissions',
  'settings.userManagement.access.permissionsTitle': 'Permissions: {{name}}',
  'settings.userManagement.access.matrixDescription': 'App x Feature x Action permission matrix',
  'settings.userManagement.access.appFeature': 'App / Feature',
  'settings.userManagement.access.reset': 'Reset',
  'settings.userManagement.access.save': 'Save',
  'settings.userManagement.access.flightPermit': 'Flight Permit (AI Agent)',
  'settings.userManagement.access.validUntil': 'Valid Until',
  'settings.userManagement.access.maxInvocations': 'Max Invocations',
  'settings.userManagement.access.unlimited': 'Unlimited',
  'settings.userManagement.access.reason': 'Reason',
  'settings.userManagement.access.reasonPlaceholder': 'Approval reason...',
  'settings.userManagement.access.pickUser': 'Select user...',
  'settings.userManagement.access.searchUsers': 'Search users...',
  'settings.userManagement.access.noUsersFound': 'No users found.',
  'settings.userManagement.access.action.read': 'Read',
  'settings.userManagement.access.action.write': 'Write',
  'settings.userManagement.access.action.delete': 'Delete',
  'settings.userManagement.access.action.execute': 'Execute',
  'settings.userManagement.access.action.admin': 'Admin',
  'settings.integrations.settings.security.enabled': 'Enabled',
  'settings.integrations.settings.security.disabled': 'Disabled',

  // Analytics - Pivot Table

  // Reports

  // Warehouse - Picking

  // Warehouse - Returns

  // Warehouse - ASN

  // CRM - Contacts
  'crm.contacts.title': 'CRM Contacts',
  'crm.contacts.description': 'Manage customer and supplier contacts with address information',
  'crm.contacts.add': 'Add Contact',
  'crm.contacts.edit': 'Edit Contact',
  'crm.contacts.delete': 'Delete Contact',
  'crm.contacts.view360': '360° View',
  'crm.contacts.unassigned': 'Unassigned',
  'crm.contacts.type.customer': 'Customer',
  'crm.contacts.type.supplier': 'Supplier',
  'crm.contacts.type.partner': 'Partner',
  'crm.contacts.type.prospect': 'Prospect',
  'crm.contacts.status.active': 'Active',
  'crm.contacts.status.inactive': 'Inactive',
  'crm.contacts.status.suspended': 'Suspended',
  'crm.contacts.validation.companyRequired': 'Company name is required',
  'crm.contacts.validation.streetRequired': 'Street address is required',
  'crm.contacts.validation.postalRequired': 'Postal code is required',
  'crm.contacts.validation.cityRequired': 'City is required',
  'crm.contacts.validation.countryRequired': 'Country is required',
  'crm.contacts.validation.nameRequired': 'Contact name is required',
  'crm.contacts.validation.emailInvalid': 'Invalid email address',
  'crm.contacts.validation.phoneRequired': 'Phone number is required',
  'crm.contacts.validation.salesPersonRequired': 'Sales person is required',
  'crm.contacts.validation.ordererNameRequired': 'Orderer name is required',
  'crm.contacts.validation.roleRequired': 'Role is required',
  'crm.contacts.validation.hoursRequired': 'Hours are required',
  'crm.openMenu': 'Open menu',
  'crm.contacts.search': 'Search contacts...',
  'crm.contacts.searchLabel': 'Search contacts',
  'crm.contacts.name': 'Name',
  'crm.contacts.company': 'Company',
  'crm.contacts.contact': 'Contact',
  'crm.contacts.type': 'Type',
  'crm.contacts.status': 'Status',
  'crm.contacts.salesPerson': 'Sales Person',
  'crm.contacts.lastContact': 'Last Contact',
  'crm.contacts.actions': 'Actions',
  'crm.contacts.viewDetails': 'View Details',
  'crm.contacts.manageAddresses': 'Manage Addresses',
  'crm.contacts.addNote': 'Add Note',
  'crm.contacts.assignSalesPerson': 'Assign Sales Person',
  'crm.contacts.tabs.contacts': 'Contacts',
  'crm.contacts.tabs.analytics': 'Analytics',
  'crm.contacts.tabs.documents': 'Documents',
  'crm.contacts.tabs.email': 'Email',
  'crm.contacts.tabs.search': 'Advanced Search',
  'crm.contacts.emptyState.selectHeading': 'Select a Contact',
  'crm.contacts.emptyState.documentsMessage': 'Choose a contact from the Contacts tab to manage their documents',
  'crm.contacts.emptyState.emailMessage': 'Choose a contact from the Contacts tab to view email communication',
  'crm.contacts.quickSearch': 'Quick search contacts...',
  'crm.contacts.close': 'Close',
  'crm.contacts.stats.total': 'Total Contacts',
  'crm.contacts.stats.active': 'Active Contacts',
  'crm.contacts.stats.customers': 'Customers',
  'crm.contacts.stats.suppliers': 'Suppliers',
  'crm.contacts.stats.changeFromLastMonth': '+{pct}% from last month',
  'crm.contacts.stats.percentActive': '% active',
  'crm.contacts.stats.percentOfTotal': '% of total',

  // CRM - Leads
  'crm.leads.title': 'Leads',
  'crm.leads.description': 'Manage sales leads and track conversion',
  'crm.leads.add': 'Add Lead',
  'crm.leads.edit': 'Edit Lead',
  'crm.leads.delete': 'Delete Lead',
  'crm.leads.status.new': 'New',
  'crm.leads.status.contacted': 'Contacted',
  'crm.leads.status.qualified': 'Qualified',
  'crm.leads.status.proposal': 'Proposal',
  'crm.leads.status.negotiation': 'Negotiation',
  'crm.leads.status.closedWon': 'Closed Won',
  'crm.leads.status.closedLost': 'Closed Lost',
  'crm.leads.source.website': 'Website',
  'crm.leads.source.referral': 'Referral',
  'crm.leads.source.email': 'Email',
  'crm.leads.source.phone': 'Phone',
  'crm.leads.source.social': 'Social Media',
  'crm.leads.source.other': 'Other',
  'crm.leads.value': 'Value',
  'crm.leads.lastContact': 'Last Contact',
  'crm.leads.notes': 'Notes',
  'crm.leads.search': 'Search leads...',
  'crm.leads.filterByStatus': 'Filter by status',
  'crm.leads.filterBySource': 'Filter by source',
  'crm.leads.totalLeads': 'Total Leads',
  'crm.leads.pipelineValue': 'Pipeline Value',
  'crm.leads.qualifiedLeads': 'Qualified Leads',
  'crm.leads.percentConversion': '% conversion',

  // CRM - Shared flat keys (used by Leads page)
  'crm.leads': 'Leads',
  'crm.name': 'Name',
  'crm.company': 'Company',
  'crm.contact': 'Contact',
  'crm.email': 'Email',
  'crm.phone': 'Phone',
  'crm.source': 'Source',
  'crm.value': 'Value',
  'crm.lastContact': 'Last Contact',
  'crm.notes': 'Notes',
  'crm.fullName': 'Full Name',
  'crm.estimatedValue': 'Estimated Value',
  'crm.searchPlaceholder': 'Search...',
  'crm.closedWon': 'Closed Won',
  'crm.viewDetails': 'View Details',
  'crm.editLead': 'Edit Lead',
  'crm.addNote': 'Add Note',
  'crm.convertToCustomer': 'Convert to Customer',
  'crm.deleteLead': 'Delete Lead',
  'crm.addNewLead': 'Add New Lead',
  'crm.createNewLead': 'Create a new sales lead',
  'crm.leadDetails': 'Lead Details',
  'crm.viewLeadDetails': 'View and edit lead information',
  'crm.status.new': 'New',
  'crm.status.contacted': 'Contacted',
  'crm.status.qualified': 'Qualified',
  'crm.status.proposal': 'Proposal',
  'crm.status.negotiation': 'Negotiation',
  'crm.status.closedWon': 'Closed Won',
  'crm.status.closedLost': 'Closed Lost',
  'crm.source.website': 'Website',
  'crm.source.referral': 'Referral',
  'crm.source.tradeShow': 'Trade Show',
  'crm.source.coldCall': 'Cold Call',
  'crm.source.socialMedia': 'Social Media',
  'crm.source.emailCampaign': 'Email Campaign',

  // CRM - Lead Map
  'crm.leadMap.title': 'Hierarchical Lead Map',
  'crm.leadMap.description': 'Visualize company relationships, hierarchies, VAT ID groupings, and sales rep assignments',
  'crm.leadMap.loading': 'Loading lead map data...',
  'crm.leadMap.loadError': 'Failed to load lead map data:',

  // CRM - Address Management
  'crm.address.management': 'Address Management',
  'crm.address.manageAll': 'Manage all address information',
  'crm.address.company': 'Company Address',
  'crm.address.delivery': 'Delivery Address',
  'crm.address.invoice': 'Invoice Address',
  'crm.address.sameAsCompany': 'Same as Company',
  'crm.address.deliverySameAsCompany': 'Delivery address is the same as company address.',
  'crm.address.invoiceSameAsCompany': 'Invoice address is the same as company address.',
  'crm.address.useDifferent': 'Use Different Address',

  // Visit Report
  'visitReport.title': 'Visit Report',
  'visitReport.createTitle': 'Create Visit Report',
  'visitReport.titleFor': 'Visit Report for {{name}}',
  'visitReport.visitType': 'Visit Type',
  'visitReport.coldVisit': 'Cold Visit',
  'visitReport.appointment': 'Appointment',
  'visitReport.salesOutcome': 'Sales Outcome',
  'visitReport.noContact': 'No Contact',
  'visitReport.conversation': 'Conversation',
  'visitReport.demo': 'Demo',
  'visitReport.order': 'Order',
  'visitReport.orderValue': 'Order Value (EUR)',
  'visitReport.nextStep': 'Next Step',
  'visitReport.callback': 'Callback',
  'visitReport.sendOffer': 'Send Offer',
  'visitReport.revisit': 'Revisit',
  'visitReport.completed': 'Completed',
  'visitReport.appointmentWindow': 'Appointment Window (optional)',
  'visitReport.from': 'From',
  'visitReport.to': 'To',
  'visitReport.contactName': 'Contact Name',
  'visitReport.enterName': 'Enter Name',
  'visitReport.roleFunction': 'Role / Function',
  'visitReport.enterRole': 'Enter Role',
  'visitReport.isDecisionMaker': 'Is Decision Maker?',
  'visitReport.decisionMakerName': 'Decision Maker Name',
  'visitReport.decisionMakerRole': 'Decision Maker Role',
  'visitReport.email': 'Email (optional)',
  'visitReport.phone': 'Phone (optional)',
  'visitReport.notes': 'Notes (optional)',
  'visitReport.additionalInfo': 'Additional information...',
  'visitReport.productsDiscussed': 'Products Discussed?',
  'visitReport.annualDemand': 'Annual Demand',
  'visitReport.select': 'Select',
  'visitReport.interest': 'Interest',
  'visitReport.interestHigh': 'high',
  'visitReport.interestMedium': 'medium',
  'visitReport.interestLow': 'low',
  'visitReport.modelFeedback': 'Was the system recommendation appropriate?',
  'visitReport.feedbackYes': 'Yes',
  'visitReport.feedbackPartially': 'Partially',
  'visitReport.feedbackNo': 'No',
  'visitReport.feedbackNotSeen': 'Not Seen',
  'visitReport.branchCorrect': 'Branch correct? (optional)',
  'visitReport.selectBranch': 'Select Branch',
  'visitReport.branchConstruction': 'Construction',
  'visitReport.branchIndustry': 'Industry',
  'visitReport.branchTrade': 'Trade',
  'visitReport.branchService': 'Service',
  'visitReport.noInterestReason': 'Reason for No Interest',
  'visitReport.wrongProduct': 'Wrong Product',
  'visitReport.wrongTiming': 'Wrong Timing',
  'visitReport.existingSupplier': 'Existing Supplier',
  'visitReport.noBudget': 'No Budget',
  'visitReport.noNeed': 'No Need',
  'visitReport.decisionMakerNotReached': 'Decision Maker Not Reached',
  'visitReport.additionalRemarks': 'Additional Remarks (optional)',
  'visitReport.error': 'Error',
  'visitReport.validationError': 'Please select visit type and sales outcome.',
  'visitReport.deferralNotPossible': 'Deferral Not Possible',
  'visitReport.maxDeferralReached': 'You have already deferred the last report. Please complete it.',
  'visitReport.reportDeferred': 'Report Deferred',
  'visitReport.deferralMessage': 'You can complete the report later.',
  'visitReport.reportCreated': 'Visit Report Created',
  'visitReport.reportSaved': 'Visit report saved.',
  'visitReport.reportSavedFor': 'Visit report for {{name}} saved.',
  'visitReport.reportError': 'Visit report could not be created.',
  'visitReport.stepOf': 'Step {{current}} of {{total}}',
  'visitReport.back': 'Back',
  'visitReport.cancel': 'Cancel',
  'visitReport.inAHurry': 'I am in a hurry',
  'visitReport.next': 'Next',
  'visitReport.saving': 'Saving...',
  'visitReport.finishVisit': 'Finish Visit',
  'visitReport.contactNotes': 'Additional information about the contact...',
  'visitReport.callingQueue.prompt': 'Should an AI appointment call be prepared for this lead?',
  'visitReport.callingQueue.yes': 'Yes, add to queue',
  'visitReport.callingQueue.no': 'No',
  'visitReport.callingQueue.toast': 'Lead added to calling queue',

  // --- SS-145: admin ---
  // --- SS-145: ui-components ---

  // --- SS-145: learning ---

  // --- SS-145: modals ---
  'modals.assignMissionModal.close': 'Close',
  'modals.assignMissionModal.searchPlaceholder': 'Search (title/industry)',
  'modals.assignMissionModal.searchAriaLabel': 'Search',
  'modals.missionQuickViewModal.description': 'Quick overview of the mission. Open the mission page for details.',
  'modals.missionQuickViewModal.close': 'Close',
  'modals.missionQuickViewModal.openDetails': 'Open details',
  'modals.missionQuickViewModal.openDetailsAria': 'Open mission detail',
  'modals.leadDetailModal.close': 'Close',
  'modals.leadDetailModal.whoIsThis': 'Who is this?',
  'modals.leadDetailModal.whatDoTheyNeed': 'What do they need?',
  'modals.leadDetailModal.whatDoISay': 'What do I say?',
  'modals.leadDetailModal.moreProducts': 'More products',
  'modals.leadDetailModal.topProduct': 'Top product',
  'modals.leadDetailModal.demoObject': 'Demo object',
  'modals.leadDetailModal.problem': 'Problem',
  'modals.leadDetailModal.dilution': 'Dilution',
  'modals.leadDetailModal.noProductData': 'No product data available',
  'modals.leadDetailModal.contactPersons': 'Contact Persons',
  'modals.leadDetailModal.addContact': 'Add',
  'modals.leadDetailModal.contactNamePlaceholder': 'Contact person name',
  'modals.leadDetailModal.save': 'Save',
  'modals.leadDetailModal.visitHistory': 'Visit History (90 days)',
  // FR-FE-POST-CALL-ENVELOPE-TO-STEFFEN-P0 (doc-store 85571ff7-…): post-call briefing tile.
  'modals.leadDetailModal.postCall.title': 'From the phone call',
  'modals.leadDetailModal.postCall.empty': 'No qualified call on record.',
  'modals.leadDetailModal.postCall.slPending': 'Post-call envelope pending (SL endpoint not yet shipped).',
  'modals.leadDetailModal.postCall.contact': 'Contact',
  'modals.leadDetailModal.postCall.contactName': 'Contact person',
  'modals.leadDetailModal.postCall.decisionMaker': 'Decision maker',
  'modals.leadDetailModal.postCall.yes': 'Yes',
  'modals.leadDetailModal.postCall.no': 'No',
  'modals.leadDetailModal.postCall.directPhone': 'Direct phone',
  'modals.leadDetailModal.postCall.email': 'Email',
  'modals.leadDetailModal.postCall.availability': 'Availability',
  'modals.leadDetailModal.postCall.window': 'Window',
  'modals.leadDetailModal.postCall.timePreference': 'Time preference',
  'modals.leadDetailModal.postCall.qualification': 'Qualification',
  'modals.leadDetailModal.postCall.interestLevel': 'Interest',
  'modals.leadDetailModal.postCall.infrastructure': 'Infrastructure',
  'modals.leadDetailModal.postCall.detection': 'Detection',
  'modals.leadDetailModal.postCall.systemType': 'System type',
  'modals.leadDetailModal.postCall.cluster': 'Cluster',
  'modals.leadDetailModal.postCall.competitor': 'Competitor',
  'modals.leadDetailModal.postCall.notes': 'Notes',
  'modals.leadDetailModal.postCall.corrections': 'Briefing corrections',
  'modals.leadDetailModal.postCall.caller': 'Caller',
  'modals.leadDetailModal.postCall.script': 'Script',
  'modals.createLead.title': 'Create New Lead',
  'modals.createLead.firma': 'Company Name',
  'modals.createLead.adresse': 'Address',
  'modals.createLead.plz': 'Postal Code',
  'modals.createLead.ort': 'City',
  'modals.createLead.branche': 'Industry',
  'modals.createLead.telefon': 'Phone',
  'modals.createLead.website': 'Website',
  'modals.createLead.submit': 'Create Lead',
  'modals.createLead.success': 'Lead created successfully',
  'modals.createLead.error': 'Failed to create lead',
  'modals.regionDetailsModal.description': 'Overview of mission details. This view is read-only.',
  'modals.regionDetailsModal.edit': 'Edit',
  'modals.regionDetailsModal.close': 'Close',
  'modals.editRegionModal.close': 'Close',
  'modals.editRegionModal.description': 'Edit time and note for the mission. Status is read-only.',
  'modals.editRegionModal.statusReadonlySrOnly': 'Status is read-only.',
  'modals.splitAssignmentDialog.actionLabel': 'Select action',
  'modals.splitAssignmentDialog.confirmButton': 'Confirm',
  'modals.addAppointmentModal.titleAdd': 'Add appointment',
  'modals.addAppointmentModal.titleEdit': 'Edit appointment',
  'modals.addAppointmentModal.description': 'Enter appointment details and save',
  'modals.addAppointmentModal.start': 'Start',
  'modals.addAppointmentModal.end': 'End',
  'modals.addAppointmentModal.companyLabel': 'Company / Lead *',
  'modals.addAppointmentModal.companyAriaLabel': 'Select or enter company / lead',
  'modals.addAppointmentModal.location': 'Location',
  'modals.addAppointmentModal.commitment': 'Commitment level',
  'modals.addAppointmentModal.commitmentConfirmed': 'Confirmed',
  'modals.addAppointmentModal.errorTimeMissing': 'Please enter start and end time.',
  'modals.addAppointmentModal.errorTimeInvalid': 'Invalid time. Format HH:MM.',
  'modals.rejectLead.title': 'Reject Lead',
  'modals.rejectLead.closeAria': 'Close dialog',
  'modals.rejectLead.description': 'Select at least one rejection reason.',
  'modals.rejectLead.reasonsLabel': 'Rejection reasons',
  'modals.rejectLead.reasonsError': 'Please select at least one reason.',
  'modals.rejectLead.otherReasonLabel': 'Other reason',
  'modals.rejectLead.otherReasonPlaceholder': 'Please describe the reason...',
  'modals.rejectLead.otherReasonAria': 'Other rejection reason',
  'modals.rejectLead.otherReasonError': 'Please enter a reason.',
  'modals.rejectLead.cancel': 'Cancel',
  'modals.rejectLead.confirm': 'Reject ({count})',
  'modals.rejectLead.reason.outOfBusiness': 'Out of business',
  'modals.rejectLead.reason.temporarilyClosed': 'Temporarily closed',
  'modals.rejectLead.reason.knownAndUnsuitable': 'Known and unsuitable',
  'modals.rejectLead.reason.noInterest': 'No interest',
  'modals.rejectLead.reason.wrongContact': 'Wrong contact',
  'modals.rejectLead.reason.other': 'Other',

  // --- SS-145: ui-components + app-components ---
  'app.routes.loadingSettings': 'Loading settings...',
  'companySearch.filters.companySize': 'Company Size',
  'curriculum.modules.pillar': 'Pillar',
  'curriculum.modules.selectLevel': 'Select level',
  'curriculum.modules.selectPillar': 'Select pillar',
  'curriculum.modules.selectPillarOption': 'Select pillar',
  'learning.lessonViewer.audioNotSupported': 'Your browser does not support the audio element.',
  'learning.lessonViewer.complete': 'Complete',
  'learning.lessonViewer.formatNotSupported': 'Format not supported',
  'learning.lessonViewer.videoNotSupported': 'Your browser does not support the video element.',
  'learning.moduleEditor.pillar': 'Pillar',
  'learning.moduleEditor.pillarLabel': 'Pillar',
  'learning.tabs.availableLessons': 'Available Lessons',
  'learning.tabs.availableQuizzes': 'Available Quizzes',
  'missionControl.totalLeads': 'Total Leads',
  'missionControl.completedLeads': 'Completed Leads',
  'missions.management.decisionMakerMet': 'Decision maker met',
  'missions.management.wonAmount': 'Won amount',
  'missions.management.demoPerformed': 'Demo performed',
  'missions.management.demoPerformedLabel': 'Demo performed',
  'missions.management.kpiDescription': 'Decision maker met, demo performed, revenue',
  'missions.management.moreActions': 'Show more actions for mission',
  'missions.management.publish': 'Publish',
  'missions.management.searchPlaceholder': 'Search (Name/Region/Topic/Product)',
  'mobile.layout.closeMenu': 'Close menu',
  'mobile.layout.menu': 'Menu',
  'mobile.layout.noOfflineContent': 'No offline content available',
  'mobile.layout.offlinePerformance': 'For better offline performance',
  'navigation.tileCard.openActions': 'Open tile actions',
  'scout.preferences.badenWuerttemberg': 'Baden-Württemberg',
  'scout.preferences.thueringen': 'Thuringia',
  'scout.sprints.ciEstimate': 'CI Runtime Estimate',
  'scout.sprints.estimatedMinutes': 'Estimated Minutes',
  'styleGuide.charts.noStatusColors': 'Charts must not use status colors',
  'styleGuide.confirmation': 'Confirmation',
  'styleGuide.description': 'Description',
  'styleGuide.statusSemantics.success': 'Success = Completed / OK',
  'tickets.list.filterPriority': 'Filter priority',
  'ui.calendar.nextMonth': 'Next Month',
  'ui.errorBoundary.returnToDashboard': 'Return to Dashboard',
  'ui.impersonation.selectImpersonation': 'Select impersonation',
  'ui.impersonation.selectUser': 'Select user:',
  'ui.routingPreview.openAppleMaps': 'Open in Apple Maps',
  'ui.routingPreview.openGoogleMaps': 'Open in Google Maps',
  'ui.routingPreview.stopsLabel': '{{count}} Stops · {{distance}} km · {{time}} min (estimated)',
  'ui.routingPreview.title': 'Route Preview',
  'weeklyPlanning.appointmentModal.additionalNotes': 'Additional Notes',
  'weeklyPlanning.legacyAppointments.addAppointment': 'Add appointment',
  'scout.help.selectArticle': 'Select an article on the left or use search to open a help article.',
  'scout.help.title': 'Help Center',
  'scout.help.subtitle': 'Find documentation, walkthroughs, and support workflows for SCOUT',
  'scout.help.localeLabel': 'Language',
  'scout.help.localeDescription': 'Switch between German and English content',
  'scout.help.toggle.english': 'English',
  'scout.help.toggle.german': 'German',
  'scout.help.clearCategory': 'Clear',
  'scout.help.loadError': 'Help content could not be loaded.',
  'scout.help.searchPlaceholder': 'Search articles',
  'scout.help.searchLabel': 'Search help articles',

  // External shared case file (link-gated, no app chrome)
  'external.case360.nav.jumpLabel': 'Jump to section',
  'external.case360.nav.summary': 'Summary',
  'external.case360.nav.parties': 'Parties',
  'external.case360.nav.timeline': 'Timeline',
  'external.case360.nav.amountsDocuments': 'Amounts & documents',
  'external.case360.section.summary': 'Case summary',
  'external.case360.section.parties': 'Parties & contacts',
  'external.case360.section.timeline': 'Timeline',
  'external.case360.section.amountsDocuments': 'Amounts & documents',
  'external.case360.summary.caseId': 'Case ID',
  'external.case360.summary.status': 'Status',
  'external.case360.summary.priority': 'Priority',
  'external.case360.summary.assignee': 'Assignee',
  'external.case360.summary.opened': 'Opened',
  'external.case360.parties.role': 'Role',
  'external.case360.amounts.regionLabel': 'Amount breakdown',
  'external.case360.amounts.heading': 'Amounts',
  'external.case360.amounts.line.principal': 'Principal',
  'external.case360.amounts.line.fees': 'Fees',
  'external.case360.amounts.line.interest': 'Interest',
  'external.case360.amounts.line.total': 'Total',
  'external.case360.documents.regionLabel': 'Documents',
  'external.case360.documents.heading': 'Documents on file',
  'external.case360.documents.received': 'Received',

  // Visit Report — Rejection Sheet (B1)

  // Visit Report — Post-Visit Report (B2)

  // Visit Report — Compliance Gate (B3)
  'scout.visitReport.questionnaire.unknownType': 'Unknown question type',
  'scout.visitReport.questionnaire.finish': 'Finish report',
  'scout.visitReport.questionnaire.empty': 'No questions in the active configuration.',
  'scout.visitReport.compliance.title': 'Open Visit Reports',
  'scout.visitReport.compliance.description': 'You have {{count}} open visit reports. Please complete them first.',
  'scout.visitReport.compliance.lockoutTitle': 'Reports Required',
  'scout.visitReport.compliance.lockoutDescription': 'Please complete all open visit reports before continuing.',
  'scout.visitReport.compliance.deferButton': 'Fill in later',
  'scout.visitReport.compliance.deferCount': '{{remaining}} deferrals remaining',
  'scout.visitReport.compliance.noDeferrals': 'No deferrals remaining',
  'scout.visitReport.compliance.fillReport': 'Fill report',
  'scout.visitReport.compliance.morningLockout': 'Daily planning locked until all open reports are completed.',

  // V1.3 Typeform-style visit report
  'scout.vr.submitted': 'Report submitted',
  'scout.vr.scanPrompt.title': 'Scan the order pad?',
  'scout.vr.scanPrompt.jetzt': 'Take photo now',
  'scout.vr.scanPrompt.spaeter': 'Later',
  'scout.vr.scanPrompt.noIdWarning': 'Receipt link will sync once online.',
  'scout.vr.next': 'Next',
  'scout.vr.yes': 'Yes',
  'scout.vr.no': 'No',
  'scout.vr.submit': 'Finish Visit',
  'scout.vr.access.title': 'How far did you get?',
  'scout.vr.access.noAccess': 'No access',
  'scout.vr.access.noDecisionMaker': 'Reception / Gatekeeper',
  'scout.vr.access.decisionMakerReached': 'Yes, decision-maker reached',
  'scout.vr.noAccess.title': 'Why no access?',
  'scout.vr.noAccess.business_closed': 'Closed / nobody there',
  'scout.vr.noAccess.wrong_address': 'Wrong address / moved',
  'scout.vr.noAccess.outside_hours': 'Outside business hours',
  'scout.vr.noAccess.security_clearance': 'No entry (security)',
  'scout.vr.noAccess.other': 'Other',
  'scout.vr.noAccess.otherPlaceholder': 'Enter reason...',
  'scout.vr.noAccess.otherLabel': 'No access - other reason',
  'scout.vr.noDm.title': 'What happened?',
  'scout.vr.noDm.gatekeeper_rejected': 'Gatekeeper refused',
  'scout.vr.noDm.dm_unavailable': 'Decision-maker not available',
  'scout.vr.noDm.referred_callback': 'Should call back / appointment',
  'scout.vr.noDm.other': 'Other',
  'scout.vr.noDm.otherPlaceholder': 'What happened?',
  'scout.vr.noDm.otherLabel': 'No decision maker - other reason',
  'scout.vr.conversation.title': 'How did the conversation go?',
  'scout.vr.conversation.sale': 'Sale',
  'scout.vr.conversation.demo': 'Demo',
  'scout.vr.conversation.conversation': 'Conversation',
  'scout.vr.conversation.rejected': 'Rejected',
  'scout.vr.sale.title': 'Sale Details',
  'scout.vr.sale.demoGiven': 'Was a demo given?',
  'scout.vr.sale.productsOrdered': 'Which products ordered?',
  'scout.vr.sale.estimatedValue': 'Estimated value?',
  'scout.vr.demo.title': 'Demo Details',
  'scout.vr.demo.productsPresented': 'Which products demonstrated?',
  'scout.vr.demo.productsInterested': 'Interest in which?',
  'scout.vr.demo.followUp': 'Follow-up?',
  'scout.vr.conv.title': 'Conversation Details',
  'scout.vr.conv.productsDiscussed': 'Which products discussed?',
  'scout.vr.conv.productsInterested': 'Interest in which?',
  'scout.vr.rejected.title': 'Why no interest?',
  'scout.vr.rejected.has_our_product': 'Already has our product',
  'scout.vr.rejected.has_competitor_product': 'Has competitor product',
  'scout.vr.rejected.too_expensive': 'Too expensive',
  'scout.vr.rejected.no_purchasing_authority': 'No purchasing authority',
  'scout.vr.rejected.no_conversation': 'No conversation possible',
  'scout.vr.rejected.dm_not_present': 'Decision-maker not present',
  'scout.vr.rejected.business_closed': 'Business closed',
  'scout.vr.rejected.no_cleaning_need': 'No cleaning need',
  'scout.vr.rejected.other': 'Other',
  'scout.vr.rejected.otherPlaceholder': 'Enter reason...',
  'scout.vr.rejected.otherLabel': 'Rejection - other reason',
  'scout.vr.useCases.title': 'Were the use cases correct?',
  'scout.vr.contact.title': 'Who did you meet?',
  'scout.vr.contact.takePhoto': 'Take photo',
  'scout.vr.contact.orManual': '— or —',
  'scout.vr.contact.firstName': 'First name',
  'scout.vr.contact.lastName': 'Last name',
  'scout.vr.contact.role': 'Role',
  'scout.vr.contact.isDecisionMaker': 'Decision-maker?',
  'scout.vr.contact.addPerson': '+ Add person',
  'scout.vr.contact.secondPerson': 'Additional person',
  'scout.vr.briefing.toggle': 'Toggle briefing',
  'scout.vr.briefing.demoObject': 'Demo object',
  'scout.vr.briefing.problem': 'Problem',
  'scout.vr.briefing.moreProducts': 'More products',
  'scout.vr.typeCheck.title': 'Industry type correct?',
  'scout.vr.typeCheck.unknown': 'Industry unknown',
  'scout.vr.typeCheck.yes': 'Yes, correct',
  'scout.vr.typeCheck.no': 'No, wrong',
  'scout.vr.wrapUp.title': 'Wrap-up',
  'scout.vr.wrapUp.customerStatus': 'Had previous contact?',
  'scout.vr.wrapUp.neukunde': 'First contact',
  'scout.vr.wrapUp.bekannt': 'Known',
  'scout.vr.wrapUp.visitType': 'With or without appointment?',
  'scout.vr.wrapUp.termin': 'Appointment',
  'scout.vr.wrapUp.kaltbesuch': 'Cold visit',
  'scout.vr.wrapUp.nextStep': 'Next step?',
  'scout.vr.wrapUp.send_offer': 'Send offer',
  'scout.vr.wrapUp.deliver_test': 'Deliver sample',
  'scout.vr.wrapUp.schedule_followup': 'Schedule follow-up',
  'scout.vr.wrapUp.none': 'No follow-up',
  'scout.vr.wrapUp.offerNotePlaceholder': 'e.g. products, terms...',
  'scout.vr.wrapUp.timeframe.this_week': 'This week',
  'scout.vr.wrapUp.timeframe.next_week': 'Next week',
  'scout.vr.wrapUp.timeframe.in_2_weeks': 'In 2 weeks',
  'scout.vr.wrapUp.timeframe.in_1_month': 'In 1 month',
  'scout.vr.wrapUp.timeframe.unclear': 'Unclear',
  'scout.vr.optional': 'optional',
  'scout.vr.wrapUp.notes': 'Notes (optional)',
  'scout.vr.wrapUp.notesPlaceholder': 'Additional notes about the visit...',
  'scout.vr.briefingLoading': 'Loading briefing…',
  'scout.vr.briefingErrorTitle': 'Briefing unavailable',
  'scout.vr.briefingErrorDesc': 'The briefing could not be loaded.',
  'scout.vr.questionnaireLoading': 'Loading questionnaire…',
  'scout.vr.questionnaireErrorTitle': 'Questionnaire unavailable',
  'scout.vr.questionnaireErrorDesc': 'The active questionnaire could not be loaded.',
  // NEVER-DARK: a spontaneous walk-in (joker) / not-in-mission stop has no
  // briefing. The report must still be fileable — soft inline notice, never a
  // blocking screen (BUG: joker visit-report dead-end 2026-06-17).
  'scout.vr.briefingMissingNotice': 'No briefing for this stop (e.g. a spontaneous visit). You can still fill in the report.',
  // Edit-not-resend (operator 2026-06-17): a report already exists for this
  // stop. Block a silent duplicate; let the rep open it to make changes.
  'scout.vr.alreadySubmitted.title': 'Report already submitted',
  'scout.vr.alreadySubmitted.desc': 'A report has already been filed for this visit. Open it to make changes.',
  'scout.vr.alreadySubmitted.openToEdit': 'Open & edit report',

  // DynamicSurvey — contact_block field type
  'survey.contact.name': 'Name',
  'survey.contact.namePlaceholder': 'Enter name',
  'survey.contact.function': 'Role / Function',
  'survey.contact.functionPlaceholder': 'Enter role',
  'survey.contact.email': 'Email',
  'survey.contact.emailPlaceholder': 'Enter email address',
  'survey.contact.phone': 'Phone',
  'survey.contact.phonePlaceholder': 'Enter phone number',
  'survey.contact.isDecisionMaker': 'Is decision maker?',

  // Wiedervorlagen (callback queue) — FR-RI-CALLBACK-QUEUE-V1
  'scout.wiedervorlagen.title': 'Callbacks',
  'scout.wiedervorlagen.subtitle': 'Due callbacks — sorted by "last called"',
  'scout.wiedervorlagen.hint': 'This list is for prioritisation only. Call back via the normal calling cockpit — you do not dial from here.',
  'scout.wiedervorlagen.overdue': 'Overdue',
  'scout.wiedervorlagen.col.company': 'Company',
  'scout.wiedervorlagen.col.contact': 'Contact',
  'scout.wiedervorlagen.col.lastCalledAt': 'Last called',
  'scout.wiedervorlagen.col.callbackAt': 'Callback at',
  'scout.wiedervorlagen.col.detail': 'Note / Reason',
  'scout.wiedervorlagen.col.lastOutcome': 'Last outcome',
  'scout.wiedervorlagen.col.phone': 'Phone',
  'scout.wiedervorlagen.col.status': 'Status',
  'scout.wiedervorlagen.col.actions': 'Actions',
  'scout.wiedervorlagen.call.noPhone': 'No phone number available',
  'scout.wiedervorlagen.call.notReady': 'Phone connection is being set up …',
  'scout.wiedervorlagen.action.call': 'Call',
  'scout.wiedervorlagen.action.complete': 'Done',
  'scout.wiedervorlagen.action.reschedule': 'Reschedule',
  'scout.wiedervorlagen.reschedule.label': 'New time',
  'scout.wiedervorlagen.reschedule.confirm': 'Set time',
  'scout.wiedervorlagen.empty.title': 'No callbacks',
  'scout.wiedervorlagen.empty.description': 'No callbacks are currently scheduled.',
  'scout.wiedervorlagen.error.title': 'Could not load callbacks',
  'scout.wiedervorlagen.error.contract': 'The data shape changed (contract error). Please report to the team.',
  'scout.wiedervorlagen.error.generic': 'Unexpected error loading callbacks.',
  'scout.wiedervorlagen.toast.completed': 'Callback marked as done',
  'scout.wiedervorlagen.toast.rescheduled': 'Callback rescheduled',
  'scout.wiedervorlagen.toast.writeFailed': 'Action failed — please try again',

  // PreQual Calling
  'scout.prequal.loadError': 'Error loading leads',
  'scout.prequal.sessionStale.title': 'Session expired',
  'scout.prequal.sessionStale.desc': 'This calling session has already ended. Start a new session to continue calling.',
  'scout.prequal.sessionStale.action': 'Start new session',
  'scout.prequal.startSession': 'Start session',
  'scout.prequal.skipLead': 'Skip',
  'scout.prequal.disqualifyLead': 'Disqualify',
  'scout.prequal.disqualify.title': 'Disqualify lead',
  'scout.prequal.disqualify.confirm': 'Disqualify',

  // PreQual Calling V2 (Live Phone — live transcript surface)
  'scout.prequalV2.title': 'Pre-Qual Calling',
  'scout.prequalV2.layout': 'Layout:',
  'scout.prequalV2.loading': 'Loading calling cockpit…',
  'scout.prequalV2.muted': 'Muted',
  'scout.prequalV2.queue': 'Queue',
  'scout.prequalV2.leadProfile': 'Lead profile',
  'scout.prequalV2.projection': 'DEC-012 projection',
  'scout.prequalV2.phone': 'Phone',
  'scout.prequalV2.location': 'Location',
  'scout.prequalV2.employees': 'Employees',
  'scout.prequalV2.website': 'Website',
  'scout.prequalV2.tradeDescription': 'Trade',
  'scout.prequalV2.revenue': 'Revenue',
  'scout.prequalV2.founded': 'Founded',
  'scout.prequalV2.score': 'Score',
  'scout.prequalV2.liveTranscript': 'Live transcript',
  'scout.prequalV2.transcriptBeta': 'Beta — Deepgram',
  'scout.prequalV2.transcriptEmpty': 'Waiting for the call to start…',
  'scout.prequalV2.speakerAgent': 'You',
  'scout.prequalV2.speakerCustomer': 'Customer',
  'scout.prequalV2.spinGuide': 'SPIN guide',
  'scout.prequalV2.outcomeLabel': 'Outcome',
  'scout.prequalV2.outcomeAppointment': 'Appointment booked',
  'scout.prequalV2.outcomeNoInterest': 'Not interested',
  'scout.prequalV2.outcomeCallback': 'Callback requested',
  'scout.prequalV2.outcomeNotReached': 'Not reached',
  'scout.prequalV2.outcomeQualified': 'Qualified',
  'scout.prequalV2.notes': 'Note',
  'scout.prequalV2.notesPlaceholder': 'Call note…',
  'scout.prequalV2.mute': 'Mute',
  'scout.prequalV2.unmute': 'Unmute',
  'scout.prequalV2.hold': 'Hold',
  'scout.prequalV2.resumeHold': 'Resume',
  'scout.prequalV2.transfer': 'Transfer',
  'scout.prequalV2.end': 'End',
  'scout.prequalV2.logAndNext': 'Log & next',
  'scout.prequalV2.expose': 'Exposé',
  'scout.prequalV2.exposePending': 'Research is being prepared…',
  'scout.prequalV2.exposePredictedProduct': 'Predicted product',
  'scout.prequalV2.exposeObjects': 'Objects',
  'scout.prequalV2.exposeContamination': 'Contamination',
  'scout.prequalV2.exposeDmToAskFor': 'Decision maker',
  'scout.prequalV2.exposeUseCases': 'Use cases',
  'scout.prequalV2.exposeOpeningQuestion': 'Opening question',
  'scout.prequalV2.exposeProbeQuestions': 'Probe questions',
  'scout.prequalV2.autoDial': 'Auto-dialer',
  'scout.prequalV2.autoDialOn': 'Auto-dialer enabled',
  'scout.prequalV2.autoDialOff': 'Auto-dialer disabled',
  'scout.prequalV2.on': 'On',
  'scout.prequalV2.off': 'Off',
  'scout.prequal.noLeads': 'No leads available',
  'scout.prequal.callerProfileUnresolved': 'Caller profile not fully loaded — call list may be limited. Calls/session can only start once it has fully loaded.',
  'scout.prequal.queueDegraded': 'Lead preview is currently limited — one campaign failed to load. Calls in your other campaigns still work.',
  'scout.prequal.startBlockedUnresolved': 'Profile not resolved',

  // ── Calling-session start: the rep-facing truth when NO session was started
  //    (BUG-FE-CALLING-SESSION-SILENT-SKIP-2026-07-27). Each message names
  //    (a) what happened, (b) the consequence — no leads are loaded — and
  //    (c) the next step. Loud AND recoverable.
  'scout.prequal.sessionStart.title': 'Session not started.',
  'scout.prequal.sessionStart.noAssignedCampaigns': 'You have no campaign assigned. No calling session was started and no leads will load. Please contact your manager.',
  'scout.prequal.sessionStart.noActiveCampaign': 'None of your assigned campaigns is active — all are archived. No calling session was started and no leads will load. Please contact your manager.',
  'scout.prequal.sessionStart.campaignNotActive': 'The selected campaign is no longer active (archived). No calling session was started and no leads will load. Please select an active campaign.',
  'scout.prequal.sessionStart.campaignUnknown': 'The selected campaign is not assigned to you. No calling session was started and no leads will load. Please select a campaign from your list.',
  'scout.prequal.sessionStart.ambiguousCampaign': 'No campaign is selected. No calling session was started and no leads will load. Please select a campaign first.',
  'scout.prequal.sessionStart.startFailed': 'The calling session could not be started on the server. No leads will load. Please try again.',
  'scout.prequal.sessionStart.noSessionId': 'The server returned no session ID — the calling session is not active and no leads will load. Please try again.',
  'scout.prequal.sessionStart.pickCampaign': 'Select campaign',
  'scout.prequal.sessionStart.retry': 'Try again',

  'scout.prequal.sessionDoneTitle': 'Session complete',
  'scout.prequal.sessionDoneSubtitle': 'All leads for today have been processed.',
  'scout.prequal.restartSession': 'Start new session',
  'scout.prequal.statsCalls': 'Calls',
  'scout.prequal.statsReached': 'Reached',
  'scout.prequal.saveAndNext': 'Save & Next',
  'scout.prequal.role': 'Role',
  'scout.prequal.availability': 'Availability',
  'scout.prequal.directPhone': 'Direct phone',
  'scout.prequal.email': 'Email',
  'scout.prequal.addressStreet': 'Street',
  'scout.prequal.addressPostalCode': 'Postal code',
  'scout.prequal.addressCity': 'City',
  'scout.prequal.companyName': 'Company',
  'scout.prequal.leadId': 'Lead-ID',
  'scout.prequal.notes': 'Notes',
  'scout.prequal.callNotesPlaceholder': 'Call notes…',
  'scout.prequal.leadHistory.title': 'Lead history',
  'scout.prequal.leadHistory.loading': 'Loading prior call data…',
  'scout.prequal.leadHistory.error': 'Could not load lead history.',
  'scout.prequal.leadHistory.empty': 'No prior calls for this lead.',
  'scout.prequal.leadHistory.lastOutcome': 'Last outcome',
  'scout.prequal.leadHistory.notes': 'Notes from last call',
  'scout.prequal.leadHistory.when': 'When',
  'scout.prequal.callHistory.title': 'Call history',
  'scout.prequal.callHistory.loading': 'Loading call history…',
  'scout.prequal.callHistory.error': 'Could not load call history.',
  'scout.prequal.callHistory.empty': 'No prior calls for this lead.',
  'scout.prequal.callHistory.dial': 'Call',
  'scout.prequal.disqualificationReason': 'Disqualification reason',
  'scout.prequal.savedNextLoading': 'Saved — Loading next lead',
  'scout.prequal.saveFailed': 'Save failed',
  'scout.prequal.saveFailedDesc': 'Your inputs are still here. Please try again.',
  'scout.prequal.retrySave': 'Retry save',
  'scout.calling.lobbyTitle': 'Ready for the next session',
  'scout.calling.saveAndNext': 'Save and continue',
  'scout.calling.pullNext': 'Pull next lead',
  'scout.calling.backToDashboard': 'Back to Scout Dashboard',
  'scout.calling.objectionsHeard': 'Objections heard',
  'scout.calling.evaluation': 'Evaluation',
  'scout.calling.isDecisionMaker': 'Decision maker?',
  'scout.calling.interestLevel': 'Interest',
  'scout.calling.yes': 'Yes',
  'scout.calling.no': 'No',
  'scout.calling.unknown': 'Unknown',
  'scout.calling.callbackTime': 'Callback time',
  'scout.calling.callbackHint': 'When should we call back?',
  'scout.calling.disqualifiedReasons': 'Disqualification — reasons',
  'scout.calling.transportHealth.unstable': 'Voice connection unstable — refresh the page if calls don\'t start.',
  'scout.calling.transportHealth.dismiss': 'Dismiss',
  'scout.prequal.objections': 'Objections',
  'scout.prequal.noLeadSelected': 'No lead selected',
  'scout.prequal.selectIndustryForClusters': 'Select an industry to load clusters',
  'scout.prequal.clustersLoading': 'Loading clusters…',
  'scout.prequal.clustersLoadError': 'Clusters could not be loaded — please reload the page (Ctrl+Shift+R)',
  'scout.prequal.cockpit.calls': 'Calls',
  'scout.prequal.cockpit.reached': 'Reached',
  'scout.prequal.cockpit.qualified': 'Qualified',
  'scout.prequal.cockpit.conversionRate': 'Rate',
  'scout.prequal.cockpit.exitSession': 'Leave session',
  'scout.prequal.cockpit.saveAndNext': 'Save & Next',
  'scout.prequal.cockpit.interestLevel': 'Interest',
  'scout.prequal.cockpit.facility': 'Has facility?',
  'scout.prequal.cockpit.facilityYes': 'Yes',
  'scout.prequal.cockpit.facilityNo': 'No',
  'scout.prequal.cockpit.facilityUnknown': 'Unknown',
  'scout.prequal.cockpit.gatekeeperPassed': 'Past gatekeeper?',
  'scout.prequal.cockpit.competitor': 'Competitor',
  'scout.prequal.cockpit.competitorPlaceholder': 'e.g. Würth, Dr. Schnell',
  'scout.prequal.callStats.title': 'Your calls today',
  'scout.prequal.callStats.calls': 'Calls',
  'scout.prequal.callStats.reached': 'Reached',
  'scout.prequal.callStats.qualified': 'Qualified',
  'scout.prequal.callStats.notReached': 'Not reached',
  'scout.prequal.callStats.reachedRate': 'Reached rate',
  'scout.prequal.voice.connecting': 'Connecting…',
  'scout.prequal.transcript.title': 'Live Transcript',
  'scout.prequal.transcript.waiting': 'Waiting for call to start…',
  'scout.prequal.transcript.extracted': 'Extracted Data',
  'scout.prequal.lastNamePlaceholder': 'Smith',
  'scout.prequal.selectDate': 'Select date',
  'scout.prequal.onboardingTitle': 'Welcome to PreQual',
  'scout.prequal.onboardingStart': 'Let\'s go',
  'scout.prequal.onboardingDismiss': 'Don\'t show again',
  'scout.prequal.leadsLabel': 'Leads in queue',
  'scout.prequal.openLeadsLabel': 'open leads',
  'scout.prequal.leadsTable.heading': 'Leads in this campaign',
  'scout.prequal.leadsTable.company': 'Company',
  'scout.prequal.leadsTable.orders': 'Orders',
  'scout.prequal.leadsTable.revenue': 'Revenue',
  'scout.prequal.leadsTable.products': 'Products',
  'scout.prequal.leadsTable.contact': 'Contact',
  'scout.prequal.leadsTable.phone': 'Phone',
  'scout.prequal.leadsTable.status': 'Status',
  'scout.prequal.leadsTable.lastCall': 'Last call',
  'scout.prequal.leadsTable.callbackAt': 'Callback at',
  'scout.prequal.leadsTable.attempts': 'Attempts',
  'scout.prequal.leadsTable.grabAndCall': 'Grab & call',
  'scout.prequal.leadsTable.error': 'Could not load leads',
  'scout.prequal.leadsTable.empty': 'No leads in this campaign.',
  'scout.prequal.leadsTable.filterAll': 'All',
  'scout.prequal.leadsTable.filterOpen': 'Open',
  'scout.prequal.leadsTable.filterCallback': 'Callback',
  'scout.prequal.leadsTable.filterBestandskunde': 'Existing customer',
  'scout.prequal.leadsTable.statusCallback': 'Callback',
  'scout.prequal.leadsTable.statusNotReached': 'Not reached yet',
  'scout.prequal.leadsTable.statusNeverTried': 'Never tried',
  'scout.prequal.leadsTable.phonesHeading': 'Phone numbers',
  'scout.prequal.leadsTable.phoneCentral': 'Main',
  'scout.prequal.leadsTable.phoneContact': 'Direct line',
  'scout.prequal.leadsTable.phoneGoogle': 'Google',
  'scout.prequal.leadsTable.industry': 'Industry',
  'scout.prequal.leadsTable.firma': 'Company',
  'scout.prequal.leadsTable.location': 'Location',
  'scout.prequal.leadsTable.employees': 'Employees',
  'scout.prequal.leadsTable.note': 'Note',
  'scout.prequal.leadsTable.bestandskunde': 'Existing customer',
  'scout.prequal.leadsTable.bestandskundeYes': 'Existing customer',
  'scout.prequal.callbacks.button': 'Callbacks',
  'scout.prequal.callbacks.heading': 'Due callbacks',
  'scout.prequal.callbacks.empty': 'No callbacks in this campaign.',
  'scout.prequal.callbacks.due': 'Callback',
  'scout.prequal.callbacks.lastCall': 'Last',
  'scout.prequal.pinned.backToLobby': 'Back to lobby',
  'scout.prequal.pinned.resumeCampaign': 'Resume campaign',
  'info.products.title': 'Product Catalog',
  'info.products.description': 'All CLANDA products at a glance.',
  'info.products.noDescription': 'Product description coming soon.',
  'info.industries.title': 'Industry Overview',
  'info.industries.description': 'All customer segments and industry codes.',
  'scout.prequal.duration': 'Duration',
  'scout.prequal.summary.verifyCompany': 'Verify company data',
  'scout.prequal.interestRequired': 'Please set interest level',
  'scout.customers.title': 'Customers',
  'scout.customers.subtitle': 'RFM analysis of your customers',
  'scout.customers.loadError': 'Could not load customer data',
  'scout.customers.table.customer': 'Customer',
  'scout.customers.table.rfmScore': 'RFM Score',
  'scout.customers.table.segment': 'Segment',
  'scout.customers.table.recency': 'Last (days)',
  'scout.customers.table.frequency': 'Frequency',
  'scout.customers.table.monetary': 'Revenue',
  'scout.dailyPlanning.cityCompletion': 'City Completion',
  'scout.dailyPlanning.endDay': 'End Day',
  'scout.dailyPlanning.endDayConfirm': 'End day and submit mission for review?',
  'scout.dailyPlanning.reviewRequested': 'Mission submitted for review',
  'scout.dailyPlanning.reviewFailed': 'Could not update mission status',
  'scout.dailyPlanning.missionStatus.draft': 'Draft',
  'scout.dailyPlanning.missionStatus.planned': 'Planned',
  'scout.dailyPlanning.missionStatus.inProgress': 'Active',
  'scout.dailyPlanning.missionStatus.done': 'Done',
  'prequal.industryCheatSheet': 'Industry Overview',
  'prequal.industry.confirm': 'Confirm',
  'scout.missions.wunschliste.noPostalCodes': 'No postal code areas added yet.',
  'scout.missions.wunschliste.addPostalCode': 'Add postal code',
  'scout.missions.wunschliste.add': 'Add',
  'scout.missionControl.teamSteering.globalNotesPlaceholder': 'e.g. Trade conflict — reduce oil products',
  'styleGuide.hover.toggleSwitch': 'Toggle / Switch',
  'styleGuide.hover.trackLightens': 'Track lightens slightly',
  'sync.syncing': 'Syncing…',
  'sync.offline': 'Offline',
  'sync.queued': 'queued',
  'scout.missionControl.live.prevWeek': 'Previous week',
  'scout.missionControl.live.nextWeek': 'Next week',
  'scout.missionControl.live.currentWeek': 'Current week',

  // ── ATC / Commander Bridge ──────────────────────────────────────────────
  'nav.atc': 'ATC',
  'nav.atc.bridge': 'Commander Bridge',
  'nav.atc.docs': 'Doc Search',

  // Registry list (/atc/bridge/agents/registry)
  'atc.registry.list.hint': 'Tap a row to open the full audit.',

  // Registry shell (identity-first master/detail, R1)
  'atc.registry.shell.title': 'Agents',
  'atc.registry.shell.subtitle': '{{count}} personas — identity-first registry',
  'atc.registry.shell.filterAll': 'All',
  'atc.registry.shell.filterLive': 'Live',
  'atc.registry.shell.selectTitle': 'Select an agent',
  'atc.registry.shell.selectDesc': 'Choose a persona in the list to view the identity stack.',
  'atc.registry.shell.pendingTitle': 'Identity stack pending',
  'atc.registry.shell.pendingDesc':
    'SL FR-RG1 (/v1/agents/{id}/identity-docs) is not live yet. Wave 2 fills the content.',
  'atc.registry.shell.backLabel': 'Back to list',
  'atc.registry.shell.liveCount': '{{count}} live',
  'atc.registry.shell.errorTitle': 'Registry unavailable',
  'atc.registry.shell.emptyTitle': 'No agents registered',
  'atc.registry.shell.emptyDesc': 'There are no personas in the registry.',
  'atc.registry.shell.scaffoldingMessage': 'Registry rebuilding (V14). Sortie S4 in preparation.',
  'atc.registry.column.agent': 'Agent',
  'atc.registry.column.shorthandle': 'Shorthandle',
  'atc.registry.column.status': 'Status',
  'atc.registry.column.live': 'Live',
  'atc.registry.column.turns': 'Turns',
  'atc.registry.column.replies': 'Replies',
  'atc.registry.column.idle': 'Idle',
  'atc.registry.column.branch': 'Branch',
  'atc.registry.column.model': 'Model',
  'atc.registry.column.repo': 'Repo',
  'atc.registry.column.lastActivity': 'Last activity',
  'atc.registry.column.liveCount': 'Live count',
  'atc.registry.column.ctxPercent': 'CTX %',
  'atc.registry.drawer.title': 'Agent details',
  'atc.registry.drawer.tab.uebersicht': 'Overview',
  'atc.registry.drawer.tab.aktivitaet': 'Activity',
  'atc.registry.drawer.tab.arbeit': 'Work',
  'atc.registry.drawer.tab.prs': 'PRs',
  'atc.registry.drawer.tab.dokumente': 'Documents',
  'atc.registry.drawer.action.openChat': 'Open chat (J)',
  'atc.registry.drawer.action.pauseEmbodiment': 'Pause embodiment (P)',
  'atc.registry.drawer.action.restart': 'Trigger restart (R)',
  'atc.registry.drawer.action.openInRepo': 'Open in repo (G)',
  'atc.registry.drawer.action.close': 'Close (Esc)',
  'atc.registry.tooltip.ctxPending': 'Pending session_host instrumentation',
  'atc.registry.viewToggle.flat': 'Flat',
  'atc.registry.viewToggle.byRepo': 'By Repo',
  'atc.registry.viewToggle.byOwner': 'By Owner',
  'atc.registry.viewToggle.byPersona': 'By Persona',
  'atc.registry.savedView.all': 'All',
  'atc.registry.savedView.live': 'Live',
  'atc.registry.savedView.idle': 'Idle',
  'atc.registry.savedView.stuck': 'Stuck',
  'atc.registry.savedView.cloud': 'Cloud lane',
  'atc.registry.savedView.local': 'Local lane',
  'atc.registry.toolbar.filter': 'Filter',
  'atc.registry.toolbar.addPersona': 'Persona',
  'atc.registry.toolbar.searchPlaceholder': 'Search…',
  'atc.registry.profile.tabs.uebersicht': 'Overview',
  'atc.registry.profile.tabs.aktivitaet': 'Activity',
  'atc.registry.profile.tabs.arbeit': 'Work',
  'atc.registry.profile.tabs.prs': 'PRs',
  'atc.registry.profile.tabs.dokumente': 'Docs',
  'atc.registry.profile.kv.shorthandle': 'Shorthandle',
  'atc.registry.profile.kv.agentId': 'agent_id',
  'atc.registry.profile.kv.repo': 'Repo',
  'atc.registry.profile.kv.branch': 'Branch',
  'atc.registry.profile.kv.model': 'Model',
  'atc.registry.profile.kv.created': 'Created',
  'atc.registry.profile.section.embodiments': 'Embodiments',
  'atc.registry.profile.section.work': 'Current work',
  'atc.registry.profile.section.timeline': 'Latest activity',
  'atc.registry.profile.work.empty': 'No active work',
  'atc.registry.taskStatus.aktiv': 'ACTIVE',
  'atc.registry.taskStatus.review': 'REVIEW',
  'atc.registry.taskStatus.blockiert': 'BLOCKED',
  'atc.registry.actions.chat': 'Chat',
  'atc.registry.actions.logs': 'Logs',
  'atc.registry.actions.kill': 'Kill',
  'atc.registry.actions.killConfirm': 'Kill agent {{handle}}? This terminates every live embodiment.',
  'atc.registry.actions.killEmbodimentConfirm': 'Kill embodiment {{handle}}?',
  'atc.registry.empty.notProjected': 'Not yet projected — pending SL {{fr}}',
  'atc.registry.profile.signals.loadError': 'Failed to load signals',
  'atc.registry.profile.work.loadError': 'Failed to load work items',
  'atc.registry.profile.prs.loadError': 'Failed to load PRs',
  'atc.registry.profile.docs.loadError': 'Failed to load documents',
  'atc.registry.profile.loadError.desc': 'Load error — please retry.',
  'atc.registry.detailV2.section.identityStack': 'Identity stack',
  'atc.registry.detailV2.section.persona': 'Persona',
  'atc.registry.detailV2.section.embodiments': 'Embodiments',
  'atc.registry.detailV2.section.flightRights': 'Flight rights',
  'atc.registry.detailV2.section.pearlChain': 'Pearl chain',
  'atc.registry.detailV2.pearlChain.title': 'Title',
  'atc.registry.detailV2.pearlChain.type': 'Type',
  'atc.registry.detailV2.pearlChain.lifecycle': 'Lifecycle',
  'atc.registry.detailV2.pearlChain.priority': 'Priority',
  'atc.registry.detailV2.pearlChain.emptyTitle': 'No Pearl chain entries',
  'atc.registry.detailV2.pearlChain.emptyDesc': 'No manifest entries are assigned to this persona.',
  'atc.registry.detailV2.section.signals': 'Recent signals',
  'atc.registry.detailV2.identity.systemPrompt': 'System Prompt',
  'atc.registry.detailV2.identity.bootstrap': 'Bootstrap',
  'atc.registry.detailV2.identity.workingDoc': 'Working Doc',
  'atc.registry.detailV2.identity.compositionPlaceholder': 'composition (1 doc · 0 snippets)',
  'atc.registry.detailV2.identity.emptyTitle': 'Identity stack not registered',
  'atc.registry.detailV2.identity.emptyDesc':
    'No System Prompt / Bootstrap / Working Doc registered for this persona. File a request with god-mode.',
  'atc.registry.detailV2.persona.notFound': 'Persona row not found in /v1/agents',
  'atc.registry.detailV2.embodiments.spawn': 'Spawn new embodiment',
  'atc.registry.detailV2.embodiments.spawnSubmit': 'Spawn',
  'atc.registry.detailV2.embodiments.initialMessage': 'Initial message (optional)',
  'atc.registry.detailV2.embodiments.shorthandle': 'shorthandle',
  'atc.registry.detailV2.embodiments.vendor': 'vendor',
  'atc.registry.detailV2.embodiments.machine': 'machine',
  'atc.registry.detailV2.embodiments.startedAt': 'started_at',
  'atc.registry.detailV2.embodiments.endedAt': 'ended_at',
  'atc.registry.detailV2.embodiments.lastSeenAt': 'last_seen_at',
  'atc.registry.detailV2.embodiments.branch': 'branch',
  'atc.registry.detailV2.embodiments.model': 'model',
  'atc.registry.detailV2.embodiments.ctxPct': 'ctx %',
  'atc.registry.detailV2.embodiments.lastActivity': 'last activity',
  'atc.registry.detailV2.embodiments.actions': 'Actions',
  'atc.registry.detailV2.embodiments.kill': 'Kill',
  'atc.registry.detailV2.embodiments.restart': 'Restart',
  'atc.registry.detailV2.embodiments.empty': 'No embodiments found for this persona.',
  'atc.registry.detailV2.embodiments.live': 'Live',
  'atc.registry.detailV2.embodiments.retired': 'Retired',
  'atc.registry.detailV2.flightRights.identitiesPrefix': 'Agent identities — for human user identity →',
  'atc.registry.detailV2.pendingEndpoint': 'SL endpoint pending — FR-RG2',
  'atc.registry.detailV2.signals.expand': 'Show recent signals (last 20)',
  'atc.registry.detailV2.signals.empty': 'No signals available.',

  // Registry detail (/atc/bridge/agents/registry/:agentId)
  'atc.registry.detail.back': 'Back',
  'atc.registry.detail.fallbackTitle': 'Registry detail',
  'atc.registry.detail.unavailableTitle': 'Registry unavailable',
  'atc.registry.detail.payloadInvalid': 'The registry response did not match the expected shape.',
  'atc.registry.detail.personaNotFoundTitle': 'Persona not found',
  'atc.registry.detail.emptyValue': '—',
  'atc.registry.detail.section.persona': 'Persona',
  'atc.registry.detail.section.embodiments': 'Embodiments',
  'atc.registry.detail.section.daemon': 'Daemon status',
  'atc.registry.detail.section.replies': 'Signals — Replies',
  'atc.registry.detail.section.narration': 'Signals — Narration',
  'atc.registry.detail.section.decisions': 'Signals — Decisions',
  'atc.registry.detail.section.escalations': 'Signals — Escalations',
  'atc.registry.detail.section.pinnedDocs': 'Pinned docs',
  'atc.registry.detail.section.auditLog': 'Audit log',
  'atc.registry.detail.section.serviceAccounts': 'Service accounts',
  'atc.registry.detail.field.agent_id': 'agent_id',
  'atc.registry.detail.field.shorthandle': 'shorthandle',
  'atc.registry.detail.field.display_name': 'display_name',
  'atc.registry.detail.field.vendor': 'vendor',
  'atc.registry.detail.field.repo': 'repo',
  'atc.registry.detail.field.status': 'status',
  'atc.registry.detail.status.alive': 'alive',
  'atc.registry.detail.status.dead': 'dead',
  'atc.registry.detail.field.embodiment_id': 'embodiment_id',
  'atc.registry.detail.field.session_id': 'session_id',
  'atc.registry.detail.field.location': 'location',
  'atc.registry.detail.field.machine': 'machine',
  'atc.registry.detail.field.started_at': 'started_at',
  'atc.registry.detail.field.last_activity_at': 'last_activity_at',
  'atc.registry.detail.field.branch': 'branch',
  'atc.registry.detail.field.model': 'model',
  'atc.registry.detail.field.turns': 'turns',
  'atc.registry.detail.field.replies': 'replies',
  'atc.registry.detail.field.ctx_pct': 'ctx_pct',
  'atc.registry.detail.field.current_task_ref': 'current_task_ref',
  'atc.registry.detail.field.source': 'source',
  'atc.registry.detail.copy': 'Copy to clipboard',
  'atc.registry.detail.copied': 'Copied',
  'atc.registry.detail.embodimentsEmpty': 'No live embodiments for this persona.',
  'atc.registry.detail.daemonNoRow': 'No daemon row for this persona',
  'atc.registry.detail.daemonNoRowDesc': 'The local daemon status table has no row matching this agent.',
  'atc.registry.detail.daemonBranch': 'branch',
  'atc.registry.detail.daemonContext': 'context_pct',
  'atc.registry.detail.daemonPushAge': 'push_age_min',
  'atc.registry.detail.daemonCi': 'ci_status',
  'atc.registry.detail.daemonHeartbeat': 'heartbeat (daemon updated_at)',
  'atc.registry.detail.repliesEmpty': 'No reply signals for this filter.',
  'atc.registry.detail.narrationEmpty': 'No narration stream entries for this persona.',
  'atc.registry.detail.decisionsEmpty': 'No decision signals for this persona.',
  'atc.registry.detail.escalationsEmpty': 'No escalation signals for this persona.',
  'atc.registry.detail.decisionExpiry': 'expiry',
  'atc.registry.detail.openDoc': 'Open linked doc',
  'atc.registry.detail.pinnedDocs.empty': 'No governance docs list this agent in frontmatter consumers.',
  'atc.registry.detail.pinnedDocs.unpin': 'Unpin',
  'atc.registry.detail.pinnedDocs.unpinFailedTitle': 'Unpin failed',
  'atc.registry.detail.escalationResolved': 'Resolved',
  'atc.registry.detail.escalationOpen': 'Open',
  'atc.registry.detail.placeholder.pinnedDocs':
    'Legacy copy — pinned docs now load live via GET /v1/agents/:id/docs (FR-A).',
  'atc.registry.detail.placeholder.auditLog':
    'Needs SL FR-B — GET /v1/agents/:id/audit returns [{actor, action, target_field, before, after, at}] from a new append-only agent_audit_log table. Tracked in MO v9 §FR-B (P2).',
  'atc.registry.detail.placeholder.serviceAccounts':
    'Managed in the service-accounts console (separate track). Per Commander 2026-05-03: "flight rights is for later, we do with service accounts."',

  // Tabs
  'atc.bridge.tabs.manifest': 'Manifest',
  'atc.bridge.tabs.highlights': 'Highlights',
  'atc.bridge.tabs.health': 'Health',
  'atc.bridge.tabs.prs': 'PRs',
  'atc.bridge.tabs.staging': 'Staging',
  'atc.bridge.tabs.escalations': 'Escalations',
  'atc.bridge.tabs.triggers': 'Triggers',
  'atc.bridge.tabs.registry': 'Registry',
  'atc.bridge.tabs.heartbeat': 'Heartbeat',
  'atc.bridge.tabs.chat': 'Chat',
  'atc.bridge.tabs.wiki': 'Wiki',

  // Bridge IA v2 shell (grouped nav + Wiki)
  'atc.bridge.groups.operations': 'Operations',
  'atc.bridge.groups.repos': 'Repos',
  'atc.bridge.groups.agents': 'Agents',
  'atc.bridge.groups.wiki': 'Wiki',
  'atc.bridge.groupsNav.ariaLabel': 'Bridge areas',
  'atc.bridge.subNav.ariaLabel': 'Bridge section',
  'atc.bridge.subNav.label': 'Section',

  // Workright grant / revoke / scope-request — FR-FE-AGENT-CONSOLE-V1 Wave 2,
  // SL ticket §2.G2. Per-error_code keys mirror the typed enums in
  // useGrantWorkright/useRevokeWorkright/useRequestScope.
  'atc.bridge.workright.grant.title': 'Grant workright',
  'atc.bridge.workright.grant.description':
    'Authorize scope globs for an agent embodiment. Validation and persistence happen in Server Logic.',
  'atc.bridge.workright.grant.submit': 'Grant',
  'atc.bridge.workright.grant.cancel': 'Cancel',
  'atc.bridge.workright.grant.successToast': 'Workright granted.',
  'atc.bridge.workright.grant.field.agent_id': 'Agent ID',
  'atc.bridge.workright.grant.field.embodiment_id': 'Embodiment ID (optional)',
  'atc.bridge.workright.grant.field.manifest_entry_id': 'Manifest entry (optional)',
  'atc.bridge.workright.grant.field.scope_globs': 'Scope globs (comma-separated or one per line)',
  'atc.bridge.workright.grant.field.expires_at': 'Expires at',
  'atc.bridge.workright.grant.field.permanent_auto_renew': 'Permanent, auto-renew',
  'atc.bridge.workright.grant.field.granted_reason': 'Reason',
  'atc.bridge.workright.grant.field.verify_token': 'Verify token (optional)',
  // Grant error_code enum (11 codes) — SL §2.G2 §2.2 grant.
  'atc.bridge.workright.error.WORKRIGHT_NOT_FOUND': 'Workright not found.',
  'atc.bridge.workright.error.WORKRIGHT_REVOKED': 'Workright already revoked.',
  'atc.bridge.workright.error.WORKRIGHT_EXPIRED': 'Workright has expired.',
  'atc.bridge.workright.error.EMBODIMENT_NOT_FOUND': 'Embodiment not found.',
  'atc.bridge.workright.error.EMBODIMENT_NOT_ACTIVE': 'Embodiment is not active.',
  'atc.bridge.workright.error.ALREADY_ASSIGNED': 'Scope already assigned.',
  'atc.bridge.workright.error.VERIFY_MISMATCH': 'Verify token did not match.',
  'atc.bridge.workright.error.GRANT_WRITE_FAILED':
    'Verify-after-write failed — the grant was not persisted.',
  'atc.bridge.workright.error.FORBIDDEN': 'Not allowed.',
  'atc.bridge.workright.error.MANIFEST_ENTRY_NOT_FOUND': 'Manifest entry not found.',
  'atc.bridge.workright.error.INVALID_SCOPE_FORMAT': 'Invalid scope glob format.',
  // Scope-request error_code enum (6 codes) — SL §2.G2 §2.2 scope-request.
  'atc.bridge.workright.error.INVALID_TARGET_FORMAT': 'Invalid target format.',
  'atc.bridge.workright.error.RATE_LIMIT_EXCEEDED': 'Rate limit exceeded — try again later.',
  'atc.bridge.workright.error.SCOPE_REJECTED': 'Scope rejected.',
  'atc.bridge.workright.error.INTERNAL': 'Internal error — please retry.',

  // Doc search page (/atc/docs)
  'atc.docs.title': 'Doc Search',
  'atc.docs.reset': 'Reset',
  'atc.docs.uuidDetected': 'UUID detected — direct lookup running in parallel with full-text search.',
  'atc.docs.col.changed': 'Updated',
  'atc.docs.openInDocStore': 'Open in doc store',
  'atc.wiki.sidebar.sections.types': 'Doc Types',
  'atc.wiki.sidebar.sections.repos': 'Repos',
  'atc.wiki.sidebar.searchPlaceholder': 'Search title or UUID…',
  'atc.wiki.sidebar.searchAria': 'Search term',
  'atc.wiki.sidebar.mobile.typeAria': 'Type filter',
  'atc.wiki.sidebar.mobile.repoAria': 'Repo filter',
  'atc.wiki.sidebar.mobile.typePlaceholder': 'Type',
  'atc.wiki.sidebar.mobile.repoPlaceholder': 'Repo',
  'atc.wiki.sidebar.mobile.allTypes': 'All types',
  'atc.wiki.sidebar.mobile.allRepos': 'All repos',
  'atc.wiki.sidebar.transitionalHint':
    'Bucket browse is transitional until SL FR-WK1/2/3 ships. Counts use (?) placeholders and results use search fallback.',
  'atc.wiki.sidebar.emptyFiltered': 'No documents found for selected bucket filters',
  'atc.wiki.sidebar.emptyFilteredDesc':
    'Try adding a search term or adjusting type/repo filters.',
  'atc.wiki.sidebar.types.dogma': 'Dogmas',
  'atc.wiki.sidebar.types.systemPrompt': 'System Prompts',
  'atc.wiki.sidebar.types.bootstrap': 'Bootstraps',
  'atc.wiki.sidebar.types.workingDoc': 'Working Docs',
  'atc.wiki.sidebar.types.skill': 'Skills',
  'atc.wiki.sidebar.types.adr': 'ADRs',
  'atc.wiki.sidebar.types.mo': 'MOs',
  'atc.wiki.sidebar.types.sortie': 'Sorties',
  'atc.wiki.sidebar.types.fr': 'FRs',
  'atc.wiki.sidebar.types.libraryCard': 'Library Cards',
  'atc.wiki.sidebar.types.audit': 'Audits',
  'atc.wiki.sidebar.types.runbook': 'Runbooks',
  'atc.wiki.sidebar.types.assessment': 'Assessments',
  'atc.wiki.sidebar.types.governance': 'Governance',
  'atc.wiki.sidebar.types.other': 'Other',
  'atc.wiki.filters.status': 'Status',
  'atc.wiki.filters.repo': 'Repo',
  'atc.wiki.filters.tag': 'Tag',
  'atc.wiki.filters.searchChip': 'Title',
  'atc.wiki.filters.allTags': 'All tags',
  'atc.wiki.table.col.document': 'Document',
  'atc.wiki.table.col.updated': 'Updated',
  'atc.wiki.table.sortAria': 'Toggle sort',

  // Doc detail page (/atc/docs/:id) — full-width reader.
  'atc.docs.detail.back': 'Back to search',
  'atc.docs.detail.frontmatter': 'Frontmatter',
  'atc.docs.detail.body': 'Body',
  'atc.docs.detail.notFound': 'Document not found',
  'atc.docs.detail.notFoundDesc': 'The UUID returned no row from the doc store. The document may have been retired or the id is wrong.',
  'atc.docs.detail.emptyBody': 'This document has no body — only frontmatter.',
  'atc.docs.detail.invalidId': 'The id is not a valid UUID.',
  'atc.docs.edit.action': 'Edit',
  'atc.docs.edit.actionAria': 'Edit document body',
  'atc.docs.edit.editorAria': 'Document body (markdown)',
  'atc.docs.edit.placeholder': 'Markdown body…',
  'atc.docs.edit.save': 'Save',
  'atc.docs.edit.saving': 'Saving…',
  'atc.docs.edit.cancel': 'Cancel',
  'atc.docs.edit.successToast': 'Document saved',
  'atc.docs.edit.error': 'Save failed — the document was not changed.',
  'atc.wiki.docNotFoundDetail': 'Document with id "{{id}}" not found. It may have been deleted or moved.',
  'atc.bridge.notFound.title': 'Page not found',
  'atc.bridge.notFound.desc': 'This Bridge route does not exist. Pick a tab above or return to the manifest.',
  'atc.bridge.notFound.action': 'Go to manifest',

  // Wiki namespace selector (atc | clanda). Cross-namespace doc reach is an
  // SL dependency — see BUG-FE-BRIDGE-WIKI-NAMESPACE-LIMITED. The clanda
  // option surfaces an explicit "not yet available" notice rather than
  // silently serving atc data (D-33 R1: no silent failures).
  'atc.wiki.namespace.label': 'Namespace',
  'atc.wiki.namespace.atc': 'ATC (platform)',
  'atc.wiki.namespace.clanda': 'CLANDA (tenant)',
  'atc.wiki.namespace.aria': 'Doc store namespace',
  'atc.wiki.namespace.pendingTitle': 'CLANDA namespace not yet reachable',
  'atc.wiki.namespace.pendingDesc':
    'The CLANDA doc store is a separate Supabase project. The Service Layer has not yet exposed a namespace-routed read path for the wiki — only the ATC namespace is reachable today.',
  'atc.wiki.searchFailed': 'Search failed:',
  'atc.wiki.noResults': 'No results for “{{query}}”',
  'atc.wiki.noResultsDesc': 'Try other search terms or reset the filters.',
  'atc.wiki.noResultsUuidDesc':
    'Neither full-text search nor the direct UUID lookup returned a hit. If the UUID is correct, the Service Layer may not have rolled out the /v1/commander/docs/{id} lookup endpoint yet.',
  'atc.wiki.searchHint': 'Enter a search term to search the doc store. UUIDs are looked up directly.',
  'atc.wiki.browse.title': 'Browse the doc store',
  'atc.wiki.browse.description': 'Pick a document type to browse, or search above.',
  'atc.wiki.browse.countsUnavailable': 'Document counts are temporarily unavailable — you can still browse by type.',

  // Doc stamp + frontmatter-edit UI (Wave 1, SL G1 pending — mock-backed).
  'atc.docs.stamp.action': 'Stamp',
  'atc.docs.stamp.actionAria': 'Stamp document',
  'atc.docs.stamp.confirmTitle': 'Stamp document',
  'atc.docs.stamp.confirmBody': 'Set status to "active"? The operation is audited and verified after write.',
  'atc.docs.stamp.submit': 'Stamp',
  'atc.docs.stamp.cancel': 'Cancel',
  'atc.docs.stamp.successToast': 'Document stamped — status updated.',
  'atc.docs.stamp.error.DOC_NOT_FOUND': 'Document not found.',
  'atc.docs.stamp.error.STAMP_FORBIDDEN': 'Stamping not allowed — missing workright.',
  'atc.docs.stamp.error.STAMP_INVALID_STATE_TRANSITION': 'Invalid state transition.',
  'atc.docs.stamp.error.FRONTMATTER_PATCH_INVALID': 'Frontmatter patch invalid.',
  'atc.docs.stamp.error.FRONTMATTER_FIELD_LOCKED': 'Frontmatter field locked — missing write right.',
  'atc.docs.stamp.error.VERIFY_AFTER_WRITE_MISMATCH': 'Verify-after-write mismatch — please retry.',
  'atc.docs.stamp.error.UNAUTHORIZED': 'Unauthorized.',
  'atc.docs.stamp.error.INTERNAL': 'Internal error — please try again later.',

  // Agent chat room (decide / escalate v1)
  'atc.agentRoom.header.backAria': 'Back to agent list',
  'atc.agentRoom.header.menuAria': 'More actions',
  'atc.agentRoom.header.refresh': 'Refresh',
  'atc.agentRoom.header.restart': 'Restart',
  'atc.agentRoom.header.restarting': 'Restarting…',
  'atc.agentRoom.header.spawn': 'Spawn',
  'atc.agentRoom.header.spawnAria': 'Spawn {{agent}}',
  'atc.agentRoom.header.spawnBlockedTitle': '{{agent}} already has a live embodiment — refresh to sync',
  'atc.agentRoom.header.kill': 'Kill',
  'atc.agentRoom.header.killAria': 'Kill {{agent}}',
  'atc.agentRoom.header.maximize': 'Maximize',
  'atc.agentRoom.header.collapse': 'Collapse',
  'atc.agentRoom.tabs.stream': 'Stream',
  'atc.agentRoom.tabs.conversation': 'Conversation',
  'atc.agentRoom.tabs.docs': 'Docs',
  'atc.agentRoom.tabs.decisions': 'Decisions',
  'atc.agentRoom.tabs.narration': 'Narration',
  'atc.agentRoom.tabs.escalations': 'Escalations',
  'atc.agentRoom.docs.blurb': 'Open Commander Bridge to browse governance docs and manifest entries.',
  'atc.agentRoom.docs.openBridge': 'Open Commander Bridge',
  'atc.agentRoom.docs.accessUnavailableTitle': 'Doc store access is not available',
  'atc.agentRoom.docs.accessUnavailableDesc': 'Your role does not allow reading governance docs.',
  'atc.agentRoom.docs.searchFailedTitle': 'Docs search failed',
  'atc.agentRoom.docs.unknownError': 'Unknown error',
  'atc.agentRoom.docs.noDocsForAgentTitle': 'No docs found for {{agentId}}',
  'atc.agentRoom.docs.noDocsForAgentDesc': 'No rows returned from the agent docs endpoint — the persona may have no consumer-linked docs yet.',
  'atc.agentRoom.docs.payloadInvalidTitle': 'Payload shape invalid',
  'atc.agentRoom.docs.payloadInvalidDesc':
    'The service returned a document list the client could not parse. Nothing is shown until the payload matches the contract.',
  'atc.agentRoom.docs.swipeHint': 'Swipe horizontally to see all doc columns.',
  'atc.agentRoom.docs.table.title': 'Title',
  'atc.agentRoom.docs.table.type': 'Type',
  'atc.agentRoom.docs.table.status': 'Status',
  'atc.agentRoom.docs.table.version': 'Version',
  'atc.agentRoom.docs.table.updated': 'Updated',
  'atc.agentRoom.docs.table.id': 'ID',
  'atc.agentRoom.docs.showingCount': 'Showing {{shown}} of {{total}}',
  'atc.agentRoom.docs.loadMore': 'Load more',
  'atc.agentRoom.docs.loadingMore': 'Loading...',
  'atc.agentRoom.narration.placeholder': 'No narration feed is attached to this agent yet.',
  'atc.agentRoom.decisions.alternativesToggle': 'Alternatives considered',
  'atc.agentRoom.decisions.supersedesChip': 'Supersedes',
  'atc.agentRoom.decisions.docChip': 'Linked doc',
  'atc.agentRoom.decisions.loadErrorTitle': 'Could not load decisions',
  'atc.agentRoom.decisions.loadErrorDesc': 'Something went wrong while fetching decision signals.',
  'atc.agentRoom.decisions.payloadInvalidTitle': 'Payload shape invalid',
  'atc.agentRoom.decisions.payloadInvalidDesc': 'The service returned rows the client could not parse. Nothing is shown until the payload matches the contract.',
  'atc.agentRoom.decisions.tabActive': 'Active',
  'atc.agentRoom.decisions.tabStale': 'Stale',
  'atc.agentRoom.decisions.emptyTitle': 'No active decisions',
  'atc.agentRoom.decisions.emptyDesc': 'When this agent records a decision it will appear here.',
  'atc.agentRoom.decisions.emptyStaleTitle': 'No stale decisions',
  'atc.agentRoom.decisions.emptyStaleDesc': 'Decisions past their expiry land in this list.',
  'atc.agentRoom.decisions.columnDecision': 'Decision',
  'atc.agentRoom.escalations.deadlinePassed': 'Past deadline',
  'atc.agentRoom.escalations.deadlineMinutes': '{{minutes}}m left',
  'atc.agentRoom.escalations.deadlineHours': '{{hours}}h left',
  'atc.agentRoom.escalations.resolvedLabel': 'Resolved',
  'atc.agentRoom.escalations.notifyTitle': 'Escalation update',
  'atc.agentRoom.escalations.loadErrorTitle': 'Could not load escalations',
  'atc.agentRoom.escalations.loadErrorDesc': 'Something went wrong while fetching escalation signals.',
  'atc.agentRoom.escalations.payloadInvalidTitle': 'Payload shape invalid',
  'atc.agentRoom.escalations.payloadInvalidDesc': 'The service returned rows the client could not parse. Nothing is shown until the payload matches the contract.',
  'atc.agentRoom.escalations.emptyTitle': 'No escalations',
  'atc.agentRoom.escalations.emptyDesc': 'When this agent escalates a blocker it will appear here with response options.',
  'atc.agentRoom.escalations.columnEscalation': 'Escalation',
  'atc.agentRoom.escalations.rateLimitTitle': 'Rate limited',
  'atc.agentRoom.escalations.rateLimitDesc': 'Too many replies in a short window. Wait a moment and try again.',
  'atc.chat.list.errorTitle': 'Failed to load agents',
  'atc.chat.list.errorRetry': 'Retry',
  'atc.chat.list.emptyTitle': 'No agents',
  'atc.chat.list.emptyDesc': 'There are no agents available right now.',
  'atc.chat.groupHeader.repoUnknown': 'No repo',
  'atc.chat.viewToggle.repo': 'Repo',
  'atc.chat.viewToggle.flat': 'Flat',
  'atc.chat.persona.expandEmbodiments': 'Expand embodiments',
  'atc.chat.persona.idle': 'idle',
  'atc.chat.persona.machineUnknown': 'unknown',
  'atc.chat.identity.personaUnknown': 'Unknown persona',
  'atc.chat.identity.embodimentAria': 'Embodiment id (short form)',
  'atc.chat.target.expandedAddressing.title': 'Detailed addressing',
  'atc.chat.target.label': 'Target:',
  'atc.chat.target.headerAria': 'Addressed embodiment',
  'atc.chat.target.switchAria': 'Choose embodiment to address',
  'atc.chat.target.selectLabel': 'Choose target embodiment',
  'atc.chat.target.noLive': 'No live embodiment',
  'atc.chat.target.allLabel': 'All · {{count}} live',
  'atc.chat.target.presence.live': 'live',
  'atc.chat.target.presence.idle': 'idle',
  'atc.chat.message.you': 'You',
  'atc.chat.list.liveSection': 'Live',
  'atc.chat.list.offlineSection': 'Offline',
  'atc.chat.action.beenden': 'End',
  'atc.chat.action.aktualisieren': 'Refresh',
  'atc.chat.action.neustart': 'Restart',
  'atc.chat.action.openInRegistry': 'Open in registry',
  'atc.chat.kbd.beenden': 'Esc',
  'atc.chat.kbd.aktualisieren': 'R',
  'atc.chat.kbd.neustart': 'Shift+R',
  'atc.decisions.title': 'Pending Decisions',
  'atc.decisions.empty': 'No pending decisions',
  'atc.decisions.error': 'Failed to load decisions',
  'atc.decisions.action.approve': 'Approve',
  'atc.decisions.action.reject': 'Reject',
  'atc.decisions.action.amend': 'Amend',
  'atc.decisions.amendmentLabel': 'Amendment text (required)',
  'atc.decisions.rejectReasonLabel': 'Reason (optional)',
  'atc.decisions.alternatives': 'Alternatives considered',
  'atc.decisions.rollbackPlan': 'Rollback plan',
  'atc.decisions.doorType.twoWay': 'Two-way door',
  'atc.decisions.doorType.oneWay': 'One-way door',
  'atc.decisions.blastRadius.agentOnly': 'Agent only',
  'atc.decisions.blastRadius.consumerRepo': 'Consumer repo',
  'atc.decisions.blastRadius.fleet': 'Fleet',
  'atc.decisions.blastRadius.ratificationLine': 'Ratification line',
  'atc.decisions.toast.ratified': 'Decision ratified',
  'atc.decisions.toast.rejected': 'Decision rejected',
  'atc.decisions.toast.amended': 'Amendment recorded',
  'atc.decisions.toast.error': 'Failed to record ratification — try again',
  'atc.narration.kind.decision': 'Decision',
  'atc.narration.kind.escalation': 'Escalation',

  // Manifest view
  'atc.bridge.manifest.empty': 'No manifest items',
  'atc.bridge.manifest.emptyDesc': 'No items in the execution manifest right now.',
  // Manifest Backlog page (Wave 6d, G7 §2.G7)
  'atc.bridge.manifest.page.title': 'Manifest Backlog',
  'atc.bridge.manifest.page.subtitle': 'Operator-facing manifest backlog. Edit priority, lifecycle, closeout profile, parent reference, due date, and notes per entry.',
  'atc.bridge.manifest.col.id': 'ID',
  'atc.bridge.manifest.col.title': 'Title',
  'atc.bridge.manifest.col.persona': 'Persona',
  'atc.bridge.manifest.col.lifecycle': 'Lifecycle',
  'atc.bridge.manifest.col.closeoutProfile': 'Closeout',
  'atc.bridge.manifest.col.priority': 'Priority',
  'atc.bridge.manifest.col.parent': 'Parent',
  'atc.bridge.manifest.col.dueAt': 'Due',
  'atc.bridge.manifest.col.notes': 'Notes',
  'atc.bridge.manifest.col.actions': 'Actions',
  'atc.bridge.manifest.view.toggleLabel': 'Switch view',
  'atc.bridge.manifest.view.list': 'List',
  'atc.bridge.manifest.view.kanban': 'Kanban',
  'atc.bridge.manifest.kanban.boardLabel': 'Manifest Kanban by lifecycle node',
  'atc.bridge.manifest.kanban.otherColumn': 'Other',
  'atc.bridge.manifest.kanban.emptyColumn': 'No entries',
  'atc.bridge.manifest.action.edit': 'Edit',
  'atc.bridge.manifest.action.hold': 'Hold',
  'atc.bridge.manifest.action.redispatch': 'Redispatch',
  'atc.bridge.manifest.action.forceClose': 'Force close',
  'atc.bridge.manifest.action.forceCloseConfirm': 'Really force-close this manifest entry? This forces a lifecycle transition and cannot be undone.',
  'atc.bridge.manifest.action.holdReasonPrompt': 'Reason for placing this manifest entry on hold:',
  'atc.bridge.manifest.action.create': '+ New entry',
  'atc.bridge.manifest.action.delete': 'Delete',
  'atc.bridge.manifest.field.priority': 'Priority (integer)',
  'atc.bridge.manifest.field.lifecycle': 'Lifecycle node',
  'atc.bridge.manifest.field.closeoutProfile': 'Closeout profile',
  'atc.bridge.manifest.field.parent': 'Parent manifest ref',
  'atc.bridge.manifest.field.dueAt': 'Due at',
  'atc.bridge.manifest.field.notes': 'Notes',
  'atc.bridge.manifest.editModal.title': 'Edit manifest entry',
  'atc.bridge.manifest.editModal.description': 'Patch the selected backlog entry. Empty fields clear the value; unchanged fields are omitted from the request body.',
  'atc.bridge.manifest.editModal.save': 'Save changes',
  'atc.bridge.manifest.editModal.saving': 'Saving...',
  // Create modal (FR-FE-BRIDGE-FULL-CRUD)
  'atc.bridge.manifest.field.id': 'Entry id',
  'atc.bridge.manifest.field.title': 'Title',
  'atc.bridge.manifest.field.entityType': 'Entity type',
  'atc.bridge.manifest.field.priorityBucket': 'Priority bucket',
  'atc.bridge.manifest.field.assignee': 'Assignee',
  'atc.bridge.manifest.field.executionMode': 'Execution mode',
  'atc.bridge.manifest.field.repo': 'Repo',
  'atc.bridge.manifest.createModal.title': 'New manifest entry',
  'atc.bridge.manifest.createModal.description': 'Insert a new work item into the execution manifest. Required: entry id, entity type, title. Other fields default server-side when omitted.',
  'atc.bridge.manifest.createModal.save': 'Create entry',
  'atc.bridge.manifest.createModal.saving': 'Creating...',
  'atc.bridge.manifest.createModal.parentPlaceholder': 'Optional parent id (root entry when blank)',
  // Delete dialog (FR-FE-BRIDGE-FULL-CRUD)
  'atc.bridge.manifest.deleteDialog.title': 'Delete manifest entry',
  'atc.bridge.manifest.deleteDialog.confirm': 'Permanently delete this manifest entry?',
  'atc.bridge.manifest.deleteDialog.confirmFor': 'Permanently delete "{title}"?',
  'atc.bridge.manifest.deleteDialog.confirmButton': 'Delete',
  'atc.bridge.manifest.deleteDialog.cascadeWarn': 'This entry has {count} descendants. Confirming will cascade-delete all of them.',
  'atc.bridge.manifest.deleteDialog.cascadeWarnUnknown': 'This entry has descendants. Confirming will cascade-delete all of them.',
  'atc.bridge.manifest.deleteDialog.cascadeConfirm': 'Cascade delete',
  'atc.bridge.manifest.deleteDialog.deleting': 'Deleting...',
  'atc.bridge.manifest.error.NOT_FOUND': 'Manifest entry not found. It may have been deleted already.',
  'atc.bridge.manifest.error.MANIFEST_ENTRY_HAS_CHILDREN': 'Entry has descendants. Re-confirm to cascade-delete.',
  'atc.bridge.manifest.error.ATC_WRITE_FAILED': 'Server failed to apply the write. Please try again.',
  'atc.bridge.manifest.error.PARENT_NOT_FOUND': 'Parent id does not exist. Pick an existing entry or leave blank for a root entry.',
  'atc.bridge.manifest.error.DUPLICATE_ID': 'An entry with this id already exists. Pick a different id.',
  'atc.bridge.manifest.error.INVALID_PRIORITY': 'Priority must be P0, P1, P2, or P3.',
  'atc.bridge.manifest.error.INVALID_ENTITY_TYPE': 'Entity type is not one of the allowed values.',
  'atc.bridge.manifest.error.INVALID_LIFECYCLE_NODE': 'Lifecycle node is not one of the allowed values.',
  'atc.bridge.manifest.error.INVALID_EXECUTION_MODE': 'Execution mode must be cloud, local_daemon, or local_raw.',
  'atc.bridge.manifest.error.INVALID_CLOSURE_REASON': 'Closure reason is not one of the allowed values.',
  'atc.bridge.manifest.error.INVALID_SESSION_PURPOSE': 'Session purpose is not one of the allowed values.',
  'atc.bridge.manifest.error.INVALID_PHASE': 'Phase must be an integer 1..5.',
  'atc.bridge.manifest.error.MANIFEST_ENTRY_CREATE_NO_ROW': 'Insert returned no row. Check your permissions and try again.',
  'atc.bridge.manifest.error.MANIFEST_NOT_FOUND': 'Manifest entry not found. It may have been closed or deleted.',
  'atc.bridge.manifest.error.EMPTY_PATCH': 'No changes to save.',
  'atc.bridge.manifest.error.INVALID_LIFECYCLE_TRANSITION': 'Illegal lifecycle transition for this entry.',
  'atc.bridge.manifest.error.INVALID_PARENT_REFERENCE': 'Parent reference is invalid or forms a cycle.',
  'atc.bridge.manifest.error.PRIORITY_OUT_OF_RANGE': 'Priority value is out of the accepted range.',
  'atc.bridge.manifest.error.FORBIDDEN': 'You lack the workright to edit this entry.',
  'atc.bridge.manifest.error.VERIFY_AFTER_WRITE_MISMATCH': 'Server detected post-write drift. Refresh and try again.',
  'atc.bridge.manifest.error.UNKNOWN': 'Update failed. Try again.',
  'atc.bridge.manifest.filters.entityType': 'Type',
  'atc.bridge.manifest.filters.owner': 'Owner',
  'atc.bridge.manifest.filters.repo': 'Repo',
  'atc.bridge.manifest.filters.priority.aria': 'Filter by priority',
  'atc.bridge.manifest.filters.lifecycle.aria': 'Filter by lifecycle node',
  'atc.bridge.manifest.filters.entityType.aria': 'Filter by entity type',
  'atc.bridge.manifest.filters.owner.aria': 'Filter by owner persona',
  'atc.bridge.manifest.filters.repo.aria': 'Filter by repo (substring match)',
  'atc.bridge.manifest.filters.blocked.aria': 'Filter by blocked state',
  'atc.operations.column.id': 'ID',
  'atc.operations.column.title': 'Title',
  'atc.operations.column.stage': 'Lifecycle stage',
  'atc.operations.column.assignee': 'Assignee',
  'atc.operations.column.priority': 'Priority',
  'atc.operations.column.age': 'Age',
  'atc.operations.column.blocked': 'Blocked',
  'atc.operations.column.linkedPrs': '# Linked PRs',
  'atc.operations.column.lastUpdate': 'Last update',
  'atc.operations.drawer.tab.uebersicht': 'Overview',
  'atc.operations.drawer.tab.aktivitaet': 'Activity',
  'atc.operations.drawer.tab.pearlChain': 'Pearl-chain',
  'atc.operations.drawer.tab.linkedPrs': 'Linked PRs',
  'atc.operations.drawer.tab.dokumente': 'Documents',
  'atc.operations.drawer.action.assign': 'Assign',
  'atc.operations.drawer.action.moveStage': 'Move stage',
  'atc.operations.drawer.action.markBlocked': 'Mark blocked',
  'atc.operations.drawer.action.addComment': 'Add comment',
  'atc.operations.drawer.action.openChat': 'Open chat with assignee',
  'atc.operations.drawer.action.openInRepo': 'Open in repo',
  'atc.operations.drawer.action.kbd.assign': 'W',
  'atc.operations.drawer.action.kbd.moveStage': 'M',
  'atc.operations.drawer.action.kbd.markBlocked': 'B',
  'atc.operations.drawer.action.kbd.addComment': 'C',
  'atc.operations.drawer.action.kbd.openChat': 'J',
  'atc.operations.drawer.action.kbd.openInRepo': 'G',
  'atc.operations.shell.emptyTitle': 'No operations found',
  'atc.operations.shell.emptyDesc': 'No operations are available for the selected filter set.',
  'atc.operations.empty.notProjected': 'Projection is not available yet ({fr}).',
  'atc.operations.drawer.overview.title': 'Title',
  'atc.operations.drawer.overview.description': 'Description',
  'atc.operations.drawer.overview.stage': 'Lifecycle stage',
  'atc.operations.drawer.overview.assignee': 'Assignee',
  'atc.operations.drawer.overview.priority': 'Priority',
  'atc.operations.drawer.overview.blocked': 'Blocked',
  'atc.operations.drawer.overview.blockedReason': 'Blocked reason',
  'atc.operations.drawer.overview.parentOp': 'Parent Op',
  'atc.operations.drawer.overview.parentSf': 'Parent SF',
  'atc.operations.drawer.overview.createdAt': 'Created',
  'atc.operations.drawer.overview.updatedAt': 'Updated',
  'atc.operations.drawer.activity.timestamp': 'Timestamp',
  'atc.operations.drawer.activity.actor': 'Actor',
  'atc.operations.drawer.activity.type': 'Event type',
  'atc.operations.drawer.activity.payload': 'Payload',
  'atc.operations.drawer.pearlChain.predecessor': 'Predecessors',
  'atc.operations.drawer.pearlChain.successor': 'Successors',
  'atc.operations.drawer.linkedPrs.branch': 'Branch -> Target',
  'atc.operations.drawer.linkedPrs.status': 'Status',
  'atc.operations.drawer.linkedPrs.age': 'Age',
  'atc.operations.drawer.linkedPrs.ci': 'CI summary',
  'atc.operations.drawer.docs.type': 'Type',
  'atc.operations.drawer.docs.status': 'Status',
  'atc.operations.drawer.docs.updated': 'Last updated',

  // Filters
  'atc.bridge.filters.all': 'All',
  'atc.bridge.filters.any': 'Any',
  'atc.bridge.filters.yes': 'Yes',
  'atc.bridge.filters.no': 'No',
  'atc.bridge.filters.lifecycle': 'Lifecycle',
  'atc.bridge.filters.blocked': 'Blocked',
  'atc.bridge.filters.closure': 'Closure',
  'atc.bridge.filters.priority': 'Priority',
  'atc.bridge.filters.mode': 'Mode',
  'atc.bridge.filters.assignee': 'Assignee',
  'atc.bridge.filters.refresh': 'Refresh',

  // Actions

  // PR Queue view
  'atc.bridge.prs.approve': 'Approve + Merge',
  'atc.bridge.prs.reject': 'Reject',
  'atc.bridge.prs.merged': '{repo} #{number} merged',
  'atc.bridge.prs.rejected': 'PR closed',
  'atc.bridge.prs.selected': '{count} selected',
  'atc.bridge.prs.approveAll': 'Approve all',
  'atc.bridge.prs.batchResult': '{merged} merged, {failed} failed',
  'atc.bridge.prs.ungrouped': 'Ungrouped',
  'atc.bridge.prs.empty': 'No open PRs',
  'atc.bridge.prs.emptyDesc': 'All pull requests have been processed.',
  'atc.bridge.prs.confirmBatch': 'Batch approve',
  'atc.bridge.prs.confirmBatchDesc': 'Approve and merge {count} PRs?',
  'atc.bridge.prs.confirmReject': 'Reject PR',
  'atc.bridge.prs.confirmRejectDesc': 'Close {repo} #{number} without merging?',
  'atc.bridge.commanderPrs.title': 'Commander PRs',
  'atc.bridge.commanderPrs.filterLabel': 'Target branches',
  'atc.bridge.commanderPrs.empty': 'No matching PRs',
  'atc.bridge.commanderPrs.emptyDesc': 'Try changing the branch filters.',
  'atc.bridge.commanderPrs.refreshing': 'Refreshing...',
  'atc.bridge.commanderPrs.columns.repo': 'Repo',
  'atc.bridge.commanderPrs.columns.number': '#',
  'atc.bridge.commanderPrs.columns.title': 'Title',
  'atc.bridge.commanderPrs.columns.author': 'Author',
  'atc.bridge.commanderPrs.columns.ci': 'CI',
  'atc.bridge.commanderPrs.columns.mergeable': 'Mergeable',
  'atc.bridge.commanderPrs.columns.comments': 'Comments',
  'atc.bridge.commanderPrs.columns.updated': 'Updated',
  'atc.bridge.commanderPrs.authorUnknown': 'Unknown',
  'atc.bridge.commanderPrs.authorKind.bot': 'Bot',
  'atc.bridge.commanderPrs.authorKind.user': 'User',
  'atc.bridge.commanderPrs.ci.success': 'Success',
  'atc.bridge.commanderPrs.ci.failure': 'Failure',
  'atc.bridge.commanderPrs.ci.pending': 'Pending',
  'atc.bridge.commanderPrs.ci.error': 'Error',
  'atc.bridge.commanderPrs.ci.unknown': 'Unknown',
  'atc.bridge.commanderPrs.mergeable.checking': 'Checking...',
  'atc.bridge.commanderPrs.mergeable.ready': 'Ready',
  'atc.bridge.commanderPrs.mergeable.blocked': 'Blocked',
  'atc.bridge.commanderPrs.commentsCount': '{count}',
  'atc.bridge.commanderPrs.unresolvedComments': 'Unresolved comments',
  'atc.bridge.commanderPrs.branchProtectionLock': 'Branch protection blocking',
  'atc.bridge.commanderPrs.drawer.emptyTitle': 'No pull request selected',
  'atc.bridge.commanderPrs.drawer.emptyDesc': 'Select a PR from the list to inspect details.',
  'atc.bridge.commanderPrs.drawer.viewOnGitHub': 'View on GitHub',
  'atc.bridge.commanderPrs.drawer.tabs.overview': 'Overview',
  'atc.bridge.commanderPrs.drawer.tabs.files': 'Files',
  'atc.bridge.commanderPrs.drawer.tabs.ci': 'CI',
  'atc.bridge.commanderPrs.drawer.tabs.comments': 'Comments',
  'atc.bridge.commanderPrs.drawer.tabs.reviews': 'Reviews',
  'atc.bridge.commanderPrs.drawer.actions.promoteToMain': 'Promote to main',
  'atc.bridge.commanderPrs.drawer.files.empty': 'No changed files',
  'atc.bridge.commanderPrs.drawer.files.emptyDesc': 'This PR does not report file changes yet.',
  'atc.bridge.commanderPrs.drawer.files.noPatch': 'No patch preview available.',
  'atc.bridge.commanderPrs.drawer.files.viewFullDiff': 'View full diff',
  'atc.bridge.commanderPrs.drawer.ci.empty': 'No checks found',
  'atc.bridge.commanderPrs.drawer.ci.emptyDesc': 'No CI check runs are attached to this pull request.',
  'atc.bridge.commanderPrs.drawer.comments.threads': 'Review threads',
  'atc.bridge.commanderPrs.drawer.comments.threadsEmpty': 'No review threads',
  'atc.bridge.commanderPrs.drawer.comments.threadsEmptyDesc': 'No threaded review comments yet.',
  'atc.bridge.commanderPrs.drawer.comments.issueComments': 'Issue comments',
  'atc.bridge.commanderPrs.drawer.comments.issueEmpty': 'No issue comments',
  'atc.bridge.commanderPrs.drawer.comments.issueEmptyDesc': 'No issue comments on this pull request yet.',
  'atc.bridge.commanderPrs.drawer.comments.resolved': 'Resolved',
  'atc.bridge.commanderPrs.drawer.comments.unresolved': 'Unresolved',
  'atc.bridge.commanderPrs.drawer.comments.resolve': 'Resolve',
  'atc.bridge.commanderPrs.drawer.comments.commentPlaceholder': 'Write a comment...',
  'atc.bridge.commanderPrs.drawer.comments.submit': 'Submit',
  'atc.bridge.commanderPrs.drawer.comments.you': 'You',
  'atc.bridge.commanderPrs.drawer.reviews.empty': 'No reviews yet',
  'atc.bridge.commanderPrs.drawer.reviews.emptyDesc': 'Reviews will appear once submitted.',
  'atc.bridge.commanderPrs.drawer.reviews.approve': 'Approve',
  'atc.bridge.commanderPrs.drawer.reviews.requestChanges': 'Request changes',
  'atc.bridge.commanderPrs.drawer.reviews.dismiss': 'Dismiss',
  'atc.bridge.commanderPrs.drawer.reviews.dismissReason': 'Dismissed from Commander drawer',
  'atc.bridge.commanderPrs.drawer.reviews.state.approved': 'Approved',
  'atc.bridge.commanderPrs.drawer.reviews.state.changes_requested': 'Changes requested',
  'atc.bridge.commanderPrs.drawer.reviews.state.commented': 'Commented',
  'atc.bridge.commanderPrs.drawer.reviews.state.dismissed': 'Dismissed',
  'atc.bridge.commanderPrs.drawer.actions.merge': 'Merge',
  'atc.bridge.commanderPrs.drawer.actions.close': 'Close',
  'atc.bridge.commanderPrs.drawer.actions.confirmMerge': 'Merge this pull request?',
  'atc.bridge.commanderPrs.drawer.actions.confirmMergeDesc': 'Merge {{repo}} #{{number}} now.',
  'atc.bridge.commanderPrs.drawer.actions.confirmClose': 'Close this pull request?',
  'atc.bridge.commanderPrs.drawer.actions.confirmCloseDesc': 'Close {{repo}} #{{number}} without merging.',
  'atc.bridge.commanderPrs.drawer.actions.ciMustPass': 'CI must pass',
  'atc.bridge.commanderPrs.drawer.actions.branchProtectionBlocking': 'Branch protection blocking',
  'atc.bridge.commanderPrs.drawer.actions.overrideBranchProtection': 'Override branch protection',
  'atc.bridge.commanderPrs.drawer.actions.overrideTypedConfirmTitle': 'Type PR number to continue',
  'atc.bridge.commanderPrs.drawer.actions.overrideTypedConfirmDesc': 'Retype #{{number}} to confirm this bypass action.',
  'atc.bridge.commanderPrs.drawer.actions.overrideTypedConfirmInputLabel': 'PR number',
  'atc.bridge.commanderPrs.drawer.actions.confirmBypass': 'Bypass branch protection on PR #{{number}}?',
  'atc.bridge.commanderPrs.drawer.actions.confirmBypassDesc': 'This attempts a direct GitHub merge using your PAT permissions.',
  'atc.bridge.commanderPrs.drawer.actions.comingB4': 'Coming in SORTIE-B4',
  'atc.bridge.commanderPrs.drawer.actions.edit': 'Edit PR',
  'atc.bridge.commanderPrs.drawer.actions.editTitle': 'Title',
  'atc.bridge.commanderPrs.drawer.actions.editBody': 'Description',
  'atc.bridge.commanderPrs.drawer.actions.editDraft': 'Draft',
  'atc.bridge.commanderPrs.drawer.actions.editNoChangesTitle': 'Nothing to save',
  'atc.bridge.commanderPrs.drawer.actions.editNoChangesDesc': 'Change the title, description, or draft flag before saving.',
  'atc.bridge.commanderPrs.drawer.actions.updateBranch': 'Update branch',
  'atc.bridge.commanderPrs.drawer.actions.rerunWorkflow': 'Rerun',
  'atc.bridge.commanderPrs.drawer.actions.rerunFailedJobs': 'Rerun failed jobs',
  'atc.bridge.commanderPrs.drawer.ci.failedWorkflows': 'Failed workflow runs',
  'atc.bridge.commanderPrs.drawer.reviews.requestChangesDefaultBody': 'Changes requested via Commander Bridge.',
  'atc.repos.column.prNumber': 'PR #',
  'atc.repos.column.title': 'Title',
  'atc.repos.column.branchTarget': 'Branch -> Target',
  'atc.repos.column.age': 'Age',
  'atc.repos.column.status': 'Status',
  'atc.repos.column.author': 'Authored-by',
  'atc.repos.column.ci': 'CI summary',
  'atc.repos.column.reviewComments': 'Review comments',
  'atc.repos.drawer.tab.uebersicht': 'Overview',
  'atc.repos.drawer.tab.diff': 'Diff',
  'atc.repos.drawer.tab.files': 'Files',
  'atc.repos.drawer.tab.ci': 'CI',
  'atc.repos.drawer.tab.comments': 'Comments',
  'atc.repos.drawer.tab.reviews': 'Reviews',
  'atc.repos.drawer.action.approve': 'Approve',
  'atc.repos.drawer.action.requestChanges': 'Request changes',
  'atc.repos.drawer.action.merge': 'Merge',
  'atc.repos.drawer.action.mergeAsAdmin': 'Merge as admin',
  'atc.repos.drawer.action.mergeAsAdminHint': 'Bypass GitHub review requirement via admin override (FR-PR-MERGE-WITHOUT-APPROVE).',
  'atc.repos.drawer.action.edit': 'Edit',
  'atc.repos.drawer.action.updateBranch': 'Update branch',
  'atc.repos.drawer.action.rerunCi': 'Rerun CI',
  'atc.repos.viewToggle.byRepo': 'Group by repo',
  'atc.repos.viewToggle.flat': 'Flat',
  'atc.repos.viewToggle.byStatus': 'Group by status',
  'atc.repos.empty.notProjected': 'Feature pending upstream ({pointer})',

  // Staging Delta view
  'atc.bridge.staging.commitsAhead': 'commits ahead',
  'atc.bridge.staging.filesChanged': 'files changed',
  'atc.bridge.staging.promote': 'Promote',
  'atc.bridge.staging.upToDate': 'Up to date',
  'atc.bridge.staging.noCommits': 'No commits',
  'atc.bridge.staging.justNow': 'Just now',
  'atc.bridge.staging.ago': 'ago',
  'atc.bridge.staging.staleWarning': 'Overdue — more than 5 commits ahead',
  'atc.bridge.staging.promoted': '{repo} promoted — PR #{pr} created',
  'atc.bridge.staging.confirmPromote': 'Promote staging',
  'atc.bridge.staging.confirmPromoteDesc': 'Create staging → main PR for {repo}?',
  'atc.bridge.staging.empty': 'No repos',
  'atc.bridge.staging.emptyDesc': 'Could not load staging delta.',
  'atc.bridge.staging.reposWithChanges': 'repos with changes',
  'atc.bridge.staging.totalCommits': 'total commits',

  // Escalations view
  'atc.bridge.escalations.title': 'Escalations',
  'atc.bridge.escalations.resetToGate': 'Reset → GATE',
  'atc.bridge.escalations.kill': 'Kill',
  'atc.bridge.escalations.replan': 'Replan',
  'atc.bridge.escalations.actionApplied': '{action} applied — status: {status}',
  'atc.bridge.escalations.confirmKill': 'Kill entity',
  'atc.bridge.escalations.confirmKillDesc': 'Permanently kill "{id}"? This cannot be undone.',
  'atc.bridge.escalations.empty': 'No escalations',
  'atc.bridge.escalations.emptyDesc': 'All entities running normally. No HALTED entries.',

  // ── Bridge Chat Composer — Send ─────────────────────────────────────────
  // Typed-error branches per `SendMessageErrorCode` (Wave 5 of Pillar 3
  // typed-fetch migration, ADR-CROSS-SYSTEM-CONTRACTS-V1 v4 §2.2). Each
  // key matches one enum value; `contractMismatch` covers response-shape
  // drift (D-33 R1), `unknown` covers everything else.
  'atc.bridge.chat.send.retry': 'Retry send',
  'atc.bridge.chat.send.error.UNAUTHORIZED': 'Signed out — please sign in again.',
  'atc.bridge.chat.send.error.FORBIDDEN': 'Not authorized to send to this target.',
  'atc.bridge.chat.send.error.NOT_FOUND': 'Recipient not found.',
  'atc.bridge.chat.send.error.VALIDATION_ERROR': 'Message rejected — invalid content.',
  'atc.bridge.chat.send.error.RATE_LIMITED': 'Too many messages — wait a moment and retry.',
  'atc.bridge.chat.send.error.INTERNAL': 'Service Layer error — please retry.',
  'atc.bridge.chat.send.error.TIMEOUT': 'Request timed out — please retry.',
  'atc.bridge.chat.send.error.CONFLICT': 'Conflict with an existing signal — refresh and retry.',
  'atc.bridge.chat.send.error.TARGET_UNREACHABLE': 'Recipient has no live session — spawn first.',
  'atc.bridge.chat.send.error.EMPTY_BODY': 'Message is empty — add text or an attachment.',
  'atc.bridge.chat.send.error.contractMismatch': 'Service Layer response is invalid — please reload.',
  'atc.bridge.chat.send.error.unknown': 'Failed to send message.',

  // ── Workitem chat-attach picker (operator 2026-05-23) ───────────────────
  // The composer picker stamps `from_work_item_id` on the outgoing signal
  // so discussions land on the workitem thread, not the flat chat lane.
  'atc.bridge.chat.workitem.label': 'Talking about',
  'atc.bridge.chat.workitem.none': 'No workitem — flat chat',
  'atc.bridge.chat.workitem.pick': 'Pick workitem',
  'atc.bridge.chat.workitem.clear': 'Clear workitem',
  'atc.bridge.chat.workitem.search': 'Search workitems…',
  'atc.bridge.chat.workitem.empty': 'No workitems match.',
  'atc.bridge.chat.workitem.loading': 'Loading workitems…',
  'atc.bridge.chat.workitem.error': 'Could not load workitems.',

  // ── Registry workitem thread (operator 2026-05-23) ──────────────────────
  'atc.workitemConversation.title': 'Workitem conversation',
  'atc.workitemConversation.empty': 'No messages yet — talk to the agent directly on this workitem.',
  'atc.workitemConversation.loading': 'Loading conversation…',
  'atc.workitemConversation.error': 'Could not load the conversation.',
  'atc.workitemConversation.placeholder': 'Message the agent on this workitem…',
  'atc.workitemConversation.send': 'Send',
  'atc.workitemConversation.sending': 'Sending…',
  'atc.workitemConversation.sendError': 'Could not send the message.',
  'atc.workitemConversation.close': 'Close',
  'atc.highlights.title': 'Highlights',
  'atc.highlights.loading': 'Loading…',
  'atc.highlights.error': 'Could not load highlights.',
  'atc.highlights.opNotFound': 'OP not found in the manifest.',
  'atc.highlights.empty': 'No open items in this OP.',
  'atc.highlights.open': 'open',
  'atc.highlights.blocked': 'blocked',
  'atc.highlights.expandRow': 'Show details',
  'atc.highlights.collapseRow': 'Hide details',
  'atc.highlights.detail.id': 'ID',
  'atc.highlights.detail.entityType': 'Type',
  'atc.highlights.detail.lifecycle': 'Lifecycle',
  'atc.highlights.detail.priority': 'Priority',
  'atc.highlights.detail.assignee': 'Assignee',
  'atc.highlights.detail.repo': 'Repo',
  'atc.highlights.detail.progress': 'Progress',
  'atc.highlights.detail.closureReason': 'Closure reason',
  'atc.highlights.detail.docStore': 'Doc',
  'atc.highlights.detail.updated': 'Updated',
  'atc.highlights.detail.none': '—',

  // ── Scout Insights ──────────────────────────────────────────────────────
  'scout.insights.title': 'Insights Dashboard',
  'scout.insights.subtitle': 'Revenue breakdown by product and industry',
  'scout.insights.error': 'Failed to load insights',
  'scout.insights.emptyTitle': 'No data yet',
  'scout.insights.emptyDescription': 'Insights will appear here once sales data is available.',
  'scout.insights.byProduct': 'Revenue by Product',
  'scout.insights.byIndustry': 'Revenue by Industry',

  // ── Scout Wochenplanung Tasks ───────────────────────────────────────────
  'scout.wochenplanung.tasks.title': 'Tasks',
  'scout.wochenplanung.tasks.openReports': 'Open Reports',
  'scout.wochenplanung.tasks.openReportsDescription': 'Visit reports that still need to be submitted',
  'scout.wochenplanung.tasks.pendingReview': 'Pending Review',
  'scout.wochenplanung.tasks.pendingReviewDescription': 'Missions awaiting review',
  'scout.wochenplanung.tasks.overdueReports': 'Overdue Reports',
  'scout.wochenplanung.tasks.overdueReportsDescription': 'Reports past their deadline',

  // ── Scout PreQual Section ───────────────────────────────────────────────
  'scout.prequal.section.branche': 'Industry',
  'scout.prequal.sessionPaused': 'Session paused',
  'scout.prequal.noActivity': 'No activity detected',
  'scout.prequal.resume': 'Resume',
  'scout.prequal.builtInTelephony': 'Built-in Telephony',
  'scout.prequal.telephonySwitched': 'We have switched to built-in telephony. Teams is no longer needed.',
  'scout.prequal.telephonyTestPhase': 'We have switched to built-in telephony. There are 2 options during the test phase:',
  'scout.prequal.telephonyAuto': 'System dials automatically after each processing.',
  'scout.prequal.telephonyManualLabel': 'Manual',
  'scout.prequal.telephonyManual': 'Handset button top left.',
  'scout.prequal.skip': 'Skip',
  'scout.prequal.dialNow': 'Dial now',

  // ── Scout PreQual Outcome Dialog ────────────────────────────────────────
  'scout.prequal.outcome.notReachedTitle': 'Not reached — provide reason',
  'scout.prequal.outcome.mailbox': 'Voicemail / Mailbox',
  'scout.prequal.outcome.noAnswer': 'No answer',
  'scout.prequal.outcome.wrongNumber': 'Wrong number',
  'scout.prequal.outcome.notesOptional': 'Notes (optional)',
  'scout.prequal.outcome.moreDetails': 'More details...',
  'scout.prequal.outcome.saveAndNext': 'Save & Next',
  'scout.prequal.dtmf.trigger': 'DTMF keypad',
  'scout.prequal.manualDial.trigger': 'Manual dial',
  'scout.prequal.manualDial.placeholder': 'Enter number',
  'scout.prequal.manualDial.call': 'Call',
  'scout.prequal.manualDial.backspace': 'Delete',
  'scout.prequal.dtmf.keyboardHint': 'Keyboard 0-9, *, # for IVR input.',
  'scout.prequal.outcome.connectionFailedTitle': 'Connection failed',
  'scout.prequal.outcome.noConnection': 'No connection at this number',
  'scout.prequal.outcome.fax': 'Fax',
  'scout.prequal.outcome.endCall': 'End call',
  'scout.prequal.outcome.whoReached': 'Who did you reach?*',
  'scout.prequal.outcome.nobodyRelevant': 'Nobody relevant',
  'scout.prequal.outcome.reception': 'Reception / Front desk',
  'scout.prequal.outcome.decisionMaker': 'Decision maker / Specialist',
  'scout.prequal.outcome.receptionNameLabel': 'Name at reception (optional)',
  'scout.prequal.outcome.receptionNamePlaceholder': 'e.g. Mrs. Schmidt',
  'scout.prequal.outcome.decisionMakerNameLabel': 'Decision maker name (optional)',
  'scout.prequal.outcome.decisionMakerNamePlaceholder': 'e.g. Mr. Smith',
  'scout.prequal.outcome.whatNext': 'What now?*',
  'scout.prequal.outcome.processingDone': 'Processing completed',
  'scout.prequal.outcome.callLater': 'Call later',
  'scout.prequal.outcome.toSummary': 'Continue to summary',
  'scout.prequal.outcome.callbackWho': 'Who do we call back?*',
  'scout.prequal.outcome.callbackAnsprechpartner': 'Contact person',
  'scout.prequal.outcome.callbackZentrale': 'Central office',
  'scout.prequal.outcome.callbackWhen': 'When?*',
  'scout.prequal.outcome.callbackCustom': 'Specific time …',
  'scout.prequal.outcome.callbackDate': 'Date',
  'scout.prequal.outcome.callbackTime': 'Time',

  // ── Scout PreQual Summary ───────────────────────────────────────────────
  'scout.prequal.summary.interestReason': 'Interest reason',
  'scout.prequal.summary.interestReasonPlaceholder': 'Why this interest level?',
  'scout.prequal.summary.competitor': 'Competitor',
  'scout.prequal.summary.competitorPlaceholder': 'e.g. Competitor A, Competitor B',

  // ── PreQual Campaign Cockpit ─────────────────────────────────────────────
  'scout.prequal.campaign.noAssignment': 'No campaign assigned',
  'scout.prequal.campaign.noAssignmentDesc': 'No active campaign found for this user. Please contact your supervisor.',
  'scout.prequal.campaign.moreCampaignsSuffix': 'more',
  'scout.prequal.campaign.allCampaigns': 'All campaigns',
  'scout.prequal.campaign.switcherLabel': 'Select campaign',
  'scout.prequal.campaign.startSession': 'Start session',
  'scout.prequal.campaign.resumeSession': 'Resume session',
  'scout.prequal.campaign.continueSession': 'Continue calling',
  'scout.prequal.campaign.todayCalls': 'Calls today',
  'scout.prequal.campaign.todayReached': 'Reached today',
  'scout.prequal.campaign.todayQualified': 'Qualified today',
  'scout.prequal.campaign.conversionRate': 'Conversion rate',
  'scout.prequal.campaign.queueProgress': 'Queue progress',
  'scout.prequal.campaign.leadsAssigned': 'Leads assigned',
  'scout.prequal.campaign.currentSession': 'Current session',
  'scout.prequal.campaign.completed': 'Completed',
  'scout.prequal.campaign.inProgress': 'In progress',
  'scout.prequal.campaign.exhausted': 'Exhausted',
  'scout.prequal.campaign.completedCount': '{{count}} completed',
  'scout.prequal.campaign.openCount': '{{count}} open',

  // ── Lobby (pre-calling landing) ──────────────────────────────────────────
  'scout.prequal.lobby.title': 'Lobby',
  'scout.prequal.lobby.pickerHeading': 'Pick a campaign',
  'scout.prequal.lobby.pickerHint': 'Select a campaign to start your session.',
  'scout.prequal.lobby.selected': 'Selected',
  'scout.prequal.lobby.selectCampaignLabel': 'Select campaign {{title}}',
  'scout.prequal.lobby.pendingLeads': '{{count}} open leads',
  'scout.prequal.lobby.typePrequal': 'New customers',
  'scout.prequal.lobby.typeReorder': 'Reorder',

  // ── PreQual Reorder Campaign (FR-FE-CALLING-REORDER-CAMPAIGN-COCKPIT) ─────
  'scout.prequal.reorder.standing': 'Revenue & Payment',
  'scout.prequal.reorder.purchaseHistory': 'Purchase history',
  'scout.prequal.reorder.orders': 'Orders',
  'scout.prequal.reorder.product': 'Product',
  'scout.prequal.reorder.qty': 'Qty',
  'scout.prequal.reorder.amount': 'Amount',
  'scout.prequal.reorder.date': 'Date',
  'scout.prequal.reorder.paymentOnTime': 'Payment on time',
  'scout.prequal.reorder.paymentOnTimeYes': 'On time',
  'scout.prequal.reorder.paymentOnTimeNo': 'Overdue',
  'scout.prequal.reorder.openInvoices': 'Open invoices',
  'scout.prequal.reorder.reorderDue': 'Reorder due',
  'scout.prequal.reorder.decisionMaker': 'Contact',
  'scout.prequal.reorder.bestandskunde': 'Existing customer',
  'scout.prequal.reorder.totalRevenue': 'Total revenue',
  'scout.prequal.reorder.payment': 'Payment',
  'scout.prequal.reorder.rep': 'Account rep',
  'scout.prequal.reorder.note': 'Note',
  'scout.prequal.reorder.scriptTitle': 'Reorder script',
  'scout.prequal.reorder.scriptEmpty': 'No script available.',

  // ── Scout Call Test ─────────────────────────────────────────────────────
  'scout.callTest.title': 'Voice Call Test',
  'scout.callTest.runAll': 'Run All Tests',
  'scout.callTest.noPhoneOnProfile': 'No phone number set on user profile.',
  'scout.callTest.phoneMissingTitle': 'Test number not found',
  'scout.callTest.phoneFallback': 'Fallback: {{number}}',
  'scout.callTest.copyTwilioLog': 'Copy Twilio log',
  'scout.callTest.copied': 'Copied',
  'scout.callTest.copyError': 'Copy failed',

  // ── Scout Dialer Config ─────────────────────────────────────────────────
  'scout.dialerConfig.title': 'Dialer Configuration',
  'scout.dialerConfig.featureFlags': 'Feature Flags (per user)',
  'scout.dialerConfig.user': 'User',

  // ── Scout Timesheet ────────────────────────────────────────────────────
  'scout.timesheet.title': 'Timesheet',
  'scout.timesheet.print': 'Print',
  'scout.timesheet.thisWeek': 'This Week',
  'scout.timesheet.thisMonth': 'This Month',
  'scout.timesheet.callsThisWeek': 'Calls This Week',
  'scout.timesheet.callsThisMonth': 'Calls This Month',
  'scout.timesheet.workLog': 'Work Log',
  'scout.timesheet.date': 'Date',
  'scout.timesheet.start': 'Start',
  'scout.timesheet.end': 'End',
  'scout.timesheet.duration': 'Duration',
  'scout.timesheet.calls': 'Calls',
  'scout.timesheet.reached': 'Reached',
  'scout.timesheet.reachedRate': 'Reach Rate',
  'scout.timesheet.qualified': 'Qualified',
  'scout.timesheet.noEntries': 'No entries yet.',

  // ── ATC Calling Dashboard ──────────────────────────────────────────────
  'atc.callingDashboard.title': 'Calling Dashboard',
  'atc.callingDashboard.activeSessions': 'Active Sessions',
  'atc.callingDashboard.callsToday': 'Calls Today',
  'atc.callingDashboard.reachedToday': 'Reached Today',
  'atc.callingDashboard.qualifiedToday': 'Qualified Today',
  'atc.callingDashboard.liveSessions': 'Live Sessions',
  'atc.callingDashboard.noActiveSessions': 'No active sessions.',
  'atc.callingDashboard.todaySummary': 'Today per Caller',
  'atc.callingDashboard.noDataToday': 'No data for today.',
  'atc.callingDashboard.caller': 'Caller',

  // ── ATC Timesheet Review ───────────────────────────────────────────────
  'atc.timesheetReview.title': 'Timesheet Review',
  'atc.timesheetReview.callerSummary': 'Summary per Caller',
  'atc.timesheetReview.days': 'Days',

  // ── Scout Sessions ─────────────────────────────────────────────────────
  'scout.sessions.title': 'My Sessions',
  'scout.sessions.totalSessions': 'Total Sessions',
  'scout.sessions.totalTime': 'Total Time',
  'scout.sessions.totalCalls': 'Total Calls',
  'scout.sessions.totalReached': 'Total Reached',
  'scout.sessions.pastSessions': 'Past Sessions',
  'scout.sessions.noSessions': 'No sessions yet.',
  'scout.sessions.status': 'Status',

  // ── Warehouse: Unified Bills Workspace (W1) ─────────────────────────────
  'warehouse.bills.title': 'Bills',
  'warehouse.bills.subtitle': 'All Wackler invoices with lifecycle, aging, and per-line status.',
  'warehouse.bills.stats.total': 'Invoices',
  'warehouse.bills.stats.closureReady': 'Closure ready',
  'warehouse.bills.stats.netOutstanding': 'Net outstanding',
  'warehouse.bills.stats.d90plus': '90+ days overdue',
  'warehouse.bills.filter.track': 'Track',
  'warehouse.bills.filter.aging': 'Aging',
  'warehouse.bills.filter.node': 'Lifecycle',
  'warehouse.bills.filter.all': 'All',
  'warehouse.bills.filter.logistics': 'Logistics',
  'warehouse.bills.filter.freight': 'Freight',
  'warehouse.bills.filter.closureReady': 'Closure ready only',
  'warehouse.bills.node.intake': 'Intake',
  'warehouse.bills.node.orient': 'Analyse',
  'warehouse.bills.node.execute': 'In progress',
  'warehouse.bills.node.verify': 'Verify',
  'warehouse.bills.node.review': 'Wackler review',
  'warehouse.bills.node.closed': 'Closed',
  'warehouse.bills.node.none': 'No lifecycle',
  'warehouse.bills.col.period': 'Period',
  'warehouse.bills.col.invoiceNumber': 'Invoice #',
  'warehouse.bills.col.invoiceDate': 'Date',
  'warehouse.bills.col.track': 'Track',
  'warehouse.bills.col.node': 'Lifecycle',
  'warehouse.bills.col.gross': 'Gross',
  'warehouse.bills.col.net': 'Net open',
  'warehouse.bills.col.age': 'Age',
  'warehouse.bills.col.lines': 'Lines (acc/disp/pend)',
  'warehouse.bills.col.flags': 'Flags',
  'warehouse.bills.col.action': 'Action',
  'warehouse.bills.close.button': 'Declare closure',
  'warehouse.bills.close.dialogTitle': 'Close bill',
  'warehouse.bills.close.dialogDescription': 'Bill {{invoice}} ({{period}}) will be marked as closed. All lines are accepted or released and the balance is settled. This cannot be undone.',
  'warehouse.bills.close.confirm': 'Confirm closure',
  'warehouse.bills.close.cancel': 'Cancel',
  'warehouse.bills.close.blockedNotReview': 'Bill can only be closed from the Wackler review state.',
  'warehouse.bills.close.blockedNotReady': 'Bill is not yet closure-ready — there are open or unallocated items.',
  'warehouse.bills.close.blockedAlreadyClosed': 'Bill is already closed.',
  'warehouse.bills.close.blockedNoEntity': 'Bill is not linked to a lifecycle entity. Contact service layer.',
  'warehouse.bills.flag.closureReady': 'Closure ready',
  'warehouse.bills.flag.locked': 'Locked',
  'warehouse.bills.empty.title': 'No bills found',
  'warehouse.bills.empty.description': 'No bills match the current filters. Clear filters or pick a different track.',
  'warehouse.bills.error': 'Failed to load bills: {{message}}',
  'warehouse.bills.pdf.drawerAriaLabel': 'PDF viewer — {{invoice}}',
  'warehouse.bills.pdf.documentFallbackTitle': 'Bill document',
  'warehouse.bills.pdf.openTab': 'Open in tab',
  'warehouse.bills.pdf.download': 'Download',
  'warehouse.bills.pdf.noStoragePath': 'This bill has no stored PDF.',
  'warehouse.bills.pdf.signFailed': 'Could not get signed URL: {{message}}',
  'warehouse.bills.pdf.renderFailed': 'Could not render PDF: {{message}}',
  'warehouse.bills.pdf.prevPage': 'Previous page',
  'warehouse.bills.pdf.nextPage': 'Next page',
  'warehouse.bills.pdf.viewPdf': 'View PDF',

  // ── Warehouse: Wackler Payments ─────────────────────────────────────────
  'warehouse.payments.title': 'Invoice Reconciliation',
  'warehouse.payments.noData': 'No payment data available.',
  'warehouse.payments.allTracks': 'All Tracks',
  'warehouse.payments.logistics': 'Logistics',
  'warehouse.payments.freight': 'Freight',
  'warehouse.payments.totalInvoiced': 'Total Invoiced',
  'warehouse.payments.totalCredited': 'Total Credited',
  'warehouse.payments.totalPaid': 'Total Paid',
  'warehouse.payments.openBalance': 'Open Balance',
  'warehouse.payments.track': 'Track',
  'warehouse.payments.invoice': 'Invoice',
  'warehouse.payments.invoiced': 'Invoiced',
  'warehouse.payments.credited': 'Credited',
  'warehouse.payments.net': 'Net',
  'warehouse.payments.paid': 'Paid',
  'warehouse.payments.openAmount': 'Open',
  'warehouse.payments.invoiceDate': 'Date',
  'warehouse.payments.age': 'Age',
  'warehouse.payments.invoicesCount': 'invoices',
  'warehouse.payments.allStatuses': 'All statuses',
  'warehouse.payments.statusPaid': 'Paid',
  'warehouse.payments.statusOpen': 'Open',
  'warehouse.payments.statusPending': 'Pending',

  // ── Warehouse: AP Aging Buckets ─────────────────────────────────────────
  'warehouse.aging.current': 'Current (0–30 days)',
  'warehouse.aging.d30': '31–60 days',
  'warehouse.aging.d60': '61–90 days',
  'warehouse.aging.d90plus': 'Over 90 days',

  // ── Warehouse: Rates & Reference Cases ──────────────────────────────────
  'warehouse.rates.title': 'Rates & Reference Cases',
  'warehouse.rates.tabRates': 'Rates',
  'warehouse.rates.tabCases': 'Reference Cases',
  'warehouse.rates.billingRates': 'Billing Rates',
  'warehouse.rates.referenceCases': 'Reference Cases',
  'warehouse.rates.code': 'Code',
  'warehouse.rates.labelDe': 'Label (DE)',
  'warehouse.rates.labelEn': 'Label (EN)',
  'warehouse.rates.rate': 'Rate',
  'warehouse.rates.floater': 'Floater',
  'warehouse.rates.noCases': 'No reference cases loaded.',

  // ── Warehouse: KDP Registry ─────────────────────────────────────────────
  'warehouse.kdp.active': 'Active',
  'warehouse.kdp.pending': 'Pending',
  'warehouse.kdp.retired': 'Retired',
  'warehouse.kdp.directionOver': 'Overcharge',
  'warehouse.kdp.directionUnder': 'Undercharge',
  'warehouse.kdp.directionVaries': 'Varies',
  'warehouse.kdp.catalog': 'KDP Catalog',
  'warehouse.kdp.detail': 'Detail',
  'warehouse.kdp.name': 'Name',
  'warehouse.kdp.direction': 'Direction',
  'warehouse.kdp.phases': 'Phases',
  'warehouse.kdp.description': 'Description',
  'warehouse.kdp.impactPerUnit': 'Impact / Unit',
  'warehouse.kdp.selectPrompt': 'Select a KDP to view details.',
  'warehouse.kdp.crosstabTitle': 'Cross-Tab Analysis (read-only)',
  'warehouse.kdp.crosstabPending': 'The month × KDP cross-tab awaits the v_kdp_monthly_crosstab view from the service layer.',

  // ── Warehouse: Pre-Send Review Modal (W4) ───────────────────────────────
  'warehouse.preSend.title': 'Pre-Send Review — {{month}}',
  'warehouse.preSend.drawerAriaLabel': 'Pre-send review for {{month}}',
  'warehouse.preSend.aggregateTotals': 'Aggregate totals',
  'warehouse.preSend.invoiceTotal': 'Invoice total',
  'warehouse.preSend.accepted': 'Accepted',
  'warehouse.preSend.disputed': 'Disputed ({{count}})',
  'warehouse.preSend.netWePay': 'Net we pay',
  'warehouse.preSend.disputedLines': 'Disputed lines ({{count}})',
  'warehouse.preSend.extraLines': 'Extra lines ({{count}})',
  'warehouse.preSend.undercharges': 'Undercharges — internal only ({{count}})',
  'warehouse.preSend.classify': 'Classify',
  'warehouse.preSend.action.pursue': 'Pursue',
  'warehouse.preSend.action.accept': 'Accept',
  'warehouse.preSend.action.drop': 'Drop',
  'warehouse.preSend.gates': 'Send gates',
  'warehouse.preSend.pendingResolved': 'Pending lines resolved',
  'warehouse.preSend.extrasClassified': 'Extras classified',
  'warehouse.preSend.noEntityId': 'No entity wired for this month — transition blocked.',
  'warehouse.preSend.cancel': 'Cancel',
  'warehouse.preSend.approveAndSend': 'Approve and send',
  'warehouse.preSend.open': 'Pre-send review',
  'warehouse.preSend.col.operation': 'Operation',
  'warehouse.preSend.col.verdict': 'Verdict',
  'warehouse.preSend.col.diff': 'Diff',
  'warehouse.preSend.col.externalComment': 'External comment',
  'warehouse.preSend.col.billed': 'Billed',
  'warehouse.preSend.col.expected': 'Expected',
  'warehouse.preSend.col.action': 'Action',

  // ── Warehouse: Reconciliation Detail ────────────────────────────────────
  'warehouse.reconciliation.title': 'Monthly Reconciliation',
  'warehouse.reconciliation.orders': 'Orders',
  'warehouse.reconciliation.matched': 'Matched',
  'warehouse.reconciliation.overcharged': 'Overcharged',
  'warehouse.reconciliation.undercharged': 'Undercharged',
  'warehouse.reconciliation.overchargeTotal': 'OVRCHG',
  'warehouse.reconciliation.underchargeTotal': 'UNDCHG',
  'warehouse.reconciliation.netImpact': 'NET',
  'warehouse.reconciliation.verdict': 'Verdict',
  'warehouse.reconciliation.verdictFilter': 'Verdict',
  'warehouse.reconciliation.allVerdicts': 'All Verdicts',
  'warehouse.reconciliation.searchAria': 'Search by operation ID',
  'warehouse.reconciliation.expectedTotal': 'Expected Total',
  'warehouse.config.kdpRegistry': 'KDP Registry',
  'warehouse.config.rates': 'Rates & Reference Cases',
  'warehouse.reconciliation.wacklerTotal': 'Wackler Amount',
  'warehouse.reconciliation.diff': 'Difference',
  'warehouse.drawer.details': 'Details',
  'warehouse.drawer.timeline': 'Timeline',
  'warehouse.drawer.billing': 'Billing',
  'warehouse.drawer.metadata': 'Metadata',
  'warehouse.drawer.operationId': 'Operation ID',
  'warehouse.drawer.carrier': 'Carrier',
  'warehouse.drawer.period': 'Service Period',
  'warehouse.drawer.phase': 'Phase',
  'warehouse.drawer.reviewedBy': 'Reviewed By',
  'warehouse.drawer.internalNote': 'Internal Note',
  'warehouse.drawer.billingSummary': 'Billing Summary',
  'warehouse.drawer.communication': 'Communication',
  'warehouse.drawer.commentPlaceholder': 'Write a message...',
  'warehouse.drawer.send': 'Send',
  'warehouse.drawer.accept': 'Accept',
  'warehouse.drawer.dispute': 'Dispute',
  'warehouse.drawer.noEvents': 'No entries yet.',
  'warehouse.drawer.timelinePending': 'Loading communication timeline...',
  'warehouse.drawer.externalWarning': 'This comment will be visible to Wackler.',
  'warehouse.drawer.commsPending': 'Comms in preparation — available once the CNS comms bus is live.',
  'warehouse.buckets.wacklerMissing': 'Wackler not charged',
  'warehouse.buckets.wacklerMissingDesc': 'Operations in our system that Wackler did not bill.',
  'warehouse.buckets.match': 'Correctly billed',
  'warehouse.buckets.matchDesc': 'Operations where both sides agree on the amount.',
  'warehouse.buckets.overcharge': 'Overcharged',
  'warehouse.buckets.overchargeDesc': 'Operations where Wackler charged more than expected (against us).',
  'warehouse.buckets.oursMissing': 'Unknown on our side',
  'warehouse.buckets.oursMissingDesc': 'Operations Wackler billed that we cannot match to an expected amount.',
  'warehouse.buckets.undercharge': 'Undercharged',
  'warehouse.buckets.underchargeDesc': 'Operations where Wackler charged less than expected (in our favour).',
  'warehouse.buckets.other': 'Other',
  'warehouse.buckets.otherDesc': 'Operations with an inconclusive reconciliation status.',
  'warehouse.drawer.accepted': 'Accepted',
  'warehouse.drawer.disputed': 'Disputed',
  'warehouse.drawer.warehouseComponents': 'Warehouse Line Items',
  'warehouse.drawer.freightCharges': 'Freight Charges',
  'warehouse.drawer.noFreightData': 'No freight data for this order.',
  'warehouse.drawer.freightBase': 'Freight (base)',
  'warehouse.drawer.diesel': 'Diesel surcharge',
  'warehouse.drawer.hazmat': 'Hazmat surcharge',
  'warehouse.drawer.security': 'Security fee',
  'warehouse.drawer.palletSwap': 'Pallet swap fee',
  'warehouse.drawer.dpdParcel': 'DPD Parcel',
  'warehouse.drawer.delivery2': 'Delivery surcharge',
  'warehouse.drawer.freightTotal': 'Freight total',
  'warehouse.drawer.componentsSubtotal': 'Components',
  'warehouse.drawer.kdpAdjustment': 'KDP adjustment',
  'warehouse.drawer.unexplained': 'Unexplained',
  'warehouse.drawer.bottomUpTotal': 'Total',
  'warehouse.drawer.bottomUpDriftWarning': 'Bottom-up sum ≠ row diff (Δ {delta})',
  'nav.wacklerBilling': 'Billing',

  // ── Scan Order Review (WhatsApp pipeline) ───────────────────────────────

  // Wackler lens (View-as-Vendor toggle)
  'wacklerLens.off.label': 'View: CLANDA',
  'wacklerLens.on.label': 'View: Wackler',
  'wacklerLens.tooltip.off': 'Switch to Wackler view (external perspective)',
  'wacklerLens.tooltip.on': 'Back to CLANDA view (internal perspective)',

  // ── 24/7 Ops Panel (MO-CB-V15 v2 §3, SL ticket §2.G5, mock-backed) ──────
  'atc.bridge.ops247.title': '24/7 Ops Panel',
  'atc.bridge.ops247.subtitle': 'Observation surface for the MO-247 mechanical loop — polling every 5–15s.',
  'atc.bridge.ops247.section.activeLoop': 'Active Loop',
  'atc.bridge.ops247.section.dispatchLog': 'Dispatch Event Log',
  'atc.bridge.ops247.section.pendingDispatches': 'Pending Dispatches',
  'atc.bridge.ops247.section.idleRepos': 'Idle Repos',
  'atc.bridge.ops247.activeLoop.col.repo': 'Repo',
  'atc.bridge.ops247.activeLoop.col.mo': 'Pinned MO',
  'atc.bridge.ops247.activeLoop.col.lifecycle': 'Lifecycle',
  'atc.bridge.ops247.activeLoop.col.persona': 'Persona',
  'atc.bridge.ops247.activeLoop.col.callSign': 'Call-sign',
  'atc.bridge.ops247.activeLoop.col.mismatch': 'Mismatch',
  'atc.bridge.ops247.activeLoop.col.pinnedSince': 'Pinned since',
  'atc.bridge.ops247.activeLoop.col.lastSignal': 'Last signal',
  'atc.bridge.ops247.activeLoop.col.lastOutcome': 'Last outcome',
  'atc.bridge.ops247.eventLog.col.when': 'When',
  'atc.bridge.ops247.eventLog.col.type': 'Type',
  'atc.bridge.ops247.eventLog.col.repo': 'Repo',
  'atc.bridge.ops247.eventLog.col.persona': 'Persona',
  'atc.bridge.ops247.eventLog.col.outcome': 'Outcome',
  'atc.bridge.heartbeat.subtitle': 'Who is alive, idle, stuck, or offline — heartbeat + embodiment status.',
  'atc.bridge.heartbeat.status.alive': 'Alive',
  'atc.bridge.heartbeat.status.idle': 'Idle',
  'atc.bridge.heartbeat.status.stuck': 'Stuck',
  'atc.bridge.heartbeat.status.unknown': 'Unknown',
  'atc.bridge.heartbeat.status.offline': 'Offline',
  'atc.bridge.heartbeat.location.cloud': 'Cloud',
  'atc.bridge.heartbeat.location.local': 'Local',
  'atc.bridge.heartbeat.col.agent': 'Agent',
  'atc.bridge.heartbeat.col.status': 'Status',
  'atc.bridge.heartbeat.col.lastSeen': 'Last seen',
  'atc.bridge.heartbeat.col.location': 'Location',
  'atc.bridge.heartbeat.col.repo': 'Repo',
  'atc.bridge.heartbeat.col.embodiments': 'Embodiments',
  'atc.bridge.heartbeat.errorTitle': 'Heartbeat failed to load',
  'atc.bridge.heartbeat.emptyTitle': 'No agents',
  'atc.bridge.heartbeat.emptyDesc': 'No agent heartbeats right now.',
  'atc.bridge.ops247.eventLog.col.dispatchId': 'Dispatch ID',
  'atc.bridge.ops247.eventLog.filterAll': 'All',
  'atc.bridge.ops247.age.justNow': 'just now',
  'atc.bridge.ops247.age.minutes': '{count} min ago',
  'atc.bridge.ops247.age.hours': '{count} h ago',
  'atc.bridge.ops247.age.days': '{count} d ago',
  'atc.bridge.ops247.empty.activeLoop': 'No active loop entries.',
  'atc.bridge.ops247.empty.dispatchLog': 'No dispatch events for this filter.',
  'atc.bridge.ops247.empty.pendingDispatches': 'No pending dispatches.',
  'atc.bridge.ops247.empty.idleRepos': 'No idle repos.',

  // Migration Approval Queue (SL PR #1335 / FR aadda454 §2.G3, Wave 6b)
  'atc.bridge.migrations.title': 'Migration Approval Queue',
  'atc.bridge.migrations.subtitle': 'Pending database migrations awaiting Commander approval.',
  'atc.bridge.migrations.section.queue': 'Pending migrations',
  'atc.bridge.migrations.empty': 'No migrations in the queue.',
  'atc.bridge.migrations.col.file': 'File',
  'atc.bridge.migrations.col.status': 'Status',
  'atc.bridge.migrations.col.requestedBy': 'Requested by',
  'atc.bridge.migrations.col.requestedAt': 'Requested at',
  'atc.bridge.migrations.col.actions': 'Actions',
  'atc.bridge.migrations.status.pending': 'Pending',
  'atc.bridge.migrations.status.approved': 'Approved',
  'atc.bridge.migrations.status.applied': 'Applied',
  'atc.bridge.migrations.status.rejected': 'Rejected',
  'atc.bridge.migrations.action.approve': 'Approve',
  'atc.bridge.migrations.action.reject': 'Reject',
  'atc.bridge.migrations.reject.defaultReason': 'Rejected by Commander.',
  'atc.bridge.migrations.error.MIGRATION_NOT_FOUND': 'Migration not found.',
  'atc.bridge.migrations.error.MIGRATION_ALREADY_APPROVED': 'Migration is already past the pending state.',
  'atc.bridge.migrations.error.MIGRATION_REJECTED': 'Migration is already rejected.',
  'atc.bridge.migrations.error.MIGRATION_DRY_RUN_FAILED': 'Dry-run failed — SL surfaced a SQL error.',
  'atc.bridge.migrations.error.MIGRATION_APPLY_FAILED': 'Apply failed after a passing dry-run.',
  'atc.bridge.migrations.error.WORKRIGHT_REQUIRED': 'Migration-approval workright required.',
  'atc.bridge.migrations.error.FORBIDDEN': 'Forbidden — identity denied.',
  'atc.bridge.migrations.error.INTERNAL': 'Internal error — see SL logs.',

  // Agent Work Bundle view (FR-SL-COMMANDER-BRIDGE-FULL-SURFACE-V1 §2.G4)
  // Mounted at /atc/bridge/work-bundle. Wave 6c.
  'atc.bridge.workBundle.title': 'Agent Work Bundle',
  'atc.bridge.workBundle.subtitle': 'Per-call-sign work table joining personas, embodiments, manifest entries, and PRs.',
  'atc.bridge.workBundle.loading': 'Loading work bundle...',
  'atc.bridge.workBundle.error': 'Failed to load work bundle.',
  'atc.bridge.workBundle.empty': 'No work bundle rows.',
  'atc.bridge.workBundle.col.callSign': 'Call-sign',
  'atc.bridge.workBundle.col.persona': 'Persona',
  'atc.bridge.workBundle.col.embodiment': 'Embodiment',
  'atc.bridge.workBundle.col.manifest': 'Manifest',
  'atc.bridge.workBundle.col.pr': 'PR',
  'atc.bridge.workBundle.embodiment.none': 'No active embodiment',
  'atc.bridge.workBundle.embodiment.started': 'Started',
  'atc.bridge.workBundle.embodiment.ended': 'Ended',
  'atc.bridge.workBundle.embodiment.machine': 'Machine',
  'atc.bridge.workBundle.manifest.closeoutProfile': 'Closeout',
  'atc.bridge.workBundle.pr.none': 'No PR',
  'atc.bridge.workBundle.pr.mergedAt': 'Merged',
  'atc.bridge.workBundle.pr.state.open': 'Open',
  'atc.bridge.workBundle.pr.state.merged': 'Merged',
  'atc.bridge.workBundle.pr.state.closed': 'Closed',

  // Commander PAT mutations (FR-SL-COMMANDER-BRIDGE-FULL-SURFACE-V1 §2.G6)
  // ManifestRowActions consumes these keys + every error_code. Wave 6c.
  'atc.bridge.pat.action.forceClose': 'Force close',
  'atc.bridge.pat.action.hold': 'Hold',
  'atc.bridge.pat.action.reDispatch': 'Re-dispatch',
  'atc.bridge.pat.action.spawn': 'Spawn session',
  'atc.bridge.pat.action.cancel': 'Cancel',
  'atc.bridge.pat.confirm.forceCloseTitle': 'Force close manifest entry?',
  'atc.bridge.pat.confirm.forceCloseBody': 'This sets the lifecycle node to closed and may bypass gating. Continue?',
  'atc.bridge.pat.confirm.holdTitle': 'Hold manifest entry?',
  'atc.bridge.pat.confirm.holdBody': 'Provide a hold reason. The agent will be paused until released.',
  'atc.bridge.pat.confirm.reDispatchTitle': 'Re-dispatch manifest entry?',
  'atc.bridge.pat.confirm.reDispatchBody': 'The dispatcher will be re-run against this manifest entry.',
  'atc.bridge.pat.confirm.spawnTitle': 'Spawn a new session?',
  'atc.bridge.pat.confirm.spawnBody': 'The persona will be embodied against this manifest entry.',
  'atc.bridge.pat.hold.reasonLabel': 'Hold reason',
  'atc.bridge.pat.spawn.existingEmbodiment': 'Existing embodiment',
  // Manifest-lifecycle PATCH error codes (force-close + hold).
  'atc.bridge.pat.error.MANIFEST_NOT_FOUND': 'Manifest entry not found.',
  'atc.bridge.pat.error.INVALID_LIFECYCLE_TRANSITION': 'Invalid lifecycle transition for this entry.',
  'atc.bridge.pat.error.LIFECYCLE_BLOCKED_BY_GATE': 'Lifecycle change blocked by an open gate.',
  'atc.bridge.pat.error.FORBIDDEN': 'You are not allowed to perform this action.',
  'atc.bridge.pat.error.VERIFY_AFTER_WRITE_MISMATCH': 'Verify-after-write mismatch — the change did not apply cleanly.',
  // Re-dispatch error codes.
  'atc.bridge.pat.error.NO_LIVE_TARGET': 'No live target persona to receive the dispatch.',
  'atc.bridge.pat.error.RE_DISPATCH_RATE_LIMITED': 'Re-dispatch rate-limited; retry later.',
  // Spawn error codes (AP-4a0ba405 — EMBODIMENT_ALREADY_ACTIVE NEVER silently retried).
  'atc.bridge.pat.error.PERSONA_NOT_FOUND': 'Persona not found.',
  'atc.bridge.pat.error.SPAWN_FAILED': 'Spawn failed.',
  'atc.bridge.pat.error.WORKRIGHT_REQUIRED': 'Workright required for this persona+manifest pair.',
  'atc.bridge.pat.error.EMBODIMENT_ALREADY_ACTIVE': 'A live embodiment already exists for this persona — close it first.',
  'atc.bridge.pat.error.INTERNAL': 'Internal error.',

  // ── Comms Hub + INBOX-SEND IACP (SL PR #1335 / Wave 6e1) ────────────────
  'atc.bridge.comms.title': 'Comms Hub',
  'atc.bridge.comms.subtitle': 'INBOX-SEND IACP 4-mode signal writer alongside the legacy agent-inbox composer.',
  'atc.bridge.comms.section.iacp': 'IACP 4-mode (new)',
  'atc.bridge.comms.section.iacp.subtitle': 'Compose signals via the INBOX-SEND IACP surface — stream, reply, decision, escalation.',
  'atc.bridge.comms.section.legacy': 'Agent inbox (legacy)',
  'atc.bridge.comms.section.legacy.subtitle': 'Existing 1:1 chat composer. Kept during the cutover window.',
  'atc.bridge.iacp.send.title': 'New IACP signal',
  'atc.bridge.iacp.send.field.kind': 'Kind',
  'atc.bridge.iacp.send.field.targetMode': 'Target by',
  'atc.bridge.iacp.send.field.target_persona': 'Target persona',
  'atc.bridge.iacp.send.field.target_embodiment_id': 'Target embodiment ID',
  'atc.bridge.iacp.send.field.in_reply_to': 'Reply to signal ID',
  'atc.bridge.iacp.send.field.dedup_key': 'Dedup key',
  'atc.bridge.iacp.send.field.body_text': 'Message',
  'atc.bridge.iacp.send.field.requires_ack': 'Requires operator ack',
  'atc.bridge.iacp.send.kind.stream': 'Stream',
  'atc.bridge.iacp.send.kind.reply': 'Reply',
  'atc.bridge.iacp.send.kind.decision': 'Decision',
  'atc.bridge.iacp.send.kind.escalation': 'Escalation',
  'atc.bridge.iacp.send.targetMode.persona': 'Persona shorthandle',
  'atc.bridge.iacp.send.targetMode.embodiment': 'Embodiment UUID',
  'atc.bridge.iacp.send.placeholder.target_persona': 'e.g. fe-lcl2',
  'atc.bridge.iacp.send.placeholder.target_embodiment_id': 'UUID',
  'atc.bridge.iacp.send.placeholder.in_reply_to': 'parent signal UUID',
  'atc.bridge.iacp.send.placeholder.dedup_key': 'unique idempotency key (required for escalation)',
  'atc.bridge.iacp.send.placeholder.body_text': 'Markdown or plain text…',
  'atc.bridge.iacp.send.submit': 'Send signal',
  'atc.bridge.iacp.send.submit.pending': 'Sending…',
  'atc.bridge.iacp.send.error.REPLY_REQUIRES_IN_REPLY_TO': 'Reply mode requires a parent signal ID.',
  'atc.bridge.iacp.send.error.INVALID_IN_REPLY_TO': 'Parent signal not found or invalid.',
  'atc.bridge.iacp.send.error.TARGET_NOT_FOUND': 'Target persona or embodiment not found.',
  'atc.bridge.iacp.send.error.MISSING_TARGET': 'Pick a target persona or embodiment.',
  'atc.bridge.iacp.send.error.INVALID_SEVERITY': 'Invalid severity value.',
  'atc.bridge.iacp.send.error.INVALID_KIND': 'Invalid signal kind.',
  'atc.bridge.iacp.send.error.INBOX_SEND_FAILED': 'Send failed — the server could not write the signal.',
  'atc.bridge.iacp.send.error.DEDUP_KEY_REQUIRES_ESCALATION': 'Dedup keys are only valid when kind is escalation.',
  'atc.bridge.iacp.send.error.FORBIDDEN': 'You are not authorized to send this signal.',
  'atc.bridge.iacp.send.error.ATC_UNAVAILABLE': 'ATC is temporarily unavailable — try again shortly.',
  'atc.bridge.iacp.send.error.WA_DISPATCH_FAILED': 'WhatsApp dispatch failed — operator was not notified.',
  'atc.bridge.iacp.send.error.VERIFY_AFTER_WRITE_MISMATCH': 'Verify-after-write mismatch — the signal may not have persisted.',
  'atc.bridge.iacp.send.error.INBOX_SEND_UNEXPECTED_ERROR': 'Unexpected server error — please retry.',
  'atc.bridge.iacp.ack.title': 'Acknowledge signal',
  'atc.bridge.iacp.ack.field.ack_note': 'Ack note (optional)',
  'atc.bridge.iacp.ack.submit': 'Acknowledge',
  'atc.bridge.iacp.ack.error.INBOX_ACK_FAILED': 'Acknowledge failed — write error.',
  'atc.bridge.iacp.ack.error.FORBIDDEN': 'You are not authorized to acknowledge this signal.',
  'atc.bridge.iacp.ack.error.SIGNAL_NOT_FOUND': 'Signal not found.',
  'atc.bridge.iacp.ack.error.ACK_NOT_REQUIRED': 'This signal does not require an ack.',
  'atc.bridge.iacp.ack.error.ALREADY_ACKED': 'This signal has already been acknowledged.',
  'atc.bridge.iacp.ack.error.INBOX_ACK_UNEXPECTED_ERROR': 'Unexpected server error — please retry.',

  // Health — owner × lifecycle-node flow heatmap, fed from manifest-tree.
  'atc.bridge.health.title': 'Health',
  'atc.bridge.health.subtitle': 'Flow heatmap: open manifest entries per owner and lifecycle node — live from the manifest-tree view.',
  'atc.bridge.health.error': 'Failed to load health data.',
  'atc.bridge.health.empty.title': 'No manifest entries',
  'atc.bridge.health.empty.desc': 'The manifest-tree view currently returns no rows for the heatmap.',
  'atc.bridge.health.heatmap.title': 'Flow heatmap (owner × node)',
  'atc.bridge.health.heatmap.owner': 'Owner',
  'atc.bridge.health.heatmap.open': 'open',
  'atc.bridge.health.heatmap.total': 'total',
  'atc.bridge.health.heatmap.ownersSum': 'Σ {count} owners',
  'atc.bridge.health.filters.title': 'Filters',
  'atc.bridge.health.filters.lane': 'Lane (owner)',
  'atc.bridge.health.filters.allLanes': 'All lanes',
  'atc.bridge.health.filters.state': 'Triage state',
  'atc.bridge.health.filters.allStates': 'All states',
  'atc.bridge.health.triage.title': 'Triage list',
  'atc.bridge.health.triage.error': 'Failed to load the triage list.',
  'atc.bridge.health.triage.empty.title': 'No triage entries',
  'atc.bridge.health.triage.empty.desc': 'The manifest-triage view returns no rows for the current filter selection.',
  'atc.bridge.health.triage.col.title': 'Entry',
  'atc.bridge.health.triage.open': 'Open work item',
  'atc.bridge.health.triage.col.entityType': 'Type',
  'atc.bridge.health.triage.col.owner': 'Owner',
  'atc.bridge.health.triage.col.node': 'Node',
  'atc.bridge.health.triage.col.priority': 'Prio',
  'atc.bridge.health.triage.col.state': 'State',
  'atc.bridge.health.triage.col.blocked': 'Blocked',
  'atc.bridge.health.triage.blocked.yes': 'Yes',
  'atc.bridge.health.triage.blocked.no': '—',
  'atc.bridge.health.scoreboard.title': 'Scoreboard',
  'atc.bridge.health.scoreboard.error': 'Failed to load the scoreboard.',
  'atc.bridge.health.scoreboard.empty.title': 'No scoreboard',
  'atc.bridge.health.scoreboard.empty.desc': 'The manifest-health view returns no scoreboard rows for the current lane selection.',
  'atc.bridge.health.scoreboard.col.lane': 'Lane (owner)',
  'atc.bridge.health.scoreboard.col.node': 'Node',
  'atc.bridge.health.scoreboard.col.count': 'Count',
  'atc.bridge.health.scoreboard.totalLabel': 'Σ {count} rows',
  // Persona identity-stack viewer — W6e2 (2026-05-23). Route /atc/bridge/personas.
  'atc.bridge.personas.title': 'Personas',
  'atc.bridge.personas.subtitle': 'Identity stack, active workrights and live embodiments per agent persona.',
  'atc.bridge.personas.search.placeholder': 'Search by agent_id or shorthandle…',
  'atc.bridge.personas.empty': 'No personas match.',
  'atc.bridge.personas.block.identity': 'Identity stack',
  'atc.bridge.personas.block.workrights': 'Active workrights',
  'atc.bridge.personas.block.embodiments': 'Active embodiments',
  'atc.bridge.personas.stack.blockA': 'Block A — Universal',
  'atc.bridge.personas.stack.blockB': 'Block B — Per-persona',
  'atc.bridge.personas.stack.emptyUniversal': 'No universal docs.',
  'atc.bridge.personas.stack.emptyPerPersona': 'No per-persona docs.',
  'atc.bridge.personas.category.universal': 'universal',
  'atc.bridge.personas.category.perPersona': 'per-persona',
  'atc.bridge.personas.status.active': 'active',
  'atc.bridge.personas.status.draft': 'draft',
  'atc.bridge.personas.status.superseded': 'superseded',
  'atc.bridge.personas.status.missing': 'missing',
  'atc.bridge.personas.inject': 'inject',
  'atc.bridge.personas.header.live': '{count} live',
  'atc.bridge.personas.header.noEmbodiment': 'no active embodiments',
  'atc.bridge.personas.header.noShorthandle': 'no shorthandle',
  'atc.bridge.personas.header.summary': '{docs} doc(s) · {workrights} workright(s) · {embodiments} live',
  'atc.bridge.personas.workrights.empty': 'No active workrights.',
  'atc.bridge.personas.workrights.tone.bounded': 'bounded',
  'atc.bridge.personas.workrights.tone.permanentAutoRenew': 'permanent · auto-renew',
  'atc.bridge.personas.workrights.tone.forbidden': 'FORBIDDEN',
  'atc.bridge.personas.workrights.tone.expired': 'expired',
  'atc.bridge.personas.workrights.autoRenew': 'auto-renew',
  'atc.bridge.personas.workrights.more': '+{count} more',
  'atc.bridge.personas.workrights.expires': 'expires',
  'atc.bridge.personas.embodiments.empty': 'No active embodiments.',
  'atc.bridge.personas.embodiments.started': 'started',
  'atc.bridge.personas.lastSignal': 'last signal',
  'atc.bridge.personas.age.justNow': 'just now',
  'atc.bridge.personas.age.minutes': '{count} min ago',
  'atc.bridge.personas.age.hours': '{count} h ago',
  'atc.bridge.personas.age.days': '{count} d ago',
  'atc.bridge.embodiments.title': 'Embodiments',
  'atc.bridge.embodiments.subtitle': 'Live and retired embodiments from agent_embodiments_unified (canonical view).',
  'atc.bridge.embodiments.section.list': 'Embodiments',
  'atc.bridge.embodiments.filter.active': 'active only',
  'atc.bridge.embodiments.filter.all': 'all',
  'atc.bridge.embodiments.filter.host.label': 'Host',
  'atc.bridge.embodiments.filter.host.allHosts': 'all hosts',
  'atc.bridge.embodiments.col.agentId': 'Agent ID',
  'atc.bridge.embodiments.col.shorthandle': 'Shorthandle',
  'atc.bridge.embodiments.col.machine': 'Machine',
  'atc.bridge.embodiments.col.vendor': 'Vendor',
  'atc.bridge.embodiments.col.status': 'Status',
  'atc.bridge.embodiments.col.startedAt': 'Started at',
  'atc.bridge.embodiments.col.retiredAt': 'Retired at',
  'atc.bridge.embodiments.col.sessionLocation': 'Session / location',
  'atc.bridge.embodiments.col.source': 'Source',
  'atc.bridge.embodiments.activeBadge': 'active',
  'atc.bridge.embodiments.empty': 'No embodiments match the current filter.',
  'atc.bridge.embodiments.loading': 'Loading embodiments …',
  'atc.bridge.embodiments.error': 'Failed to load embodiments.',
  'atc.bridge.embodiments.diagnostics.summary': '{active} active / {total} total / {hosts} hosts',
  'atc.bridge.embodiments.slGapNote': 'Note: session turn, CTX %, work_item, workright and phantom-session columns are not served by the agent_embodiments_unified view yet (needs an SL join slug).',
  // Rich parity surface (view embodiments-tracking) — session + workright +
  // CTX % + phantom detection, full parity with the god-mode tab.
  'atc.bridge.embodiments.tracking.title': 'Live embodiments (tracking)',
  'atc.bridge.embodiments.tracking.subtitle': 'LIVE sessions only (retired_at IS NULL): identity (agent_id + embodiment UUID), machine, CTX %, last turn, node, work item and workright per embodiment from the embodiments-tracking view.',
  'atc.bridge.embodiments.tracking.liveCount': '{count} live session(s)',
  'atc.bridge.embodiments.tracking.phantomFlag': 'Phantom ({count})',
  'atc.bridge.embodiments.tracking.lastTurn': 'last turn: {when}',
  'atc.bridge.embodiments.col.agent': 'Agent',
  'atc.bridge.embodiments.col.embodiment': 'Embodiment',
  'atc.bridge.embodiments.col.session': 'Session',
  'atc.bridge.embodiments.col.ctx': 'CTX %',
  'atc.bridge.embodiments.col.lastTurnAge': 'Last turn',
  'atc.bridge.embodiments.col.workItem': 'Work item',
  'atc.bridge.embodiments.col.workright': 'Workright',
  'atc.bridge.embodiments.col.lcout': 'LCOUT / LCIN',
  'atc.bridge.embodiments.col.boot': 'Boot',
  'atc.bridge.embodiments.col.phantom': 'Phantom',
  // SL-dep note: columns the operator's admin surface shows but the typed
  // embodiments-tracking contract does NOT serve yet (role, ORIENT brick-B
  // gate held/cleared, session≡embodiment link). Surfaced loud, never faked.
  'atc.bridge.embodiments.slDepColumns': 'Not yet in the typed contract (SL-dep): role, ORIENT brick-B gate (held/cleared), session≡embodiment link. Omitted rather than faked.',
}
